var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs, Fragment as Fragment$1 } from "react/jsx-runtime";
import { useState, useCallback, useEffect, useMemo, Fragment, useRef, createContext, useContext, useId, cloneElement, createElement } from "react";
import classNames from "classnames";
import { cloneDeep, kebabCase, get, keys, chunk, isArray, castArray, first, range, toLower, snakeCase, set, trim, trimEnd, trimStart } from "lodash";
import { useFloating, offset as offset$1, flip, shift, arrow, autoUpdate, useClick, useHover, safePolygon, useDismiss, useRole, useInteractions, FloatingPortal, FloatingArrow, useListItem, size, useListNavigation, useTypeahead, FloatingList } from "@floating-ui/react";
import { defer, from } from "rxjs";
import DatePicker from "react-datepicker";
import { isValid, format, getYear, getMonth, getDay, startOfDay } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import addMinutes from "date-fns/addMinutes";
import "react-datepicker/dist/react-datepicker.css";
import { Chart } from "react-google-charts";
import { renderToString } from "react-dom/server";
import { createPortal } from "react-dom";
import { ToastContainer as ToastContainer$1, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSwipeable } from "react-swipeable";
import { NumericFormat } from "react-number-format";
import { getTrackBackground, Range } from "react-range";
import { v4 } from "uuid";
import axios from "axios";
import { enUS, es, uk } from "date-fns/locale";
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["Mobile"] = "mobile";
  MediaType2["Tablet"] = "tablet";
  MediaType2["Desktop"] = "desktop";
  return MediaType2;
})(MediaType || {});
class MediaSize {
}
__publicField(MediaSize, "Mobile", [-Infinity, 767]);
__publicField(MediaSize, "Tablet", [768, 1153]);
__publicField(MediaSize, "Desktop", [1154, Infinity]);
function detectDevice() {
  const [mobileMin, mobileMax] = MediaSize.Mobile;
  const [tabletMin, tabletMax] = MediaSize.Tablet;
  if (window.innerWidth >= mobileMin && window.innerWidth <= mobileMax) {
    return MediaType.Mobile;
  }
  if (window.innerWidth >= tabletMin && window.innerWidth <= tabletMax) {
    return MediaType.Tablet;
  }
  return MediaType.Desktop;
}
const useDeviceDetection = () => {
  const [dimension, setDimension] = useState(detectDevice());
  const detect = useCallback(() => setDimension(detectDevice()), []);
  useEffect(() => {
    window.removeEventListener("resize", detect);
    window.addEventListener("resize", detect);
    return () => window.removeEventListener("resize", detect);
  }, [detect]);
  return dimension;
};
function isDeviceMap(value) {
  return value != null && Object.prototype.hasOwnProperty.call(value, "desktop");
}
class DeviceValues {
  constructor(map) {
    __publicField(this, "desktop");
    __publicField(this, "tablet");
    __publicField(this, "mobile");
    if (isDeviceMap(map)) {
      this.desktop = map.desktop;
      this.tablet = map.tablet === void 0 ? this.desktop : map.tablet;
      this.mobile = map.mobile === void 0 ? this.tablet : map.mobile;
    } else {
      this.desktop = map;
      this.tablet = map;
      this.mobile = map;
    }
  }
  select(media) {
    return this[media];
  }
}
function pick(predicate, obj) {
  if (obj == null || typeof obj !== "object") {
    return {};
  }
  const filtered = {};
  Object.keys(obj).forEach((k) => {
    const v = obj[k];
    if (predicate(k, v)) {
      filtered[k] = v;
    }
  });
  return filtered;
}
const pickDataAttributes = pick.bind(null, (k) => String(k).startsWith("data-"));
const omitDataAttributes = pick.bind(null, (k) => !String(k).startsWith("data-"));
const icon$2 = "GAFE-icons-icon";
const styles$O = {
  icon: icon$2
};
function useIcon({
  className,
  colorSchema,
  width = "md",
  height = "md",
  role = "img",
  onClick,
  ...props
}) {
  const device = useDeviceDetection();
  const $width = useMemo(() => new DeviceValues(width).select(device), [device, width]);
  const $height = useMemo(() => new DeviceValues(height).select(device), [device, height]);
  return {
    className: classNames(styles$O.icon, className),
    fill: "currentcolor",
    onClick,
    role,
    ...pickDataAttributes(props),
    "data-active": Boolean(onClick),
    "data-width": $width,
    "data-height": $height,
    "data-color-schema": colorSchema
  };
}
function IconChevronLeft(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-chevron-left",
      ...icon2,
      viewBox: "0 0 10 18",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M2.79452 9L10 1.46179L8.60274 0L0 9L8.60274 18L10 16.5382L2.79452 9Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconChevronLeft.displayName = "ChevronLeft";
function IconChevronRight(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-chevron-right",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.2055 12L7 4.46179L8.39726 3L17 12L8.39726 21L7 19.5382L14.2055 12Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconChevronRight.displayName = "ChevronRight";
function firstBy(predicate, fallback, ...values) {
  for (const value of values) {
    if (value != null && predicate(value)) {
      return value;
    }
  }
  return fallback;
}
function firstTruthy(fallback, ...rest) {
  return firstBy((v) => Boolean(v), fallback, ...rest);
}
function firstDefined(fallback, ...rest) {
  return firstBy((v) => v != null, fallback, ...rest);
}
function isRectangle(value) {
  return value != null && (Object.prototype.hasOwnProperty.call(value, "bottom") || Object.prototype.hasOwnProperty.call(value, "left") || Object.prototype.hasOwnProperty.call(value, "top") || Object.prototype.hasOwnProperty.call(value, "right"));
}
function isPoint(value) {
  return value != null && (Object.prototype.hasOwnProperty.call(value, "x") || Object.prototype.hasOwnProperty.call(value, "y"));
}
class RectangleBuilder {
  constructor(initial) {
    __publicField(this, "$rectangle");
    this.$rectangle = {
      bottom: initial,
      left: initial,
      right: initial,
      top: initial
    };
  }
  left(left) {
    this.$rectangle.left = left;
    return this;
  }
  right(right) {
    this.$rectangle.right = right;
    return this;
  }
  top(top) {
    this.$rectangle.top = top;
    return this;
  }
  bottom(bottom) {
    this.$rectangle.bottom = bottom;
    return this;
  }
  x(leftAndRight) {
    return this.left(leftAndRight).right(leftAndRight);
  }
  y(topAndBottom) {
    return this.top(topAndBottom).bottom(topAndBottom);
  }
  from(other) {
    if (isRectangle(other)) {
      this.$rectangle.bottom = firstDefined(this.$rectangle.bottom, other.bottom);
      this.$rectangle.left = firstDefined(this.$rectangle.left, other.left);
      this.$rectangle.right = firstDefined(this.$rectangle.right, other.right);
      this.$rectangle.top = firstDefined(this.$rectangle.top, other.top);
    } else if (isPoint(other)) {
      this.$rectangle.bottom = firstDefined(this.$rectangle.bottom, other.y);
      this.$rectangle.left = firstDefined(this.$rectangle.left, other.x);
      this.$rectangle.right = firstDefined(this.$rectangle.right, other.x);
      this.$rectangle.top = firstDefined(this.$rectangle.top, other.y);
    } else {
      this.$rectangle.bottom = firstDefined(this.$rectangle.bottom, other);
      this.$rectangle.left = firstDefined(this.$rectangle.left, other);
      this.$rectangle.right = firstDefined(this.$rectangle.right, other);
      this.$rectangle.top = firstDefined(this.$rectangle.top, other);
    }
    return this;
  }
  copy(other) {
    this.$rectangle = cloneDeep(other);
    return this;
  }
  build() {
    return cloneDeep(this.$rectangle);
  }
}
function useRectangle(fallback, device, value) {
  return useMemo(() => {
    const rectangleLike = new DeviceValues(firstDefined(fallback, value)).select(device);
    return new RectangleBuilder(fallback).from(rectangleLike).build();
  }, [value, fallback, device]);
}
const OrientationToFlexDirection = {
  horizontal: "row",
  "horizontal-reverse": "row-reverse",
  vertical: "column",
  "vertical-reverse": "column-reverse"
};
const Stack = (props) => {
  const {
    align,
    children,
    className,
    justify,
    orientation = "vertical",
    gap = "none",
    inline = false,
    display = inline ? "inline-flex" : "flex"
  } = props;
  const media = useDeviceDetection();
  const $orientation = useMemo(() => new DeviceValues(orientation), [orientation]);
  const $gap = useRectangle("none", media, gap);
  const style = useMemo(
    () => ({
      alignItems: align == null ? void 0 : align.items,
      alignContent: align == null ? void 0 : align.content,
      justifyItems: justify == null ? void 0 : justify.items,
      justifyContent: justify == null ? void 0 : justify.content,
      flexDirection: OrientationToFlexDirection[$orientation.select(media)],
      columnGap: `var(--gap-${$gap.left})`,
      rowGap: `var(--gap-${$gap.top})`,
      display
    }),
    [justify, align, $orientation, $gap, media, display]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(className),
      "data-testid": "gafe-stack",
      style,
      ...pickDataAttributes(props),
      children
    }
  );
};
const root$j = "GAFE-Typography-root";
const styles$N = {
  root: root$j
};
function Typography({
  TElement = "div",
  className,
  children,
  colorSchema,
  decoration,
  display,
  size: size2,
  transform,
  weight,
  width,
  wrap,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    TElement,
    {
      ...props,
      className: classNames(styles$N.root, className),
      "data-color-schema": colorSchema,
      "data-decoration-line": decoration == null ? void 0 : decoration.line,
      "data-decoration-style": decoration == null ? void 0 : decoration.style,
      "data-size": size2,
      "data-transform": transform,
      "data-weight": weight,
      "data-wrap": wrap,
      style: { display, width: width === "full" ? "100%" : void 0 },
      children
    }
  );
}
const Body = (props) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "p",
    "data-testid": "gafe-typography-body",
    ...props,
    "data-typography": "Body",
    size: "xs",
    weight: "regular"
  }
);
const TabLabel = Body;
const container$2 = "GAFE-Breadcrumbs-container";
const item$1 = "GAFE-Breadcrumbs-item";
const active$1 = "GAFE-Breadcrumbs-active";
const clickable = "GAFE-Breadcrumbs-clickable";
const styles$M = {
  container: container$2,
  item: item$1,
  active: active$1,
  clickable
};
const Breadcrumbs = ({ items, className }) => {
  const media = useDeviceDetection();
  const isMobile = media === MediaType.Mobile;
  const lastIndex = items.length - 1;
  return /* @__PURE__ */ jsx("div", { className: classNames(styles$M.container, className), "data-testid": "breadcrumbs-wrapper", children: /* @__PURE__ */ jsx(Stack, { align: { items: "center" }, gap: "2xs", orientation: "horizontal", children: items.map((item2, index) => {
    var _a, _b;
    if (isMobile && items.length > 1) {
      return index === lastIndex ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames({
              [styles$M.clickable]: Boolean((_a = items[lastIndex - 1]) == null ? void 0 : _a.handleOnClick)
            }),
            "data-testid": "breadcrumbs-arrow-reversed",
            onClick: (_b = items[lastIndex - 1]) == null ? void 0 : _b.handleOnClick,
            children: /* @__PURE__ */ jsx(IconChevronLeft, { colorSchema: "monochromatic-dark", height: "sm", width: "sm" })
          }
        ),
        /* @__PURE__ */ jsx(
          Body,
          {
            TElement: "span",
            className: classNames(styles$M.item, item2.className, {
              [styles$M.active]: item2.current
            }),
            "data-testid": `breadcrumbs-${kebabCase(item2.title)}`,
            children: item2.title
          }
        )
      ] }, item2.title) : null;
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      index ? /* @__PURE__ */ jsx("span", { "data-testid": "breadcrumbs-arrow", children: /* @__PURE__ */ jsx(IconChevronRight, { className: styles$M.arrow }) }) : null,
      /* @__PURE__ */ jsx(
        Body,
        {
          TElement: "span",
          className: classNames(styles$M.item, item2.className, {
            [styles$M.clickable]: item2.handleOnClick,
            [styles$M.active]: item2.current
          }),
          "data-testid": `breadcrumbs-${kebabCase(item2.title)}`,
          onClick: item2.handleOnClick,
          children: item2.title
        }
      )
    ] }, item2.title);
  }) }) });
};
function useDeviceValue(device, value, fallback) {
  const $value = useMemo(
    () => new DeviceValues(firstDefined(fallback, value)).select(device),
    [value, fallback, device]
  );
  return $value;
}
function Hidden({ children, on }) {
  const media = useDeviceDetection();
  const device = useMemo(() => new DeviceValues(on), [on]);
  const visible = useMemo(() => !device.select(media), [device, media]);
  return visible ? children : null;
}
const Subtitle2 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-subtitle-two",
    ...props,
    "data-typography": "Subtitle2",
    size: "xs",
    weight: "semibold"
  }
);
const root$i = "GAFE-Alert-root";
const prefix$4 = "GAFE-Alert-prefix";
const header$2 = "GAFE-Alert-header";
const body$1 = "GAFE-Alert-body";
const suffix$3 = "GAFE-Alert-suffix";
const footer$2 = "GAFE-Alert-footer";
const styles$L = {
  root: root$i,
  prefix: prefix$4,
  header: header$2,
  body: body$1,
  suffix: suffix$3,
  footer: footer$2
};
function Alert({
  className,
  children,
  colorSchema,
  footer: footer2,
  header: header2,
  prefix: prefix2,
  suffix: suffix2,
  variant = "outlined",
  width,
  ...props
}) {
  const device = useDeviceDetection();
  const $footer = useDeviceValue(device, footer2);
  const $header = useDeviceValue(device, header2);
  const $prefix = useDeviceValue(device, prefix2);
  const $suffix = useDeviceValue(device, suffix2);
  const $width = useDeviceValue(device, width);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-testid": "gafe-alert",
      ...pickDataAttributes(props),
      className: classNames(styles$L.root, className),
      "data-color-schema": colorSchema,
      "data-variant": variant,
      "data-width": $width,
      role: "alert",
      children: [
        /* @__PURE__ */ jsx("div", { className: styles$L.prefix, "data-color-iconography": true, "data-testid": "gafe-alert-prefix", children: $prefix }),
        /* @__PURE__ */ jsx(Subtitle2, { TElement: "header", className: styles$L.header, "data-testid": "gafe-alert-header", children: $header }),
        /* @__PURE__ */ jsx(Body, { TElement: "article", className: styles$L.body, "data-testid": "gafe-alert-body", children }),
        /* @__PURE__ */ jsx("div", { className: styles$L.suffix, "data-testid": "gafe-alert-suffix", children: $suffix }),
        /* @__PURE__ */ jsx(Hidden, { on: !$footer, children: /* @__PURE__ */ jsx("footer", { className: styles$L.footer, "data-testid": "gafe-alert-footer", children: $footer }) })
      ]
    }
  );
}
const backdrop$1 = "GAFE-Backdrop-backdrop";
const styles$K = {
  backdrop: backdrop$1
};
const Backdrop = ({ className, hide, transparent, onClick, ...props }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles$K.backdrop, className),
      "data-testid": "backdrop",
      onClick,
      ...pickDataAttributes(props),
      "data-hidden": hide,
      "data-transparent": transparent
    }
  );
};
function IconCancelOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-cancel-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m10.67,12l-4.67-4.67,1.33-1.33,4.67,4.67,4.67-4.67,1.33,1.33-4.67,4.67,4.67,4.67-1.33,1.33-4.67-4.67-4.67,4.67-1.33-1.33,4.67-4.67Z",
            fillRule: "evenodd"
          }
        )
      ] })
    }
  );
}
IconCancelOutlined.displayName = "CancelOutlined";
function isCorners(value) {
  return value != null && (Object.prototype.hasOwnProperty.call(value, "leftBottom") || Object.prototype.hasOwnProperty.call(value, "leftTop") || Object.prototype.hasOwnProperty.call(value, "rightBottom") || Object.prototype.hasOwnProperty.call(value, "rightTop"));
}
function isCornersHorizontal(value) {
  return value != null && (Object.prototype.hasOwnProperty.call(value, "left") || Object.prototype.hasOwnProperty.call(value, "right"));
}
function isCornersVertical(value) {
  return value != null && (Object.prototype.hasOwnProperty.call(value, "bottom") || Object.prototype.hasOwnProperty.call(value, "top"));
}
class CornersBuilder {
  constructor(fallback) {
    __publicField(this, "$corners");
    this.$corners = {
      leftBottom: fallback,
      leftTop: fallback,
      rightBottom: fallback,
      rightTop: fallback
    };
  }
  leftBottom(value) {
    this.$corners.leftBottom = value;
    return this;
  }
  leftTop(value) {
    this.$corners.leftTop = value;
    return this;
  }
  rightBottom(value) {
    this.$corners.rightBottom = value;
    return this;
  }
  rightTop(value) {
    this.$corners.rightTop = value;
    return this;
  }
  top(value) {
    return this.leftTop(value).rightTop(value);
  }
  bottom(value) {
    return this.leftBottom(value).rightBottom(value);
  }
  left(value) {
    return this.leftTop(value).leftBottom(value);
  }
  right(value) {
    return this.rightTop(value).rightBottom(value);
  }
  copy(other) {
    this.$corners = cloneDeep(other);
    return this;
  }
  from(other) {
    if (isCorners(other)) {
      this.$corners.leftBottom = firstDefined(this.$corners.leftBottom, other.leftBottom);
      this.$corners.leftTop = firstDefined(this.$corners.leftTop, other.leftTop);
      this.$corners.rightBottom = firstDefined(this.$corners.rightBottom, other.rightBottom);
      this.$corners.rightTop = firstDefined(this.$corners.rightTop, other.rightTop);
    } else if (isCornersHorizontal(other)) {
      this.$corners.leftBottom = firstDefined(this.$corners.leftBottom, other.left);
      this.$corners.leftTop = firstDefined(this.$corners.leftTop, other.left);
      this.$corners.rightBottom = firstDefined(this.$corners.rightBottom, other.right);
      this.$corners.rightTop = firstDefined(this.$corners.rightTop, other.right);
    } else if (isCornersVertical(other)) {
      this.$corners.leftBottom = firstDefined(this.$corners.leftBottom, other.bottom);
      this.$corners.leftTop = firstDefined(this.$corners.leftTop, other.top);
      this.$corners.rightBottom = firstDefined(this.$corners.rightBottom, other.bottom);
      this.$corners.rightTop = firstDefined(this.$corners.rightTop, other.top);
    } else {
      this.$corners.leftBottom = firstDefined(this.$corners.leftBottom, other);
      this.$corners.leftTop = firstDefined(this.$corners.leftTop, other);
      this.$corners.rightBottom = firstDefined(this.$corners.rightBottom, other);
      this.$corners.rightTop = firstDefined(this.$corners.rightTop, other);
    }
    return this;
  }
  build() {
    return cloneDeep(this.$corners);
  }
}
function useCorners(fallback, device, value) {
  return useMemo(() => {
    const cornerLike = new DeviceValues(firstDefined(fallback, value)).select(device);
    return new CornersBuilder(fallback).from(cornerLike).build();
  }, [value, fallback, device]);
}
class CssPropertiesBuilder {
  constructor() {
    __publicField(this, "$properties");
    this.$properties = {};
  }
  borderStyle(style) {
    const rectangle = new RectangleBuilder("solid").from(style).build();
    this.$properties.borderBottomStyle = rectangle.bottom;
    this.$properties.borderLeftStyle = rectangle.left;
    this.$properties.borderRightStyle = rectangle.right;
    this.$properties.borderTopStyle = rectangle.top;
    return this;
  }
  borderRadius(radius) {
    const corners = new CornersBuilder("none").from(radius).build();
    this.$properties.borderBottomLeftRadius = `var(--rounding-${corners.leftBottom})`;
    this.$properties.borderBottomRightRadius = `var(--rounding-${corners.rightBottom})`;
    this.$properties.borderTopLeftRadius = `var(--rounding-${corners.leftTop})`;
    this.$properties.borderTopRightRadius = `var(--rounding-${corners.rightTop})`;
    return this;
  }
  borderWidth(width) {
    const rectangle = new RectangleBuilder("none").from(width).build();
    this.$properties.borderBottomWidth = `var(--thickness-${rectangle.bottom})`;
    this.$properties.borderLeftWidth = `var(--thickness-${rectangle.left})`;
    this.$properties.borderRightWidth = `var(--thickness-${rectangle.right})`;
    this.$properties.borderTopWidth = `var(--thickness-${rectangle.top})`;
    return this;
  }
  margin(gap) {
    const rectangle = new RectangleBuilder("none").from(gap).build();
    this.$properties.marginBottom = `var(--gap-${rectangle.bottom})`;
    this.$properties.marginLeft = `var(--gap-${rectangle.left})`;
    this.$properties.marginRight = `var(--gap-${rectangle.right})`;
    this.$properties.marginTop = `var(--gap-${rectangle.top})`;
    return this;
  }
  padding(gap) {
    const rectangle = new RectangleBuilder("none").from(gap).build();
    this.$properties.paddingBottom = `var(--gap-${rectangle.bottom})`;
    this.$properties.paddingLeft = `var(--gap-${rectangle.left})`;
    this.$properties.paddingRight = `var(--gap-${rectangle.right})`;
    this.$properties.paddingTop = `var(--gap-${rectangle.top})`;
    return this;
  }
  cursor(cursor) {
    this.$properties.cursor = cursor;
    return this;
  }
  build() {
    return cloneDeep(this.$properties);
  }
}
const root$h = "GAFE-Box-root";
const styles$J = {
  root: root$h
};
function Box({
  border,
  children,
  className,
  colorSchema,
  cursor = "default",
  interactive,
  margin,
  padding,
  ...props
}) {
  const device = useDeviceDetection();
  const $padding = useRectangle("none", device, padding);
  const $margin = useRectangle("none", device, margin);
  const $borderStyle = useRectangle("solid", device, border == null ? void 0 : border.style);
  const $borderWidth = useRectangle("none", device, border == null ? void 0 : border.width);
  const $borderRadius = useCorners("none", device, border == null ? void 0 : border.radius);
  const tabIndex = interactive ? 0 : void 0;
  const style = useMemo(
    () => new CssPropertiesBuilder().borderRadius($borderRadius).borderStyle($borderStyle).borderWidth($borderWidth).cursor(cursor).margin($margin).padding($padding).build(),
    [$padding, $margin, $borderStyle, $borderWidth, $borderRadius, cursor]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": "gafe-box",
      ...pickDataAttributes(props),
      className: classNames(styles$J.root, className),
      "data-color-schema": colorSchema,
      "data-interactive": interactive,
      style,
      tabIndex,
      children
    }
  );
}
const Grow = ({
  children,
  className,
  factor = 1,
  display = "block",
  ...props
}) => {
  const style = {
    flexGrow: factor,
    display
  };
  return /* @__PURE__ */ jsx("div", { className: classNames(className), style, ...pickDataAttributes(props), children });
};
const Caption = (props) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "p",
    "data-testid": "gafe-typography-caption-one",
    ...props,
    "data-typography": "Caption",
    size: "2xs",
    weight: "regular"
  }
);
const Caption1 = Caption;
const Subtitle3 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-subtitle-three",
    ...props,
    "data-typography": "Subtitle3",
    size: "2xs",
    weight: "semibold"
  }
);
const root$g = "GAFE-Balloon-root";
const prefix$3 = "GAFE-Balloon-prefix";
const target = "GAFE-Balloon-target";
const pointer = "GAFE-Balloon-pointer";
const styles$I = {
  root: root$g,
  prefix: prefix$3,
  target,
  pointer
};
function Balloon({
  className,
  children,
  colorSchema = "monochromatic-light",
  delay = 200,
  disabled: disabled2,
  on = "hover",
  placement = "top",
  PopupProps = {},
  show: show2 = false,
  gap = "sm",
  ...props
}) {
  const {
    children: popupChildren,
    footer: footer2,
    header: header2,
    prefix: prefix2,
    variant,
    width,
    CloseProps = (handle) => /* @__PURE__ */ jsx(IconCancelOutlined, { "data-testid": "gafe-common-balloon-close", onClick: handle })
  } = PopupProps;
  const device = useDeviceDetection();
  const $footer = useDeviceValue(device, footer2);
  const $header = useDeviceValue(device, header2);
  const $prefix = useDeviceValue(device, prefix2);
  const $width = useDeviceValue(device, width, "auto");
  const offsetMap = {
    sm: 10,
    md: 20
  };
  const arrowRef = useRef(null);
  const [open2, setOpen] = useState(false);
  const handleClose = useMemo(() => setOpen.bind(null, false), [setOpen]);
  const close2 = useMemo(() => {
    if (CloseProps === false) {
      return null;
    }
    return CloseProps(handleClose);
  }, [handleClose, CloseProps]);
  const $open = (open2 || show2) && !disabled2;
  const { refs, floatingStyles, context } = useFloating({
    open: $open,
    onOpenChange: setOpen,
    placement,
    middleware: [
      offset$1(offsetMap[gap]),
      flip(),
      shift({ padding: 5 }),
      arrow({
        element: arrowRef,
        padding: 8
      })
    ],
    whileElementsMounted: autoUpdate
  });
  const interactions = [
    useClick(context, { enabled: on === "click" }),
    useHover(context, {
      enabled: on === "hover",
      handleClose: safePolygon(),
      delay: { open: delay }
    }),
    useDismiss(context),
    useRole(context, { role: "tooltip" })
  ];
  const { getReferenceProps, getFloatingProps } = useInteractions(interactions);
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx(
      "section",
      {
        className: styles$I.target,
        ref: refs.setReference,
        ...getReferenceProps(),
        "data-testid": "gafe-common-balloon-target",
        children
      }
    ),
    /* @__PURE__ */ jsx(FloatingPortal, { children: /* @__PURE__ */ jsx(Hidden, { on: !$open, children: /* @__PURE__ */ jsxs(
      "section",
      {
        ref: refs.setFloating,
        style: { ...floatingStyles, zIndex: 1050 },
        ...getFloatingProps(),
        children: [
          /* @__PURE__ */ jsx(
            FloatingArrow,
            {
              className: styles$I.pointer,
              context,
              "data-color-schema": colorSchema,
              ref: arrowRef,
              strokeWidth: 0.1
            }
          ),
          /* @__PURE__ */ jsx(
            Box,
            {
              "data-testid": "gafe-common-balloon",
              ...pickDataAttributes(props),
              border: { radius: "2xs", width: "md" },
              className: classNames(styles$I.root, className),
              colorSchema,
              "data-variant": variant,
              "data-width": $width,
              padding: "xs",
              children: /* @__PURE__ */ jsxs(Stack, { gap: "xs", children: [
                /* @__PURE__ */ jsx(Hidden, { on: !$prefix && !close2 && !$header, children: /* @__PURE__ */ jsxs(Stack, { align: { items: "center" }, gap: "2xs", orientation: "horizontal", children: [
                  /* @__PURE__ */ jsx(Hidden, { on: !$prefix, children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: styles$I.prefix,
                      "data-color-iconography": true,
                      "data-testid": "gafe-common-balloon-prefix",
                      style: { display: "inline-flex" },
                      children: $prefix
                    }
                  ) }),
                  /* @__PURE__ */ jsx(Grow, { children: /* @__PURE__ */ jsx(
                    Subtitle3,
                    {
                      TElement: "div",
                      className: styles$I.header,
                      "data-testid": "gafe-common-balloon-header",
                      children: $header
                    }
                  ) }),
                  /* @__PURE__ */ jsx(Hidden, { on: !close2, children: /* @__PURE__ */ jsx(
                    "div",
                    {
                      "data-testid": "gafe-common-balloon-suffix",
                      style: { display: "inline-flex" },
                      children: close2
                    }
                  ) })
                ] }) }),
                /* @__PURE__ */ jsx(Caption, { TElement: "div", "data-testid": "gafe-common-balloon-body", children: popupChildren }),
                /* @__PURE__ */ jsx(Hidden, { on: !$footer, children: /* @__PURE__ */ jsx("div", { "data-testid": "gafe-common-balloon-footer", children: $footer }) })
              ] })
            }
          )
        ]
      }
    ) }) })
  ] });
}
function IconGafeIso(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-iso",
      ...icon2,
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M38.8031 38.8031H1.19531V1.19531H38.8031V38.8031Z", fill: "white" }),
        /* @__PURE__ */ jsx("path", { d: "M40 40V0H0V40H40ZM38.8045 38.8033H1.19667V1.19556H38.8045V38.8033Z", fill: "#D71920" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.9958 18.4078L21.2091 14.4078L22.4402 18.4078H19.9958ZM35.5724 13.3356V10.8245H26.7036V21.4078L22.868 10.8267H19.5513L15.7158 21.4078V15.6989H10.6613V18.09H12.148C12.148 18.4722 11.4046 19.4356 10.1169 19.4356C9.32908 19.4356 7.75467 19.2556 7.75467 16.0278C7.75467 12.8 9.96468 12.83 9.96468 12.83C11.8413 12.83 12.0846 14.2945 12.0846 14.2945H15.4435C14.8691 11.1556 12.2958 10.4056 10.1769 10.3489C8.05798 10.2922 4.42578 11.6045 4.42578 16.0278C4.42578 20.4511 6.90801 22.1234 9.57134 22.1856C12.1447 22.2445 13.2646 20.5711 13.2646 20.5711V22.0656H18.8646L19.3035 20.6311H23.118L23.5558 22.0656H30.2758V18.09H34.4836V15.6989H30.2758V13.3378L35.5724 13.3356Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.39201 29.1774V28.0497H7.03646V27.3241H8.92312V26.1974H7.03646V25.473H9.39201V24.3452H5.45312V29.1774H9.39201Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.5213 24.3452H10.0391V29.1774H11.5557V27.6474V26.6385L13.2191 29.1774H14.7024V24.3452H13.1868V25.8819V26.8897L11.5213 24.3452Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.4947 29.1774V28.0497H17.1391V27.3241H19.0258V26.1974H17.1391V25.473H19.4936V24.3452H15.5547V29.1774H19.4947Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.7262 25.4733H22.464C22.8329 25.4733 23.1017 25.6345 23.1017 25.9767C23.1017 26.3189 22.8395 26.4333 22.3495 26.4333H21.7262V25.4733ZM22.2095 27.4934C22.9473 27.4934 23.0551 27.7011 23.0551 28.3322C23.0437 28.6164 23.0707 28.9008 23.1351 29.1778H24.7384C24.6179 28.8609 24.5613 28.5233 24.5717 28.1845C24.5717 27.2111 24.2628 27.0911 23.7528 26.9033C24.3162 26.7478 24.565 26.2789 24.565 25.7222C24.565 24.7822 24.0339 24.3467 22.4239 24.3467H20.1406V29.1778H21.724V27.4934H22.2095Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29.9257 26.519H27.7591V27.5668H28.4569C28.3758 27.9001 27.9669 28.1224 27.6446 28.1224C26.8458 28.1224 26.6313 27.4979 26.6313 26.8135C26.6313 25.9612 26.9269 25.3979 27.5502 25.3979C27.7357 25.3876 27.919 25.4432 28.0675 25.5548C28.2161 25.6664 28.3206 25.8269 28.3624 26.0079H29.8657C29.6713 24.8201 28.738 24.2168 27.5769 24.2168C26.0135 24.2168 25.0469 25.2768 25.0469 26.8201C25.0469 28.5046 26.1579 29.3035 27.3891 29.3035C28.1479 29.3035 28.5835 29.0212 28.8458 28.7123V29.189H29.9257V26.5224V26.519Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M33.1908 27.4185L34.9886 24.3452H33.2308L32.3986 25.983L31.5664 24.3452H29.8086L31.6064 27.4185V29.1774H33.1908V27.4185Z",
            fill: "#D71920"
          }
        )
      ]
    }
  );
}
IconGafeIso.displayName = "GafeIso";
const root$f = "GAFE-Banner-root";
const prefix$2 = "GAFE-Banner-prefix";
const suffix$2 = "GAFE-Banner-suffix";
const styles$H = {
  root: root$f,
  prefix: prefix$2,
  suffix: suffix$2
};
function Banner({
  className,
  children,
  colorSchema,
  prefix: prefix2 = /* @__PURE__ */ jsx(IconGafeIso, { height: "xl" }),
  suffix: suffix2,
  ...props
}) {
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      "data-testid": "gafe-banner",
      ...pickDataAttributes(props),
      align: { items: "center" },
      className: classNames(styles$H.root, className),
      "data-color-schema": colorSchema,
      gap: "3xl",
      orientation: "horizontal",
      children: [
        /* @__PURE__ */ jsx(Hidden, { on: prefix2 == null, children: /* @__PURE__ */ jsx(Body, { TElement: "div", className: styles$H.prefix, "data-testid": "gafe-banner-prefix", children: prefix2 }) }),
        /* @__PURE__ */ jsx(Grow, { "data-testid": "gafe-banner-body", children: /* @__PURE__ */ jsx(Body, { TElement: "div", children }) }),
        /* @__PURE__ */ jsx(Hidden, { on: suffix2 == null, children: /* @__PURE__ */ jsx(Body, { TElement: "div", className: styles$H.suffix, "data-testid": "gafe-banner-suffix", children: suffix2 }) })
      ]
    }
  );
}
const Caption2 = (props) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "p",
    "data-testid": "gafe-typography-caption-two",
    ...props,
    size: "3xs",
    weight: "regular"
  }
);
const root$e = "GAFE-Bubble-root";
const styles$G = {
  root: root$e
};
function Bubble({ children, ...props }) {
  return /* @__PURE__ */ jsx(
    Caption2,
    {
      TElement: "div",
      className: styles$G.root,
      "data-testid": "gafe-bubble",
      ...pickDataAttributes(props),
      children
    }
  );
}
function IconSpinner(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-spinner",
      ...icon2,
      viewBox: "0 0 120 120",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M17 60C17 68.5046 19.5219 76.8182 24.2468 83.8895C28.9717 90.9608 35.6874 96.4722 43.5446 99.7268C51.4018 102.981 60.0477 103.833 68.3889 102.174C76.7301 100.515 84.3919 96.4193 90.4056 90.4056C96.4192 84.3919 100.515 76.7301 102.174 68.3889C103.833 60.0477 102.981 51.4018 99.7268 43.5446C96.4723 35.6874 90.9608 28.9717 83.8895 24.2468C76.8182 19.5219 68.5046 17 60 17L60 23.45C67.2289 23.45 74.2955 25.5936 80.3061 29.6098C86.3167 33.626 91.0014 39.3343 93.7678 46.0129C96.5342 52.6916 97.258 60.0405 95.8477 67.1306C94.4374 74.2206 90.9564 80.7331 85.8448 85.8448C80.7331 90.9564 74.2206 94.4374 67.1305 95.8477C60.0405 97.258 52.6916 96.5342 46.0129 93.7678C39.3343 91.0014 33.6259 86.3167 29.6098 80.3061C25.5936 74.2955 23.45 67.2289 23.45 60L17 60Z",
            fill: "url(#paint0_linear_825_6600)"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            gradientUnits: "userSpaceOnUse",
            id: "paint0_linear_825_6600",
            x1: "63",
            x2: "-3",
            y1: "17",
            y2: "72.5",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "currentcolor" }),
              /* @__PURE__ */ jsx("stop", { offset: "0.428366", stopColor: "currentcolor", stopOpacity: "0.571634" }),
              /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "currentcolor", stopOpacity: "0" })
            ]
          }
        ) })
      ]
    }
  );
}
IconSpinner.displayName = "Spinner";
const spin = "GAFE-ProgressSpinner-spin";
const spinnerBorder = "GAFE-ProgressSpinner-spinner-border";
const styles$F = {
  spin,
  spinnerBorder
};
function ProgressSpinner({
  active: active2 = true,
  colorSchema = "primary-dark",
  width = "2xl",
  ...props
}) {
  const device = useDeviceDetection();
  const $size = useDeviceValue(device, width);
  if (!active2) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Stack,
    {
      "data-testid": "gafe-common-progress-spinner",
      ...pickDataAttributes(props),
      align: { items: "center" },
      justify: { content: "center" },
      orientation: "horizontal",
      children: /* @__PURE__ */ jsx(IconSpinner, { className: styles$F.spin, colorSchema, height: $size, width: $size })
    }
  );
}
function DualityIndicator({ engaged, disengaged, value }) {
  return /* @__PURE__ */ jsx("div", { "data-testid": "gafe-duality-indicator", style: { display: "inline-flex" }, children: value ? engaged : disengaged });
}
const ButtonTextMedium = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-button-text-medium",
    ...props,
    "data-typography": "ButtonTextMedium",
    size: "2xs",
    transform: "uppercase",
    weight: "semibold"
  }
);
const ButtonTextSmall = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-button-text-small",
    ...props,
    "data-typography": "ButtonTextSmall",
    size: "3xs",
    transform: "uppercase",
    weight: "semibold"
  }
);
class AnalyticsPayloadBuilder {
  /**
   * Initializes a new instance of this object.
   */
  constructor() {
    __publicField(this, "$payload");
    this.$payload = {
      data: {}
    };
  }
  /**
   * Sets the url information from an existing UrlInfo or Location object.
   *
   * @param url -
   *        The location or info object to update the payload url with.
   *
   * @returns
   *        This object.
   */
  url(url) {
    this.$payload.url = {
      href: url.href,
      host: url.host,
      pathname: url.pathname,
      port: url.port,
      protocol: url.protocol,
      search: url.search
    };
    return this;
  }
  /**
   * Sets the user identity information.
   *
   * @param identity -
   *        The identity to set.  If this is undefined
   *        then the identity is removed.
   *
   * @returns
   *        This object.
   */
  identity(identity) {
    if (identity == null) {
      delete this.$payload.identity;
    } else {
      this.$payload.identity = identity;
    }
    return this;
  }
  /**
   * Sets the contextual data for the event.
   *
   * @param data -
   *        The data to set.
   *
   * @returns
   *        This object.
   */
  data(data) {
    this.$payload.data = data;
    return this;
  }
  /**
   * Sets the contextual data for the event without
   * removing any existing properties.
   *
   * Note that this will replace properties that are already
   * set on the initial data object.
   *
   * @param data -
   *        The data to merge.
   *
   * @returns
   *        This object.
   */
  merge(data) {
    return this.data(Object.assign({}, this.$payload.data, data));
  }
  /**
   * Strips out the data prop attributes and merges those with the
   * existing data payload.
   *
   * @param data -
   *        The data to take the data-* props from.
   *
   * @returns
   *        This object.
   */
  dataProps(data) {
    return this.merge(pickDataAttributes(data));
  }
  /**
   * Adds a key value pair into the data.
   *
   * @param key -
   *        The key to add.
   * @param value -
   *        The value to associate with the key.
   *
   * @returns
   *        This object.
   */
  pair(key, value) {
    return this.merge({ [key]: value });
  }
  /**
   * Copies other into this object.
   *
   * @param other -
   *        The current payload to copy.
   *
   * @returns
   *        This object.
   */
  copy(other) {
    this.$payload = cloneDeep(other);
    return this;
  }
  /**
   * Builds the analytics payload.
   *
   * @returns
   *        The built object.
   */
  build() {
    return cloneDeep(this.$payload);
  }
}
const _AnalyticsEventBuilder = class _AnalyticsEventBuilder {
  /**
   * Initializes a new instance of this object.
   */
  constructor() {
    __publicField(this, "$event");
    this.$event = {
      component: "component",
      name: "event",
      payload: new AnalyticsPayloadBuilder().build()
    };
  }
  /**
   * Creates a standard event name from an event object.
   *
   * @param event -
   *        The event to stringify.
   *
   * @returns
   *        The full event name with namespace, layer, component, and name.
   */
  static nameify(event) {
    const ns = _AnalyticsEventBuilder.AnalyticsNamespace;
    const layer = _AnalyticsEventBuilder.AnalyticsLayer;
    const { component, name } = event;
    return `${ns}.${layer}.${component}.${name}`;
  }
  /**
   * Sets the component name.
   *
   * @param name -
   *        The name of the component.
   *
   * @returns
   *        This object.
   */
  component(name) {
    this.$event.component = name;
    return this;
  }
  /**
   * Sets the event name.
   *
   * @param name -
   *        The name of the event.
   *
   * @returns
   */
  name(name) {
    this.$event.name = name;
    return this;
  }
  /**
   * Sets the entire payload object.
   *
   * You can put anything you want in this field.  The standard
   * for this at gafe-entery
   *
   * @param payload -
   *        The payload object to set.
   *
   * @returns
   *        This object.
   */
  payload(payload) {
    this.$event.payload = payload;
    return this;
  }
  /**
   * Copies another event into this event.
   *
   * @param other -
   *        The event to copy.
   *
   * @returns
   *        This object.
   */
  copy(other) {
    this.$event = cloneDeep(other);
    return this;
  }
  /**
   * Returns the built event.
   *
   * @returns
   *        The built event.
   */
  build() {
    return cloneDeep(this.$event);
  }
};
/**
 * The root namespace.
 */
__publicField(_AnalyticsEventBuilder, "AnalyticsNamespace", "gafe");
/**
 * The namespace layer.
 */
__publicField(_AnalyticsEventBuilder, "AnalyticsLayer", "ui");
let AnalyticsEventBuilder = _AnalyticsEventBuilder;
function createError(problem, schema = ["message", "error", "exception", "data"]) {
  if (problem instanceof Error) {
    return problem;
  }
  if (problem == null) {
    return new Error();
  }
  for (let i = 0; i < schema.length; ++i) {
    const key = schema[i];
    if (Object.prototype.hasOwnProperty.call(problem, key)) {
      return createError(problem[key]);
    }
  }
  return new Error(String(problem));
}
function sleep(ms = 0, val = void 0) {
  return new Promise((resolve) => setTimeout(() => resolve(val), ms));
}
const AsyncLoading = Symbol("loading");
function useAsyncState(load, deps = []) {
  const [last, setLast] = useState(null);
  const [current, setCurrent] = useState(AsyncLoading);
  const subscription = useRef();
  const $refresh = () => {
    return new Promise((resolve) => {
      var _a;
      (_a = subscription.current) == null ? void 0 : _a.unsubscribe();
      subscription.current = defer(() => {
        setCurrent(AsyncLoading);
        return from(load());
      }).subscribe({
        next: (v) => {
          setCurrent(v);
          setLast(v);
          resolve();
        },
        error: (e) => {
          setCurrent(createError(e));
          resolve();
        }
      });
    });
  };
  const refresh = (useThisData) => {
    if (useThisData === void 0) {
      $refresh();
    } else {
      setCurrent(useThisData);
      setLast(useThisData);
    }
    return sleep(1);
  };
  useEffect(() => {
    $refresh();
    return () => {
      var _a;
      return (_a = subscription.current) == null ? void 0 : _a.unsubscribe();
    };
  }, [...deps]);
  return [current, refresh, last];
}
function isDataLoading(data) {
  return data === AsyncLoading;
}
function isDataErrored(data) {
  return data instanceof Error;
}
function isDataLoaded(data) {
  return !isDataLoading(data) && !isDataErrored(data);
}
function asData(data, fallback) {
  return isDataLoaded(data) ? data : fallback;
}
function asError(data) {
  return isDataErrored(data) ? data : void 0;
}
class StorageServiceBrowser {
  /**
   * Initializes a new instance of this object.
   *
   * @param $storage -
   *        The storage to read from.
   */
  constructor($storage) {
    this.$storage = $storage;
  }
  /**
   * Returns a service for localStorage.
   *
   * @returns
   *        The service that reads and writes to localStorage.
   */
  static local() {
    return new StorageServiceBrowser(localStorage);
  }
  /**
   * Returns a service for sessionStorage.
   *
   * @returns
   *        The service that reads and writes to sessionStorage.
   */
  static session() {
    return new StorageServiceBrowser(sessionStorage);
  }
  $readKeyPath(path) {
    let json = this.$storage.getItem(path);
    if (json != null) {
      return json;
    }
    const [first2, ...rest] = path.split(".");
    json = this.$storage.getItem(first2);
    if (json == null) {
      return null;
    }
    const childPath = rest.join(".");
    const asObject = JSON.parse(json);
    const value = get(asObject, childPath);
    return value ? JSON.stringify(value) : null;
  }
  get(path, fallback) {
    try {
      const value = this.$readKeyPath(path);
      return Promise.resolve(value ? JSON.parse(value) : fallback);
    } catch {
      return Promise.resolve(fallback);
    }
  }
  set(key, value) {
    if (value == null) {
      this.$storage.removeItem(key);
    } else {
      this.$storage.setItem(key, JSON.stringify(value));
    }
    return Promise.resolve();
  }
}
class StorageServiceComposite {
  /**
   * Initializes a new instance of this object.
   *
   * @param services -
   *        The list of storage services that will be reviewed when retrieving keys.
   *        When setting, a bulk update will be performed across all services.
   */
  constructor(services) {
    this.services = services;
  }
  async get(key, fallback) {
    for await (const $service of this.services) {
      const current = await $service.get(key);
      if (current != null) {
        return current;
      }
    }
    return fallback;
  }
  async set(key, value) {
    await Promise.all(this.services.map((service) => service.set(key, value)));
  }
}
const _StorageKeys = class _StorageKeys {
};
// Individual keys
__publicField(_StorageKeys, "KEY_GAF_PP_STORAGE", "gaf-pp-storage");
__publicField(_StorageKeys, "KEY_PORTAL_ACCESS_TOKEN", "portalAccessToken");
// Full Paths
__publicField(_StorageKeys, "PATH_PORTAL_ACCESS_TOKEN", `${_StorageKeys.KEY_GAF_PP_STORAGE}.${_StorageKeys.KEY_PORTAL_ACCESS_TOKEN}`);
let StorageKeys = _StorageKeys;
class IdentityBuilder {
  /**
   * Initializes a new instance of this object.
   */
  constructor() {
    __publicField(this, "$identity");
    __publicField(this, "admin", this.user.bind(this, "Admin"));
    __publicField(this, "limited", this.user.bind(this, "Limited"));
    this.$identity = {
      assistedByAdmin: false,
      authorizedToSell: false
    };
  }
  /**
   * Sets the information of the admin who is assisting the user
   *
   * @param id -
   *        The id of the assisting admin.
   * @param name -
   *        The name of the assisting admin.
   *
   * @returns
   *        This object.
   */
  assistedBy(id, name) {
    if (id == null) {
      this.$identity.assistedByAdmin = false;
      delete this.$identity.assistingAdminId;
      delete this.$identity.assistingAdminName;
    } else {
      this.$identity.assistedByAdmin = true;
      this.$identity.assistingAdminId = id;
      this.$identity.assistingAdminName = name;
    }
    return this;
  }
  /**
   * Sets whether or not the partner is authorized to sell.
   *
   * @param authorized -
   *        The flag that determines whether or not the partner is
   *        authorized to sell.
   *
   * @returns
   *        This object.
   */
  authorized(authorized = true) {
    this.$identity.authorizedToSell = authorized;
    return this;
  }
  /**
   * Sets the company information that the user belongs to.
   *
   * @param id -
   *        The id of the company the user belongs to.
   * @param name -
   *        The friendly name of the company.
   *
   * @returns
   *        This object.
   */
  company(id, name) {
    if (id == null) {
      delete this.$identity.companyId;
      delete this.$identity.companyName;
    } else {
      this.$identity.companyId = id;
      this.$identity.companyName = name;
    }
    return this;
  }
  /**
   * Sets the contractor information.
   *
   * @param company -
   *        The contractor company id.
   * @param user -
   *        The contractor id.
   *
   * @returns
   *        This object.
   */
  contractor(company, user) {
    if (company == null) {
      delete this.$identity.contractorZoneCompanyId;
    } else {
      this.$identity.contractorZoneCompanyId = company;
    }
    if (user == null) {
      delete this.$identity.contractorZoneUserId;
    } else {
      this.$identity.contractorZoneUserId = user;
    }
    return this;
  }
  /**
   * Sets the user information
   *
   * @param role -
   *        The user's current role.
   * @param id -
   *        The user's id.
   * @param email -
   *        The user's email.
   *
   * @returns
   *        This object.
   */
  user(role, id, email) {
    this.$identity.role = role;
    this.$identity.userId = id;
    this.$identity.email = email;
    return this;
  }
  /**
   * A sample identity that is useful for unit tests.
   *
   * @returns
   *        This object.
   */
  jessie() {
    return this.limited("d6e9f4a7-91e5-4081-a3e3-3c6f91f19d97", "jessie.doe@fake.com").company("64e86e7b-7404-46e0-ac76-c65870192445", "Acme LTD").assistedBy("ca3feab3-50c9-4c84-9090-63abb95b64f4", "Noah Blake").authorized();
  }
  /**
   * Parses a jwt into this identity.
   *
   * @param jwt -
   *        The jwt token to parse.
   *
   * @returns
   *        This object.
   */
  parse(jwt) {
    var _a;
    const [, payload] = jwt.split(".");
    const json = atob(payload);
    const candidate = JSON.parse(json);
    const role = candidate.role === "Sales" ? "Limited" : candidate.role;
    return this.assistedBy(candidate.assistingAdminId, candidate.assistingAdminName).authorized(((_a = candidate.authorizedToSell) == null ? void 0 : _a.toString().toLowerCase()) === "true").company(candidate.companyId, candidate.companyName).contractor(candidate.contractorZoneCompanyId, candidate.contractorZoneUserId).user(role, candidate.userId, candidate.email);
  }
  /**
   * Builds the identity.
   */
  build() {
    return cloneDeep(this.$identity);
  }
}
class IdentityServiceStorage {
  /**
   * Initializes a new instance of this object.
   *
   * @param $storage -
   *        The storage service to look for the gaf-pp-storage key in.
   */
  constructor($storage) {
    this.$storage = $storage;
  }
  async get() {
    try {
      const key = StorageKeys.PATH_PORTAL_ACCESS_TOKEN;
      const portalAccessToken = await this.$storage.get(key);
      return portalAccessToken ? new IdentityBuilder().parse(portalAccessToken).build() : void 0;
    } catch {
      return Promise.resolve(void 0);
    }
  }
}
function createDefaultIdentityService() {
  const targets = [StorageServiceBrowser.session(), StorageServiceBrowser.local()];
  return new IdentityServiceStorage(new StorageServiceComposite(targets));
}
const IdentityServiceContext = createContext(createDefaultIdentityService());
const useIdentityService = () => useContext(IdentityServiceContext);
const useIdentity = () => {
  const service = useIdentityService();
  const [identity] = useAsyncState(() => service.get());
  return identity;
};
class AnalyticsServiceGoogleTagManager {
  constructor($identity, $logger) {
    this.$identity = $identity;
    this.$logger = $logger;
  }
  get dataLayer() {
    return get(window, "dataLayer", []);
  }
  async track(event) {
    try {
      const identity = await this.$identity.get();
      const $payload = new AnalyticsPayloadBuilder().copy(event.payload).url(window.location).identity(identity).build();
      const tag2 = {
        event: AnalyticsEventBuilder.nameify(event),
        params: $payload
      };
      this.dataLayer.push(tag2);
      return Promise.resolve();
    } catch (e) {
      this.$logger.error(e);
      return Promise.resolve();
    }
  }
}
__publicField(AnalyticsServiceGoogleTagManager, "ENV_GTM_ID", "GTM_ID");
function createDefaultAnalyticsService() {
  const identity = createDefaultIdentityService();
  return new AnalyticsServiceGoogleTagManager(identity, console);
}
const AnalyticsServiceContext = createContext(createDefaultAnalyticsService());
const useAnalyticsService = () => useContext(AnalyticsServiceContext);
const root$d = "GAFE-Button-root";
const prefix$1 = "GAFE-Button-prefix";
const suffix$1 = "GAFE-Button-suffix";
const styles$E = {
  root: root$d,
  prefix: prefix$1,
  suffix: suffix$1
};
const Widths = {
  auto: "fit-content",
  full: "100%"
};
const SizeToGutter = {
  "extra-extra-small": "xs",
  "extra-small": "xs",
  small: "sm",
  medium: "md",
  large: "md"
};
const GutterToTypographyMap = {
  xs: ButtonTextSmall,
  sm: ButtonTextSmall,
  md: ButtonTextMedium
};
function Button({
  appendIcon: appendIcon2,
  buttonRef,
  children,
  className,
  colorSchema = "none",
  disabled: disabled2,
  isLoading = false,
  loadingText,
  mobileAppendIcon,
  mobilePrependIcon,
  mobileSize,
  mobileWidth,
  name,
  onClick,
  prependIcon: prependIcon2,
  size: size2 = "medium",
  submit = false,
  testId = "gafe-button",
  variant = "contained",
  width,
  prefix: prefix2 = { desktop: prependIcon2, mobile: mobilePrependIcon },
  suffix: suffix2 = { desktop: appendIcon2, mobile: mobileAppendIcon },
  gutter = { desktop: SizeToGutter[size2], mobile: SizeToGutter[firstDefined(size2, mobileSize)] },
  ...props
}) {
  const device = useDeviceDetection();
  const analytics = useAnalyticsService();
  const $prefix = useDeviceValue(device, prefix2);
  const $suffix = useDeviceValue(device, suffix2);
  const $gutter = useDeviceValue(device, gutter, "md");
  const $$width = useDeviceValue(device, width);
  const $width = useDeviceValue(device, { desktop: $$width, mobile: mobileWidth });
  const style = { width: firstDefined($width, get(Widths, firstDefined("auto", $width))) };
  const ButtonTypography = GutterToTypographyMap[$gutter];
  const handleClick = useCallback(
    async (e) => {
      e.preventDefault();
      onClick == null ? void 0 : onClick.call(null, e);
      const event = new AnalyticsEventBuilder().component("button").name("click").payload(
        new AnalyticsPayloadBuilder().dataProps(props).pair("textContent", e.currentTarget.textContent).pair("type", e.currentTarget.type).build()
      ).build();
      await analytics.track(event);
    },
    [analytics, onClick, props]
  );
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: classNames(styles$E.root, className),
      "data-color-schema": colorSchema,
      "data-gutter": $gutter,
      "data-name": name,
      "data-testid": testId,
      "data-variant": variant,
      "data-width": $width,
      disabled: isLoading || disabled2,
      name,
      onClick: handleClick,
      ref: buttonRef,
      style,
      type: submit ? "submit" : "button",
      ...pickDataAttributes(props),
      children: /* @__PURE__ */ jsxs(Stack, { align: { items: "center" }, gap: "xs", orientation: "horizontal", children: [
        /* @__PURE__ */ jsx(
          ProgressSpinner,
          {
            active: isLoading,
            className: styles$E.loader,
            "data-testid": "gafe-button-loader",
            width: "sm"
          }
        ),
        /* @__PURE__ */ jsx(Hidden, { on: !$prefix || isLoading, children: /* @__PURE__ */ jsx(
          ButtonTypography,
          {
            TElement: "div",
            className: styles$E.prefix,
            "data-testid": "gafe-button-prefix",
            display: "inline-flex",
            children: $prefix
          }
        ) }),
        /* @__PURE__ */ jsx(Grow, { display: "inline-flex", children: /* @__PURE__ */ jsx(ButtonTypography, { TElement: "div", "data-testid": "gafe-button-content", width: "full", children: /* @__PURE__ */ jsx(Stack, { justify: { content: "center" }, orientation: "horizontal", children: /* @__PURE__ */ jsx(
          DualityIndicator,
          {
            disengaged: children,
            engaged: firstTruthy(children, loadingText),
            value: isLoading
          }
        ) }) }) }),
        /* @__PURE__ */ jsx(Hidden, { on: !$suffix, children: /* @__PURE__ */ jsx(
          ButtonTypography,
          {
            TElement: "div",
            className: styles$E.suffix,
            "data-testid": "gafe-button-suffix",
            display: "inline-flex",
            children: $suffix
          }
        ) })
      ] })
    }
  );
}
function castFunction(value) {
  return typeof value === "function" ? value : () => value;
}
const card = "GAFE-Card-card";
const header$1 = "GAFE-Card-header";
const body = "GAFE-Card-body";
const footer$1 = "GAFE-Card-footer";
const styles$D = {
  card,
  header: header$1,
  body,
  footer: footer$1
};
const Card = ({
  borderless,
  children,
  flat,
  rounded,
  compact,
  width = "auto",
  height = "auto",
  renderHeader,
  renderFooter,
  ...props
}) => {
  const $renderHeader = useMemo(() => castFunction(renderHeader), [renderHeader]);
  const $renderFooter = useMemo(() => castFunction(renderFooter), [renderFooter]);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$D.card),
      "data-testid": "card",
      ...pickDataAttributes(props),
      "data-borderless": Boolean(borderless),
      "data-compact": Boolean(compact),
      "data-flat": Boolean(flat),
      "data-height": height,
      "data-rounded": Boolean(rounded),
      "data-width": width,
      children: [
        renderHeader && /* @__PURE__ */ jsx("div", { className: styles$D.header, "data-testid": "card-header", children: $renderHeader() }),
        /* @__PURE__ */ jsx("div", { className: styles$D.body, "data-testid": "card-body", children }),
        renderFooter && /* @__PURE__ */ jsx("div", { className: styles$D.footer, "data-testid": "card-footer", children: $renderFooter() })
      ]
    }
  );
};
function useAmbassadorState(current, setCurrent, initial) {
  const [localCurrent, setLocalCurrent] = useState(current || initial);
  const $current = current === void 0 ? localCurrent : current;
  const $setCurrent = (val) => {
    setLocalCurrent(val);
    const isReducer = (v) => typeof v === "function";
    if (setCurrent) {
      const next = isReducer(val) ? val($current) : val;
      setCurrent(next);
    }
  };
  return [$current, $setCurrent];
}
function IconCheckMark(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-check-mark",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.22 6L9.33 14.57L5.78 11.14L4 12.86L7.56 16.29L9.33 18L11.11 16.29L20 7.71L18.22 6Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconCheckMark.displayName = "CheckMark";
function ClassService(classes, styles2 = {}) {
  const result = {};
  if (!classes) {
    return styles2;
  }
  Object.keys(styles2).forEach((name) => {
    if (classes[name]) {
      if (typeof classes[name] === "object" && classes[name].substitute) {
        result[name] = classes[name].name;
        return;
      }
      result[name] = classNames(classes[name], styles2[name]);
      return;
    }
    result[name] = styles2[name];
  });
  return result;
}
const Inherit = (props) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "span",
    "data-testid": "gafe-typography-inherit",
    ...props,
    "data-typography": "Inherit",
    size: "inherit",
    transform: "inherit",
    weight: "inherit"
  }
);
function Label({
  children,
  className,
  required: required2,
  Typography: Typography2 = Caption,
  TypographyProps,
  ...props
}) {
  const $required = required2 === true ? "prefix" : required2;
  const renderRequiredStar = (position) => /* @__PURE__ */ jsx(Inherit, { colorSchema: "destructive", "data-position": position, "data-testid": "gafe-label-required", children: "*" });
  return /* @__PURE__ */ jsx(
    Typography2,
    {
      TElement: "span",
      colorSchema: "dark",
      ...TypographyProps,
      className,
      "data-testid": "gafe-label",
      ...pickDataAttributes(props),
      children: /* @__PURE__ */ jsxs(Stack, { align: { items: "flex-start" }, gap: "3xs", orientation: "horizontal", children: [
        /* @__PURE__ */ jsx(Hidden, { on: !$required || $required === "suffix", children: renderRequiredStar("prefix") }),
        /* @__PURE__ */ jsx(
          "label",
          {
            ...omitDataAttributes(props),
            "data-testid": "gafe-label-content",
            style: { cursor: "inherit" },
            children
          }
        ),
        /* @__PURE__ */ jsx(Hidden, { on: !$required || $required === "prefix", children: renderRequiredStar("suffix") })
      ] })
    }
  );
}
const wrapper$7 = "GAFE-Checkbox-wrapper";
const checkbox_input = "GAFE-Checkbox-checkbox_input";
const checkmark = "GAFE-Checkbox-checkmark";
const checked$1 = "GAFE-Checkbox-checked";
const not_checked = "GAFE-Checkbox-not_checked";
const styles$C = {
  wrapper: wrapper$7,
  checkbox_input,
  checkmark,
  checked: checked$1,
  not_checked
};
const Checkbox = ({
  classes,
  checked: checked2,
  disabled: disabled2 = false,
  id,
  label: label2,
  onClick
}) => {
  const [checkboxState, setCheckboxState] = useAmbassadorState(checked2, onClick, false);
  const gid = useId();
  const $id = firstDefined(gid, id);
  const css2 = ClassService(classes, {
    wrapper: styles$C.wrapper,
    checkmark: styles$C.checkmark
  });
  const checkInputHandler = useCallback(
    (e) => setCheckboxState(e.target.checked),
    [setCheckboxState]
  );
  const toggle = useCallback(() => setCheckboxState((c) => !c), [setCheckboxState]);
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      align: { items: "center" },
      className: css2.wrapper,
      "data-testid": "gafe-checkbox",
      gap: "2xs",
      orientation: "horizontal",
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            checked: checkboxState,
            className: styles$C.checkbox_input,
            "data-testid": "checkbox-input",
            disabled: disabled2,
            id: $id,
            onChange: checkInputHandler,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames(css2.checkmark, checkboxState ? styles$C.checked : styles$C.not_checked),
            "data-testid": "gafe-checkbox-toggler",
            onClick: toggle,
            children: /* @__PURE__ */ jsx(IconCheckMark, { colorSchema: "monochromatic-light", height: "sm", width: "sm" })
          }
        ),
        /* @__PURE__ */ jsx(
          Label,
          {
            Typography: Body,
            TypographyProps: { colorSchema: "monochromatic-dark" },
            className: css2.wrapper,
            "data-testid": "checkbox-wrapper",
            htmlFor: $id,
            children: label2
          }
        )
      ]
    }
  );
};
const root$c = "GAFE-Chip-root";
const lineItemBody = "GAFE-Chip-line-item-body";
const lineItem = "GAFE-Chip-line-item";
const styles$B = {
  root: root$c,
  lineItemBody,
  lineItem
};
function Chip({
  children,
  prefix: prefix2,
  suffix: suffix2,
  className,
  colorSchema,
  width,
  ...props
}) {
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      align: { items: "center" },
      className: classNames(styles$B.root, className),
      "data-testid": "gafe-chip",
      gap: "2xs",
      orientation: { desktop: "horizontal" },
      ...pickDataAttributes(props),
      "data-color-schema": colorSchema,
      "data-width": width,
      children: [
        prefix2 && /* @__PURE__ */ jsx("div", { className: styles$B.lineItem, "data-testid": "gafe-chip-prefix", children: prefix2 }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$B.lineItem, styles$B.lineItemBody),
            "data-testid": "gafe-chip-body",
            children
          }
        ),
        suffix2 && /* @__PURE__ */ jsx("div", { className: styles$B.lineItem, "data-testid": "gafe-chip-suffix", children: suffix2 })
      ]
    }
  );
}
const root$b = "GAFE-Divider-root";
const styles$A = {
  root: root$b
};
function Divider({ className }) {
  return /* @__PURE__ */ jsx("hr", { className: classNames(styles$A.root, className), role: "separator" });
}
function useDialog(dialog, {
  children,
  className,
  closeOnBackdropClick,
  closeOnEsc,
  open: open2,
  onClose,
  renderFooter,
  renderHeader
}, {
  onBeforeOpen,
  onAfterOpen,
  onBeforeClose,
  onAfterClose,
  onBeforeDestroy
} = {}) {
  const $renderHeader = useMemo(() => castFunction(renderHeader), [renderHeader]);
  const $renderFooter = useMemo(() => castFunction(renderFooter), [renderFooter]);
  const $dummy = useMemo(() => document.createElement("dialog"), []);
  const getDialog = useCallback(() => firstDefined($dummy, dialog.current), [$dummy, dialog]);
  const $open = useCallback(async () => {
    const $dialog = getDialog();
    if ($dialog.open) {
      return;
    }
    await (onBeforeOpen == null ? void 0 : onBeforeOpen.call(null, $dialog));
    $dialog.show();
    await (onAfterOpen == null ? void 0 : onAfterOpen.call(null, $dialog));
  }, [getDialog, onBeforeOpen, onAfterOpen]);
  const $close = useCallback(async () => {
    const $dialog = getDialog();
    if (!$dialog.open) {
      return;
    }
    await (onBeforeClose == null ? void 0 : onBeforeClose.call(null, $dialog));
    $dialog.close();
    await (onAfterClose == null ? void 0 : onAfterClose.call(null, $dialog));
  }, [getDialog, onBeforeClose, onAfterClose]);
  const onKeyDown = useCallback(
    (e) => {
      if (e.key.toUpperCase() !== "ESCAPE") {
        return;
      }
      e.preventDefault();
      if (closeOnEsc) {
        $close();
        onClose == null ? void 0 : onClose.call(null);
      }
    },
    [closeOnEsc, $close, onClose]
  );
  const onClickBackdrop = useCallback(() => {
    if (closeOnBackdropClick) {
      $close();
      onClose == null ? void 0 : onClose.call(null);
    }
  }, [closeOnBackdropClick, $close, onClose]);
  useEffect(() => {
    if (open2) {
      $open();
    } else {
      $close();
    }
  }, [open2, $open, $close]);
  useEffect(() => {
    return () => {
      onBeforeDestroy == null ? void 0 : onBeforeDestroy.call(null, getDialog());
    };
  }, [getDialog, onBeforeDestroy]);
  return {
    children,
    className,
    open: open2,
    onClose,
    onClickBackdrop,
    onKeyDown,
    renderHeader: $renderHeader,
    renderFooter: $renderFooter
  };
}
var AnchorY = /* @__PURE__ */ ((AnchorY2) => {
  AnchorY2["Bottom"] = "bottom";
  AnchorY2["Middle"] = "middle";
  AnchorY2["Top"] = "top";
  return AnchorY2;
})(AnchorY || {});
var AnchorX = /* @__PURE__ */ ((AnchorX2) => {
  AnchorX2["Left"] = "left";
  AnchorX2["Center"] = "center";
  AnchorX2["Right"] = "right";
  return AnchorX2;
})(AnchorX || {});
class Plane2d {
  constructor(bounds) {
    __publicField(this, "leftTop", this.point.bind(this, [AnchorX.Left, AnchorY.Top]));
    __publicField(this, "leftMiddle", this.point.bind(this, [AnchorX.Left, AnchorY.Middle]));
    __publicField(this, "leftBottom", this.point.bind(this, [AnchorX.Left, AnchorY.Bottom]));
    __publicField(this, "centerTop", this.point.bind(this, [AnchorX.Center, AnchorY.Top]));
    __publicField(this, "centerMiddle", this.point.bind(this, [AnchorX.Center, AnchorY.Middle]));
    __publicField(this, "centerBottom", this.point.bind(this, [AnchorX.Center, AnchorY.Bottom]));
    __publicField(this, "rightTop", this.point.bind(this, [AnchorX.Right, AnchorY.Top]));
    __publicField(this, "rightMiddle", this.point.bind(this, [AnchorX.Right, AnchorY.Middle]));
    __publicField(this, "rightBottom", this.point.bind(this, [AnchorX.Right, AnchorY.Bottom]));
    this.bounds = bounds;
  }
  point(target2) {
    const { bottom, left, right, top } = this.bounds;
    const [horizontal, vertical] = target2;
    const $vertical = {
      [AnchorY.Top]: top,
      [AnchorY.Middle]: (bottom + top) / 2,
      [AnchorY.Bottom]: bottom
    };
    const $horizontal = {
      [AnchorX.Left]: left,
      [AnchorX.Center]: (right + left) / 2,
      [AnchorX.Right]: right
    };
    return { x: $horizontal[horizontal], y: $vertical[vertical] };
  }
}
const fullscreen = "GAFE-FullScreen-fullscreen";
const styles$z = {
  fullscreen
};
const FullScreen = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx("div", { className: classNames(styles$z.fullscreen, className), ...pickDataAttributes(props), children });
};
const root$a = "GAFE-Popup-root";
const content$3 = "GAFE-Popup-content";
const styles$y = {
  root: root$a,
  content: content$3
};
function Popup({
  attach,
  attachAnchor = [AnchorX.Left, AnchorY.Bottom],
  compact,
  height,
  popupAnchor = [AnchorX.Left, AnchorY.Top],
  width,
  ...props
}) {
  const device = useDeviceDetection();
  const dummy = useMemo(() => document.createElement("dialog"), []);
  const popup = useRef(null);
  const $width = useDeviceValue(device, width);
  const $height = useDeviceValue(device, height);
  const calculatePosition = useCallback(
    async (dialog) => {
      const $attach = firstDefined(document.body, attach, dialog.parentElement);
      const attachBounds = $attach.getBoundingClientRect();
      const popupBounds = dialog.getBoundingClientRect();
      const attachRectangle = new RectangleBuilder(0).right(attachBounds.width).bottom(attachBounds.height).build();
      const attachPlane = new Plane2d(attachRectangle);
      const contentRectangle = new RectangleBuilder(0).right(popupBounds.width).bottom(popupBounds.height).build();
      const contentPlane = new Plane2d(contentRectangle);
      const { x: attachX, y: attachY } = attachPlane.point(attachAnchor);
      const { x: popupX, y: popupY } = contentPlane.point(popupAnchor);
      const left = attachBounds.left + attachX - popupX;
      const top = attachBounds.top + attachY - popupY;
      dialog.style.left = `${left}px`;
      dialog.style.top = `${top}px`;
      dialog.style.width = `${attachBounds.width}px`;
      await sleep();
    },
    [attach, attachAnchor, popupAnchor]
  );
  const handleResize = useCallback(() => {
    const $popup = firstDefined(dummy, popup.current);
    calculatePosition($popup);
  }, [calculatePosition, dummy]);
  useEffect(() => {
    window.removeEventListener("resize", handleResize);
    window.removeEventListener("scroll", handleResize);
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleResize);
    };
  }, [handleResize]);
  const { children, className, onClickBackdrop, onKeyDown, open: open2, renderHeader, renderFooter } = useDialog(popup, { ...props }, { onAfterOpen: calculatePosition });
  return /* @__PURE__ */ jsxs(FullScreen, { children: [
    /* @__PURE__ */ jsx(Backdrop, { hide: !open2, onClick: onClickBackdrop, transparent: true }),
    /* @__PURE__ */ jsx(
      "dialog",
      {
        className: classNames(styles$y.root, className),
        role: "dialog",
        ...pickDataAttributes(props),
        "data-compact": compact,
        "data-height": $height,
        "data-width": $width,
        onKeyDown,
        ref: popup,
        children: /* @__PURE__ */ jsxs(Stack, { className: classNames(styles$y.content), gap: "sm", children: [
          props.renderHeader && /* @__PURE__ */ jsx("header", { "data-testid": "header", children: renderHeader() }),
          /* @__PURE__ */ jsx("article", { "data-testid": "body", children }),
          props.renderFooter && /* @__PURE__ */ jsx("footer", { "data-testid": "footer", children: renderFooter() })
        ] })
      }
    )
  ] });
}
function Labeled({
  className,
  children,
  label: label2,
  notes,
  position = "prefix",
  GrowProps,
  LayoutProps,
  LabelProps,
  ...props
}) {
  const renderLabel = () => /* @__PURE__ */ jsx(Label, { ...LabelProps, "data-position": position, children: label2 });
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      className,
      "data-testid": "gafe-labeled",
      gap: "2xs",
      ...pickDataAttributes(props),
      children: [
        /* @__PURE__ */ jsxs(Stack, { gap: "2xs", ...LayoutProps, children: [
          /* @__PURE__ */ jsx(Hidden, { on: !label2 || position === "suffix", children: renderLabel() }),
          /* @__PURE__ */ jsx(Grow, { ...GrowProps, children }),
          /* @__PURE__ */ jsx(Hidden, { on: !label2 || position === "prefix", children: renderLabel() })
        ] }),
        /* @__PURE__ */ jsx(Hidden, { on: !notes, children: /* @__PURE__ */ jsx(Caption, { TElement: "div", "data-testid": "gafe-labeled-notes", children: notes }) })
      ]
    }
  );
}
const root$9 = "GAFE-TextInput-root";
const input$1 = "GAFE-TextInput-input";
const error$2 = "GAFE-TextInput-error";
const styles$x = {
  root: root$9,
  input: input$1,
  error: error$2
};
const SizeMapToPadding = {
  large: "md",
  medium: "md",
  small: "sm"
};
const TextInput = ({
  appendIcon: appendIcon2,
  className,
  classes,
  colorSchema,
  disabled: disabled2,
  errorMessage,
  hasError = false,
  helperText,
  helperIcon,
  prependIcon: prependIcon2,
  innerRef,
  labelText,
  size: size2 = "medium",
  showRequired = false,
  testId,
  gutter = SizeMapToPadding[size2],
  prefix: prefix2 = prependIcon2,
  suffix: suffix2 = appendIcon2,
  LabeledProps,
  id,
  ...rest
}) => {
  const device = useDeviceDetection();
  const gid = useId();
  const $id = firstDefined(id, gid);
  const $gutter = useDeviceValue(device, gutter);
  const $prefix = useDeviceValue(device, prefix2);
  const $suffix = useDeviceValue(device, suffix2);
  const $testId = firstDefined("gafe-common-text-input", get(rest, "data-testid"), testId);
  const renderLegacyNotes = () => {
    const showErrorMessage = hasError && Boolean(errorMessage);
    const shouldRenderHelperText = Boolean(helperText) || showErrorMessage;
    if (!shouldRenderHelperText) {
      return null;
    }
    const message = showErrorMessage ? errorMessage : helperText;
    return /* @__PURE__ */ jsx(Caption, { TElement: "span", colorSchema: showErrorMessage ? "destructive" : "inherit", children: /* @__PURE__ */ jsxs(Stack, { align: { items: "center" }, gap: "2xs", orientation: "horizontal", children: [
      /* @__PURE__ */ jsx(Hidden, { on: !helperIcon, children: /* @__PURE__ */ jsx("span", { "data-testid": `${$testId}-helper-icon`, style: { display: "inline-flex" }, children: helperIcon }) }),
      /* @__PURE__ */ jsx("span", { "data-testid": `${$testId}-helper-message`, children: message })
    ] }) });
  };
  return /* @__PURE__ */ jsx(
    Body,
    {
      TElement: "div",
      className: classNames(styles$x.root, className, classes == null ? void 0 : classes.wrapper),
      ...pickDataAttributes(rest),
      "data-testid": `${$testId}-wrapper`,
      children: /* @__PURE__ */ jsx(
        Labeled,
        {
          LabelProps: {
            required: showRequired,
            htmlFor: $id
          },
          label: labelText,
          notes: renderLegacyNotes(),
          ...LabeledProps,
          children: /* @__PURE__ */ jsxs(
            Stack,
            {
              align: { items: "center" },
              className: classNames(styles$x.input, { [styles$x.error]: hasError }),
              "data-color-schema": colorSchema,
              "data-padding": $gutter,
              gap: "2xs",
              orientation: "horizontal",
              children: [
                /* @__PURE__ */ jsx(Hidden, { on: !$prefix, children: /* @__PURE__ */ jsx(Inherit, { TElement: "span", "data-testid": `${$testId}-prefix`, display: "inline-grid", children: $prefix }) }),
                /* @__PURE__ */ jsx(
                  "input",
                  {
                    autoComplete: "off",
                    ...rest,
                    "data-testid": $testId,
                    disabled: disabled2,
                    id: $id,
                    ref: innerRef,
                    style: { flexGrow: 1 }
                  }
                ),
                /* @__PURE__ */ jsx(Hidden, { on: !$suffix, children: /* @__PURE__ */ jsx(Inherit, { TElement: "span", "data-testid": `${$testId}-suffix`, display: "inline-grid", children: $suffix }) })
              ]
            }
          )
        }
      )
    }
  );
};
function IconChevronDown(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-chevron-down",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "m20,8l-8,8L4,8", fill: "none", stroke: "currentcolor", strokeWidth: "2px" }),
        /* @__PURE__ */ jsx("rect", { className: "cls-1", fill: "none", height: "24", width: "24" })
      ] })
    }
  );
}
IconChevronDown.displayName = "ChevronDown";
function IconChevronUp(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-chevron-up",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "m20,16l-8-8-8,8", fill: "none", stroke: "currentcolor", strokeWidth: "2px" }),
        /* @__PURE__ */ jsx("rect", { className: "cls-1", fill: "none", height: "24", width: "24" })
      ] })
    }
  );
}
IconChevronUp.displayName = "ChevronUp";
function IconSearch(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-search",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.6976 17.1168L22.9803 21.3995L21.5661 22.8137L17.2834 18.531C15.7435 19.763 13.7906 20.5 11.6666 20.5C6.69863 20.5 2.66663 16.468 2.66663 11.5C2.66663 6.532 6.69863 2.5 11.6666 2.5C16.6346 2.5 20.6666 6.532 20.6666 11.5C20.6666 13.624 19.9296 15.5769 18.6976 17.1168ZM16.6913 16.3748C17.9141 15.1146 18.6666 13.3956 18.6666 11.5C18.6666 7.6325 15.5341 4.5 11.6666 4.5C7.79913 4.5 4.66663 7.6325 4.66663 11.5C4.66663 15.3675 7.79913 18.5 11.6666 18.5C13.5622 18.5 15.2812 17.7475 16.5414 16.5247L16.6913 16.3748Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconSearch.displayName = "Search";
function mapToString(value) {
  return typeof value === "object" ? JSON.stringify(value) : String(value);
}
class DataRequestBuilder {
  constructor() {
    __publicField(this, "request");
    this.request = {};
  }
  filter(filter2) {
    if (filter2 == null) {
      delete this.request.filter;
    } else {
      this.request.filter = filter2;
    }
    return this;
  }
  sort(sort2) {
    if (sort2 == null ? void 0 : sort2.length) {
      this.request.sort = sort2;
    } else {
      delete this.request.sort;
    }
    return this;
  }
  search(text2) {
    if (text2) {
      this.request.search = text2;
    } else {
      delete this.request.search;
    }
    return this;
  }
  page(page) {
    if (page && page > 1 && page < Infinity) {
      this.request.page = page;
    } else {
      delete this.request.page;
    }
    return this;
  }
  size(size2) {
    if (size2 != null && size2 >= 0 && size2 < Infinity) {
      this.request.size = size2;
    } else {
      delete this.request.size;
    }
    return this;
  }
  copy(other) {
    this.request = JSON.parse(JSON.stringify(other));
    return this;
  }
  build() {
    return JSON.parse(JSON.stringify(this.request));
  }
}
class DataResolveIdentity {
  resolve(ids) {
    return Promise.resolve(ids);
  }
}
var OperatorBinary = /* @__PURE__ */ ((OperatorBinary2) => {
  OperatorBinary2["Equals"] = "eq";
  OperatorBinary2["Contains"] = "cn";
  return OperatorBinary2;
})(OperatorBinary || {});
const _FilterBinaryBuilder = class _FilterBinaryBuilder {
  constructor() {
    __publicField(this, "filter");
    __publicField(this, "equals", this.relate.bind(
      this,
      "eq"
      /* Equals */
    ));
    __publicField(this, "contains", this.relate.bind(
      this,
      "cn"
      /* Contains */
    ));
    this.filter = {
      $type: _FilterBinaryBuilder.Type,
      operator: "eq",
      value: ""
    };
  }
  subject(subject) {
    this.filter.subject = subject;
    return this;
  }
  relate(relationship, value) {
    this.filter.operator = relationship;
    this.filter.value = value;
    return this;
  }
  build() {
    return JSON.parse(JSON.stringify(this.filter));
  }
};
__publicField(_FilterBinaryBuilder, "Type", "__filter_binary__");
let FilterBinaryBuilder = _FilterBinaryBuilder;
function isBinaryFilter(filter2) {
  return filter2.$type === FilterBinaryBuilder.Type;
}
const BinaryComparators = {
  [
    "eq"
    /* Equals */
  ]: (d, v) => d === v,
  [
    "cn"
    /* Contains */
  ]: (d, v) => `${d}`.toUpperCase().includes(`${v}`.toUpperCase())
};
var OperatorLogic = /* @__PURE__ */ ((OperatorLogic2) => {
  OperatorLogic2["And"] = "and";
  OperatorLogic2["Or"] = "or";
  return OperatorLogic2;
})(OperatorLogic || {});
const _FilterLogicBuilder = class _FilterLogicBuilder {
  constructor() {
    __publicField(this, "filter");
    __publicField(this, "and", this.operator.bind(
      this,
      "and"
      /* And */
    ));
    __publicField(this, "or", this.operator.bind(
      this,
      "or"
      /* Or */
    ));
    this.filter = {
      $type: _FilterLogicBuilder.Type,
      operator: "and",
      value: []
    };
  }
  operator(operator) {
    this.filter.operator = operator;
    return this;
  }
  clauses(values) {
    this.filter.value = values;
    return this;
  }
  clause(value) {
    return this.clauses(this.filter.value.concat([value]));
  }
  build() {
    return JSON.parse(JSON.stringify(this.filter));
  }
};
__publicField(_FilterLogicBuilder, "Type", "__filter_logic__");
let FilterLogicBuilder = _FilterLogicBuilder;
function isLogicFilter(filter2) {
  return filter2.$type === FilterLogicBuilder.Type;
}
class DataFilterFields {
  $matchLogicFilter(data, filter2) {
    return filter2.operator === OperatorLogic.And ? filter2.value.every((f) => this.match(data, f)) : filter2.value.some((f) => this.match(data, f));
  }
  $matchSubjectFilter(data, filter2, comparators, value) {
    const comparator = comparators[filter2.operator];
    const compareAgainst = filter2.subject ? get(data, filter2.subject, null) : data;
    return comparator(compareAgainst, value);
  }
  match(data, filter2) {
    if (isLogicFilter(filter2)) {
      return this.$matchLogicFilter(data, filter2);
    }
    if (isBinaryFilter(filter2)) {
      return this.$matchSubjectFilter(data, filter2, BinaryComparators, filter2.value);
    }
    return false;
  }
}
class DataSearchFields {
  constructor($fields) {
    this.$fields = $fields;
  }
  match(data, filter2) {
    const $$fields = this.$fields || keys(data);
    const $$filter = filter2.toUpperCase();
    return $$fields.some((field) => {
      const value = `${get(data, field) || ""}`.toUpperCase();
      return value.includes($$filter);
    });
  }
}
class DataMatchOptional {
  constructor($match) {
    this.$match = $match;
  }
  match(data, filter2) {
    if (filter2 == null) {
      return true;
    }
    return this.$match.match(data, filter2);
  }
}
var SortDirection = /* @__PURE__ */ ((SortDirection2) => {
  SortDirection2["Ascending"] = "asc";
  SortDirection2["Descending"] = "desc";
  return SortDirection2;
})(SortDirection || {});
class SortCriterionBuilder {
  constructor() {
    __publicField(this, "criterion");
    this.criterion = [];
  }
  insert(criterion, index = -1) {
    let $index = index < 0 ? this.criterion.length + index + 1 : index;
    $index = Math.min(this.criterion.length, $index);
    this.criterion.splice($index, 0, JSON.parse(JSON.stringify(criterion)));
    return this;
  }
  ascending(subject) {
    return this.insert({
      subject,
      direction: "asc"
      /* Ascending */
    });
  }
  descending(subject) {
    return this.insert({
      subject,
      direction: "desc"
      /* Descending */
    });
  }
  copy(other) {
    this.criterion = JSON.parse(JSON.stringify(other));
    return this;
  }
  build() {
    return JSON.parse(JSON.stringify(this.criterion));
  }
}
function paginate(data, page, size2) {
  if (size2 === Infinity) {
    return page <= 1 ? data : [];
  }
  const $page = Math.max(0, page - 1);
  const pages = chunk(data, size2);
  return pages[$page] || [];
}
function filter(data, filter2, match) {
  const $match = new DataMatchOptional(match);
  return data.filter((item2) => $match.match(item2, filter2));
}
function sort(data, sorts) {
  const $data = data.slice();
  if (!(sorts == null ? void 0 : sorts.length)) {
    return $data;
  }
  $data.sort((x, y) => {
    for (let i = 0; i < sorts.length; ++i) {
      const s = sorts[i];
      const m = s.direction === SortDirection.Ascending ? 1 : -1;
      const xV = s.subject ? get(x, s.subject, null) : x;
      const yV = s.subject ? get(y, s.subject, null) : y;
      if (xV == null && yV == null) {
        continue;
      }
      if (xV == null && yV != null) {
        return -1 * m;
      }
      if (xV != null && yV == null) {
        return m;
      }
      if (xV === yV) {
        continue;
      }
      return m * (xV < yV ? -1 : 1);
    }
    return 0;
  });
  return $data;
}
class DataSourceStatic {
  constructor($data, options = {}) {
    __publicField(this, "$options");
    this.$data = $data;
    this.$options = {
      delay: 0,
      search: new DataSearchFields(),
      filter: new DataFilterFields(),
      ...options
    };
  }
  async count(request) {
    const { search: $search, filter: $filter } = request;
    const data = await this.$data;
    if (data instanceof Error) {
      return new Promise((_, reject) => setTimeout(() => reject(data), this.$options.delay));
    }
    let arr = data;
    arr = filter(arr, $search, this.$options.search);
    arr = filter(arr, $filter, this.$options.filter);
    return new Promise((resolve) => setTimeout(() => resolve(arr.length), this.$options.delay));
  }
  async list(request) {
    const { page = 1, size: size2 = Infinity, search: $search, filter: $filter, sort: $sort } = request;
    const data = await this.$data;
    if (data instanceof Error) {
      return new Promise((_, reject) => setTimeout(() => reject(data), this.$options.delay));
    }
    let arr = data;
    arr = filter(arr, $search, this.$options.search);
    arr = filter(arr, $filter, this.$options.filter);
    arr = sort(arr, $sort);
    arr = paginate(arr, page, size2);
    return new Promise((resolve) => setTimeout(() => resolve(arr), this.$options.delay));
  }
}
const LinkButtonTextMedium = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-link-button-text-medium",
    ...props,
    "data-typography": "LinkButtonTextMedium",
    size: "xs",
    transform: "sentence",
    weight: "semibold"
  }
);
const LinkButtonTextSmall = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-link-button-text-small",
    ...props,
    "data-typography": "LinkButtonTextSmall",
    size: "2xs",
    transform: "sentence",
    weight: "semibold"
  }
);
const linkButton = "GAFE-LinkButton-linkButton";
const disabled_hover_styles = "GAFE-LinkButton-disabled_hover_styles";
const disabled$5 = "GAFE-LinkButton-disabled";
const large$4 = "GAFE-LinkButton-large";
const medium$4 = "GAFE-LinkButton-medium";
const small$4 = "GAFE-LinkButton-small";
const prependIcon = "GAFE-LinkButton-prependIcon";
const appendIcon = "GAFE-LinkButton-appendIcon";
const styles$w = {
  linkButton,
  disabled_hover_styles,
  disabled: disabled$5,
  large: large$4,
  medium: medium$4,
  small: small$4,
  prependIcon,
  appendIcon
};
const SizeToTypographyMap = {
  small: LinkButtonTextSmall,
  medium: LinkButtonTextMedium,
  large: LinkButtonTextMedium
};
const LinkButton = ({
  appendIcon: appendIcon2,
  className,
  disabled: disabled2,
  href,
  onClick,
  prependIcon: prependIcon2,
  ref,
  role,
  size: size2 = "medium",
  target: target2 = "_self",
  testId = "gafe-common-button-link",
  text: text2,
  disableHoverStyles,
  disableUnderline
}) => {
  const css2 = ClassService(
    { link: className },
    {
      link: styles$w.linkButton
    }
  );
  const LinkButtonTypography = SizeToTypographyMap[size2];
  const onHandleClick = useCallback(
    (e) => {
      if (disabled2) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (typeof onClick === "function" && !disabled2) {
        onClick(e);
      }
    },
    [disabled2, onClick]
  );
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: classNames(css2.link, styles$w[size2], {
        [styles$w.disabled]: disabled2,
        [styles$w.disabled_hover_styles]: disableHoverStyles
      }),
      "data-testid": testId,
      href,
      onClick: onHandleClick,
      ref,
      referrerPolicy: "no-referrer",
      role,
      target: target2,
      children: [
        prependIcon2 && /* @__PURE__ */ jsx("span", { className: styles$w.prependIcon, "data-testid": "gafe-link-prefix", children: prependIcon2 }),
        /* @__PURE__ */ jsx(LinkButtonTypography, { decoration: { line: disableUnderline ? "none" : "underline" }, children: text2 }),
        appendIcon2 && /* @__PURE__ */ jsx("span", { className: styles$w.appendIcon, "data-testid": "gafe-link-suffix", children: appendIcon2 })
      ]
    }
  );
};
const root$8 = "GAFE-OptionList-root";
const styles$v = {
  root: root$8
};
function ChoiceOptionList({
  colorSchema,
  options,
  renderOption,
  identifyOption,
  onSelect,
  onRemove
}) {
  return /* @__PURE__ */ jsx("div", { className: styles$v.root, role: "list", children: options.map((option) => {
    const value = identifyOption(option);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        "data-color-schema": colorSchema,
        "data-selectable": Boolean(onSelect),
        "data-value": value,
        onClick: () => onSelect == null ? void 0 : onSelect.call(null, option),
        role: "option",
        children: [
          /* @__PURE__ */ jsx(Grow, { children: renderOption(option) }),
          onRemove && /* @__PURE__ */ jsx(
            LinkButton,
            {
              onClick: () => onRemove.call(null, option),
              role: "deletion",
              text: "Remove"
            }
          )
        ]
      },
      value
    );
  }) });
}
const root$7 = "GAFE-ValueList-root";
const styles$u = {
  root: root$7
};
function ChoiceValueList({
  values,
  multiple,
  placeholder: placeholder2,
  ChipProps: getChipProps,
  ChipCloseProps: getChipCloseProps,
  identifyOption,
  renderValue,
  onRemove
}) {
  const $values = useMemo(() => multiple ? values : values.slice(0, 1), [values, multiple]);
  const handleRemove = useCallback(
    (value, e) => {
      e.stopPropagation();
      onRemove(value);
    },
    [onRemove]
  );
  const renderValueList = () => {
    if ($values.length === 0) {
      return placeholder2;
    }
    return $values.map((value) => {
      const key = identifyOption(value);
      const renderMultiple = () => /* @__PURE__ */ jsx(
        Chip,
        {
          ...getChipProps(value),
          suffix: /* @__PURE__ */ jsx(
            IconCancelOutlined,
            {
              ...getChipCloseProps(value),
              onClick: handleRemove.bind(null, value),
              role: "deletion",
              width: "sm"
            }
          ),
          children: renderValue(value)
        }
      );
      const renderSingle = () => renderValue(value);
      return /* @__PURE__ */ jsx("div", { "data-value": key, role: "listitem", children: multiple ? renderMultiple() : renderSingle() }, key);
    });
  };
  return /* @__PURE__ */ jsx("div", { className: styles$u.root, "data-placeholder": $values.length === 0, role: "list", children: renderValueList() });
}
const root$6 = "GAFE-Select-root";
const loading = "GAFE-Select-loading";
const dropIcon = "GAFE-Select-drop-icon";
const styles$t = {
  root: root$6,
  loading,
  dropIcon
};
const renderAsParagraph = (option) => {
  return /* @__PURE__ */ jsx(Body, { children: String(option) });
};
function ChoiceSelect({
  className,
  colorSchema,
  indelible,
  loading: loading2,
  multiple,
  options,
  placeholder: placeholder2 = /* @__PURE__ */ jsx(Body, { children: "Select an option" }),
  request,
  resolve,
  unresolve,
  value,
  identifyOption = mapToString,
  renderAvailableOption = renderAsParagraph,
  renderSelectedOption = renderAvailableOption,
  renderValue = renderAvailableOption,
  onRequestChange,
  onSelectOptions,
  onValueChange,
  ChipProps = {},
  ChipCloseProps = {},
  DualityIndicatorProps,
  PopupProps,
  SearchProps,
  disabled: disabled2,
  ...props
}) {
  const [open2, setOpen] = useState(false);
  const $open = useMemo(() => setOpen.bind(null, true), []);
  const $close = useMemo(() => setOpen.bind(null, false), []);
  const drop = useRef();
  const [$value, setValue] = useAmbassadorState(value, onValueChange, null);
  const $empty = useMemo(() => new DataRequestBuilder().build(), []);
  const [$request, setRequest] = useAmbassadorState(request, onRequestChange, $empty);
  const $resolve = useMemo(
    () => resolve || new DataResolveIdentity(),
    [resolve]
  );
  const $unresolve = useMemo(
    () => unresolve || new DataResolveIdentity(),
    [unresolve]
  );
  const source = useMemo(() => {
    const $options2 = firstDefined([], options);
    return isArray($options2) ? new DataSourceStatic($options2) : $options2;
  }, [options]);
  const [choices] = useAsyncState(() => source.list($request), [source, $request]);
  const [selectedOptions, _, last] = useAsyncState(
    () => $resolve.resolve(castArray(firstDefined([], $value))),
    [$resolve, $value]
  );
  const $options = firstDefined([], asData(choices));
  const $selectedValues = firstDefined([], last);
  const $loading = loading2 || isDataLoading(choices) || isDataLoading(selectedOptions);
  const $ChipProps = useMemo(() => castFunction(ChipProps), [ChipProps]);
  const $ChipCloseProps = useMemo(() => castFunction(ChipCloseProps), [ChipCloseProps]);
  const availableOptions = useMemo(() => {
    const lookup = new Set($selectedValues.map((op) => identifyOption(op)));
    return $options.filter((option) => !lookup.has(identifyOption(option)));
  }, [identifyOption, $options, $selectedValues]);
  const selectOption = useCallback(
    async (value2) => {
      const next = await $unresolve.resolve([value2]);
      if (multiple) {
        const nextOptions = firstDefined([], last).concat(value2);
        onSelectOptions == null ? void 0 : onSelectOptions.call(null, nextOptions);
        setValue((current) => castArray(firstDefined([], current)).concat(next));
      } else {
        onSelectOptions == null ? void 0 : onSelectOptions.call(null, value2);
        setValue(next[0]);
        setOpen(false);
      }
    },
    [multiple, setValue, $unresolve, last, onSelectOptions]
  );
  const removeOption = useCallback(
    async (value2) => {
      const next = $selectedValues.slice();
      const index = next.indexOf(value2);
      next.splice(index, 1);
      const $next = await $unresolve.resolve(next);
      if (multiple) {
        onSelectOptions == null ? void 0 : onSelectOptions.call(null, next.length ? next : null);
        setValue($next.length ? $next : null);
      } else {
        onSelectOptions == null ? void 0 : onSelectOptions.call(null, first(next) || null);
        setValue(first($next) || null);
      }
    },
    [$selectedValues, setValue, multiple, $unresolve, onSelectOptions]
  );
  const handleSearch = useCallback(
    ({ currentTarget: { value: value2 } }) => setRequest((current) => {
      const search = firstTruthy(void 0, value2);
      const next = new DataRequestBuilder().copy(current);
      return next.search(search).build();
    }),
    [setRequest]
  );
  const header2 = SearchProps === false ? null : /* @__PURE__ */ jsx(Box, { padding: { desktop: "2xs" }, children: /* @__PURE__ */ jsx(
    TextInput,
    {
      suffix: /* @__PURE__ */ jsx(IconSearch, { height: "xs", width: "xs" }),
      ...SearchProps,
      onChange: handleSearch,
      role: "search",
      value: firstDefined("", $request.search)
    }
  ) });
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs(
      Popup,
      {
        ...PopupProps,
        attach: drop.current,
        className: styles$t.popup,
        closeOnBackdropClick: true,
        closeOnEsc: true,
        compact: true,
        onClose: $close,
        open: open2 && !disabled2,
        renderHeader: header2,
        children: [
          /* @__PURE__ */ jsx(
            ChoiceOptionList,
            {
              colorSchema,
              identifyOption,
              onRemove: indelible ? void 0 : removeOption,
              options: $selectedValues,
              renderOption: renderSelectedOption
            }
          ),
          Boolean($selectedValues.length) && /* @__PURE__ */ jsx(Divider, {}),
          /* @__PURE__ */ jsx(
            ChoiceOptionList,
            {
              colorSchema,
              identifyOption,
              onSelect: selectOption,
              options: availableOptions,
              renderOption: renderAvailableOption
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "section",
      {
        className: classNames(styles$t.root, className),
        onClick: $open,
        ref: drop,
        role: "combobox",
        tabIndex: 0,
        ...pickDataAttributes(props),
        "data-color-schema": colorSchema,
        "data-disabled": disabled2,
        "data-multiple": multiple,
        children: /* @__PURE__ */ jsxs(Stack, { align: { items: "flex-start" }, orientation: { desktop: "horizontal" }, children: [
          /* @__PURE__ */ jsx(
            ChoiceValueList,
            {
              ChipCloseProps: $ChipCloseProps,
              ChipProps: $ChipProps,
              identifyOption,
              multiple: Boolean(multiple),
              onRemove: removeOption,
              placeholder: placeholder2,
              renderValue,
              values: $selectedValues
            }
          ),
          /* @__PURE__ */ jsx("div", { className: styles$t.loading, children: /* @__PURE__ */ jsx(
            ProgressSpinner,
            {
              active: Boolean($loading),
              "data-testid": "gafe-choice-loading",
              width: "xs"
            }
          ) }),
          /* @__PURE__ */ jsx(
            DualityIndicator,
            {
              disengaged: /* @__PURE__ */ jsx(IconChevronDown, { className: styles$t.dropIcon, height: "sm", width: "sm" }),
              engaged: /* @__PURE__ */ jsx(IconChevronUp, { className: styles$t.dropIcon, height: "sm", width: "sm" }),
              ...DualityIndicatorProps,
              value: open2
            }
          )
        ] })
      }
    )
  ] });
}
function ChoiceAsync({
  request,
  resolve,
  unresolve,
  source,
  value,
  onRequestChange,
  DropDownProps,
  PopupProps
}) {
  return /* @__PURE__ */ jsx(
    ChoiceSelect,
    {
      ...DropDownProps,
      PopupProps,
      onRequestChange,
      onSelectOptions: DropDownProps == null ? void 0 : DropDownProps.onValueChange,
      onValueChange: void 0,
      options: source,
      request,
      resolve,
      unresolve,
      value
    }
  );
}
function ChoiceDropDown({ hideChevron, ...props }) {
  const chevrons = hideChevron ? { engaged: null, disengaged: null } : {};
  return /* @__PURE__ */ jsx(ChoiceSelect, { ...props, DualityIndicatorProps: chevrons, SearchProps: false });
}
const collapsible = "GAFE-Collapsible-collapsible";
const styles$s = {
  collapsible
};
const Collapsible = ({
  children,
  className,
  isOpened,
  testId = "collapsible-component"
}) => {
  const collapsibleRef = useRef(null);
  const [height, setHeight] = useState(isOpened ? "auto" : 0);
  useEffect(() => {
    if (!height || !isOpened || !collapsibleRef.current) {
      return () => {
      };
    }
    const resizeObserver = new ResizeObserver((childrenElements) => {
      setHeight(childrenElements[0].contentRect.height);
    });
    resizeObserver.observe(collapsibleRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [height, isOpened]);
  useEffect(() => {
    var _a;
    if (isOpened) {
      const collapsibleBoundaries = (_a = collapsibleRef.current) == null ? void 0 : _a.getBoundingClientRect();
      const contentHeight = Number(collapsibleBoundaries == null ? void 0 : collapsibleBoundaries.height);
      setHeight(contentHeight);
    } else {
      setHeight(0);
    }
  }, [isOpened]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles$s.collapsible, className),
      "data-collapsed": !isOpened,
      "data-testid": testId,
      style: {
        height
      },
      children: /* @__PURE__ */ jsx("div", { "data-testid": `${testId}-${isOpened ? "expanded" : "collapsed"}`, ref: collapsibleRef, children })
    }
  );
};
const modal = "GAFE-Modal-modal";
const fade = "GAFE-Modal-fade";
const closing = "GAFE-Modal-closing";
const content$2 = "GAFE-Modal-content";
const close = "GAFE-Modal-close";
const styles$r = {
  modal,
  fade,
  closing,
  content: content$2,
  close
};
const ModalAnimationLengthMs = 155;
function Modal({ height, width, scrollContainer = document.body, ...props }) {
  const overflow = useRef(scrollContainer.style.overflow);
  const modal2 = useRef(null);
  const analytics = useAnalyticsService();
  const handleBeforeOpen = useCallback(() => {
    overflow.current = scrollContainer.style.overflow;
    scrollContainer.style.overflow = "hidden";
    return Promise.resolve();
  }, [scrollContainer]);
  const handleAfterOpen = useCallback(async () => {
    const event = new AnalyticsEventBuilder().component(Modal.metadata.component).name(Modal.metadata.events.open).payload(new AnalyticsPayloadBuilder().dataProps(props).build()).build();
    await analytics.track(event);
  }, [analytics, props]);
  const handleBeforeClose = useCallback(async (dialog) => {
    dialog.classList.add(styles$r.closing);
    await sleep(ModalAnimationLengthMs);
    dialog.classList.remove(styles$r.closing);
  }, []);
  const handleCleanup = useCallback(() => {
    scrollContainer.style.overflow = overflow.current;
    return Promise.resolve();
  }, [scrollContainer]);
  const handleAfterClose = useCallback(async () => {
    handleCleanup();
    const event = new AnalyticsEventBuilder().component(Modal.metadata.component).name(Modal.metadata.events.close).payload(new AnalyticsPayloadBuilder().dataProps(props).build()).build();
    await analytics.track(event);
  }, [handleCleanup, analytics, props]);
  const {
    children,
    className,
    open: open2,
    onClose,
    onKeyDown,
    onClickBackdrop,
    renderHeader,
    renderFooter
  } = useDialog(modal2, props, {
    onBeforeOpen: handleBeforeOpen,
    onBeforeClose: handleBeforeClose,
    onAfterOpen: handleAfterOpen,
    onAfterClose: handleAfterClose,
    onBeforeDestroy: handleCleanup
  });
  return /* @__PURE__ */ jsxs(FullScreen, { children: [
    /* @__PURE__ */ jsx(Backdrop, { hide: !open2, onClick: onClickBackdrop }),
    /* @__PURE__ */ jsxs(
      "dialog",
      {
        className: classNames(styles$r.modal, className),
        role: "dialog",
        ...pickDataAttributes(props),
        "data-height": height,
        "data-width": width,
        onKeyDown,
        ref: modal2,
        children: [
          /* @__PURE__ */ jsx(
            IconCancelOutlined,
            {
              className: styles$r.close,
              "data-testid": "close",
              onClick: onClose,
              width: "lg"
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: styles$r.content, children: [
            /* @__PURE__ */ jsx("header", { "data-testid": "header", children: renderHeader() }),
            /* @__PURE__ */ jsx("article", { "data-testid": "body", children }),
            /* @__PURE__ */ jsx("footer", { "data-testid": "footer", children: renderFooter() })
          ] })
        ]
      }
    )
  ] });
}
Modal.metadata = {
  component: "modal",
  events: {
    open: "open",
    close: "close"
  }
};
const ConfirmationModal = ({
  ModalProps,
  CancelButtonProps,
  ConfirmButtonProps,
  children,
  open: open2,
  onRequestClose,
  onConfirm,
  ...props
}) => {
  const onConfirmButtonClick = useCallback(() => {
    onRequestClose();
    onConfirm();
  }, [onRequestClose, onConfirm]);
  const $renderFooter = useCallback(() => {
    const cancelChildren = (CancelButtonProps == null ? void 0 : CancelButtonProps.children) || "Cancel";
    const confirmChildren = (ConfirmButtonProps == null ? void 0 : ConfirmButtonProps.children) || "Confirm";
    return /* @__PURE__ */ jsxs(
      Stack,
      {
        align: { items: "center" },
        gap: "sm",
        justify: { content: "flex-end" },
        orientation: "horizontal",
        children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              colorSchema: "primary",
              testId: "cancel-button",
              variant: "text",
              ...CancelButtonProps,
              onClick: onRequestClose,
              children: cancelChildren
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              colorSchema: "destructive",
              testId: "confirm-button",
              ...ConfirmButtonProps,
              onClick: onConfirmButtonClick,
              children: confirmChildren
            }
          )
        ]
      }
    );
  }, [CancelButtonProps, ConfirmButtonProps, onRequestClose, onConfirmButtonClick]);
  return /* @__PURE__ */ jsx(
    Modal,
    {
      ...ModalProps,
      onClose: onRequestClose,
      open: open2,
      renderFooter: $renderFooter,
      ...pickDataAttributes(props),
      children
    }
  );
};
const Circle = ({ colour, value = 30, maxValue = 30, size: size2 = 80 }) => {
  const radius = size2 / 2;
  const radiusWithoutStroke = radius - 4;
  const circ = 2 * Math.PI * radiusWithoutStroke;
  const valueAsPercentage = value * (100 / maxValue);
  const strokePct = -(valueAsPercentage * circ) / 100;
  return /* @__PURE__ */ jsx(
    "circle",
    {
      cx: radius,
      cy: radius,
      "data-testid": `circle-${colour}`,
      fill: "transparent",
      r: radiusWithoutStroke,
      stroke: colour,
      strokeDasharray: circ,
      strokeDashoffset: circ - strokePct,
      strokeLinecap: "square",
      strokeWidth: "4px"
    }
  );
};
const countdown_container = "GAFE-Countdown-countdown_container";
const countdown_text = "GAFE-Countdown-countdown_text";
const counter_text = "GAFE-Countdown-counter_text";
const styles$q = {
  countdown_container,
  countdown_text,
  counter_text
};
const Text = ({ topLineText = 30, bottomLineText = "days left" }) => {
  let textColor;
  const topLineNumber = Number(topLineText);
  if (topLineNumber === 0) {
    textColor = "dark";
  } else if (topLineNumber < 6) {
    textColor = "information";
  } else {
    textColor = "information-dark";
  }
  return /* @__PURE__ */ jsxs("g", { className: styles$q.countdown_text, children: [
    /* @__PURE__ */ jsx("foreignObject", { height: "27", width: "23", x: "28.5", y: "14", children: /* @__PURE__ */ jsx(Subtitle2, { TElement: "span", colorSchema: textColor, "data-testid": "countdown-top-text", children: topLineText }) }),
    /* @__PURE__ */ jsx("foreignObject", { height: "18", width: "56", x: "12", y: "40", children: /* @__PURE__ */ jsx(
      Caption2,
      {
        TElement: "span",
        className: classNames(styles$q.counter_text),
        colorSchema: "dark",
        "data-testid": "countdown-bottom-text",
        children: bottomLineText
      }
    ) })
  ] });
};
const limitCount = (counterValue, maxValue, minValue) => {
  const tooLow = !Number.isFinite(Number(counterValue)) || counterValue < minValue;
  const tooHigh = counterValue > maxValue;
  if (tooHigh) {
    return maxValue;
  }
  return tooLow ? minValue : Number(counterValue);
};
const Countdown = ({
  classname,
  colour = "#D9D9D6",
  counterValue = 30,
  maxValue = 30,
  minValue = 0,
  testId = "countdown-container",
  size: size2 = 80,
  bottomLineText
}) => {
  const validValue = limitCount(counterValue, maxValue, minValue);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles$q.countdown_container, classname == null ? void 0 : classname.container),
      "data-testid": testId,
      children: /* @__PURE__ */ jsxs("svg", { height: size2, viewBox: `0 0 ${size2} ${size2}`, width: size2, children: [
        /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(Circle, { colour: "#D9D9D6", size: size2 }),
          /* @__PURE__ */ jsx(Circle, { colour, size: size2, value: validValue })
        ] }),
        /* @__PURE__ */ jsx(
          Text,
          {
            bottomLineText,
            textClasses: classname == null ? void 0 : classname.text,
            topLineText: validValue
          }
        )
      ] })
    }
  );
};
class AnalyticsServiceInject {
  /**
   * Initializes a new instance of this object.
   *
   * @param data -
   *        The data to merge into the payload.
   * @param $forward -
   *        The analytics service to forward the updated
   *        event to.
   */
  constructor(data, $forward) {
    this.data = data;
    this.$forward = $forward;
  }
  track(event) {
    const payload = new AnalyticsPayloadBuilder().copy(event.payload).merge(this.data).build();
    const injected = new AnalyticsEventBuilder().copy(event).payload(payload).build();
    return this.$forward.track(injected);
  }
}
function DataBucket({ data, children }) {
  const analytics = useAnalyticsService();
  const inject = useMemo(() => new AnalyticsServiceInject(data, analytics), [analytics, data]);
  return /* @__PURE__ */ jsx(AnalyticsServiceContext.Provider, { value: inject, children });
}
function IconRefresh(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-refresh",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "m4.5,18.61c-1.61-1.83-2.5-4.18-2.5-6.61h2c0,1.95.71,3.83,2,5.29,1.29,1.46,3.07,2.4,5,2.65,1.93.24,3.89-.23,5.5-1.32,1.61-1.09,2.77-2.74,3.25-4.63.48-1.89.26-3.89-.62-5.62-.88-1.74-2.37-3.09-4.18-3.81-1.81-.72-3.82-.75-5.65-.09-1.4.5-2.62,1.38-3.53,2.53h2.24v2H2V3h2v3c1.17-1.55,2.77-2.74,4.61-3.41,2.29-.82,4.8-.79,7.07.11,2.26.9,4.12,2.59,5.23,4.76,1.11,2.17,1.38,4.67.78,7.03-.61,2.36-2.05,4.42-4.07,5.78-2.01,1.37-4.46,1.96-6.87,1.65-2.42-.31-4.64-1.48-6.25-3.31Z" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" })
      ] })
    }
  );
}
IconRefresh.displayName = "Refresh";
var MetadataType = /* @__PURE__ */ ((MetadataType2) => {
  MetadataType2["Text"] = "text";
  MetadataType2["Lookup"] = "lookup";
  MetadataType2["Custom"] = "custom";
  return MetadataType2;
})(MetadataType || {});
class MetadataBuilder {
  constructor() {
    __publicField(this, "$metadata");
    this.$metadata = {
      id: "",
      name: "",
      type: "text"
      /* Text */
    };
  }
  id(id) {
    this.$metadata.id = id;
    return this;
  }
  path(path) {
    this.$metadata.path = path;
    return this;
  }
  name(name) {
    this.$metadata.name = name;
    return this;
  }
  description(value) {
    this.$metadata.description = value;
    return this;
  }
  hidden(hide = true) {
    this.$metadata.hidden = hide;
    return this;
  }
  identity(identity = true) {
    this.$metadata.identity = identity;
    return this;
  }
  type(type) {
    this.$metadata.type = type;
    return this;
  }
  text() {
    return this.type(
      "text"
      /* Text */
    );
  }
  lookup(dictionary) {
    this.$metadata.dictionary = dictionary;
    return this.type(
      "lookup"
      /* Lookup */
    );
  }
  custom(render) {
    this.$metadata.render = render;
    return this.type(
      "custom"
      /* Custom */
    );
  }
  copy(other) {
    this.$metadata = { ...other };
    return this;
  }
  build() {
    return { ...this.$metadata };
  }
}
const Grid = ({
  align,
  children,
  className,
  columns,
  gap,
  justify,
  ...props
}) => {
  const media = useDeviceDetection();
  const $columns = useMemo(() => new DeviceValues(columns), [columns]);
  const $gap = useRectangle("none", media, gap);
  const style = useMemo(
    () => ({
      alignContent: align == null ? void 0 : align.content,
      alignItems: align == null ? void 0 : align.items,
      display: "grid",
      rowGap: `var(--gap-${$gap.top})`,
      columnGap: `var(--gap-${$gap.left})`,
      gridTemplateColumns: $columns.select(media),
      justifyContent: justify == null ? void 0 : justify.content,
      justifyItems: justify == null ? void 0 : justify.items
    }),
    [$columns, $gap, media, align, justify]
  );
  return /* @__PURE__ */ jsx("div", { className, "data-testid": "gafe-grid", style, ...pickDataAttributes(props), children });
};
const GridSpan = ({
  children,
  className,
  columnStart = { desktop: void 0 },
  columnEnd = { desktop: void 0 }
}) => {
  const device = useDeviceDetection();
  const $columnStart = useMemo(() => new DeviceValues(columnStart), [columnStart]);
  const $columnEnd = useMemo(() => new DeviceValues(columnEnd), [columnEnd]);
  const $style = useMemo(
    () => ({
      gridColumnStart: $columnStart.select(device),
      gridColumnEnd: $columnEnd.select(device)
    }),
    [$columnStart, $columnEnd, device]
  );
  return /* @__PURE__ */ jsx("div", { className: classNames(className), style: $style, children });
};
const list$1 = "GAFE-List-list";
const listItem = "GAFE-List-listItem";
const styles$p = {
  list: list$1,
  listItem
};
function List({ className, children, ...props }) {
  return /* @__PURE__ */ jsx("div", { className: classNames(styles$p.list, className), ...pickDataAttributes(props), role: "list", children });
}
function ListItem({ className, children, row, ...props }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles$p.listItem, className),
      ...pickDataAttributes(props),
      "data-row": row,
      role: "listitem",
      children
    }
  );
}
const table = "GAFE-Table-table";
const styles$o = {
  table
};
function Table({ className, children, ...props }) {
  return /* @__PURE__ */ jsx(
    "table",
    {
      className: classNames(styles$o.table, className),
      ...pickDataAttributes(props),
      role: "table",
      children
    }
  );
}
function TableBody({ className, children, ...props }) {
  return /* @__PURE__ */ jsx(
    "tbody",
    {
      className,
      ...pickDataAttributes(props),
      "aria-label": "table-body",
      role: "rowgroup",
      children
    }
  );
}
function TableCell({
  className,
  children,
  column,
  row,
  colSpan,
  rowSpan,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "td",
    {
      className,
      ...pickDataAttributes(props),
      colSpan,
      "data-column": column,
      "data-row": row,
      role: "cell",
      rowSpan,
      children
    }
  );
}
function TableHead({ className, children, ...props }) {
  return /* @__PURE__ */ jsx("thead", { className, ...pickDataAttributes(props), role: "rowgroup", children });
}
function TableHeader({ className, children, column, ...props }) {
  return /* @__PURE__ */ jsx(
    "th",
    {
      className,
      ...pickDataAttributes(props),
      "data-column": column,
      role: "columnheader",
      children
    }
  );
}
function TableRow({ className, children, row, ...props }) {
  return /* @__PURE__ */ jsx("tr", { className, ...pickDataAttributes(props), "data-row": row, role: "row", children });
}
const ColumnHeader = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-column-header",
    ...props,
    "data-typography": "ColumnHeader",
    size: "2xs",
    transform: "uppercase",
    weight: "regular"
  }
);
const ColumnLabel = ColumnHeader;
function DataTabular({
  hideRefresh,
  metadata = [],
  request,
  source,
  onRequestChange,
  renderHeaderLeft,
  TableProps,
  ListProps,
  ...props
}) {
  const $source = useMemo(() => source || new DataSourceStatic([]), [source]);
  const [$request, $setRequest] = useAmbassadorState(
    request,
    onRequestChange,
    new DataRequestBuilder().build()
  );
  const [view] = useAsyncState(() => $source.list($request), [$request, $source]);
  const headers = useMemo(() => metadata.filter((m) => !m.hidden), [metadata]);
  const identity = useMemo(() => first(metadata.filter((m) => m.identity)), [metadata]);
  const getRowId = (row) => {
    return (identity == null ? void 0 : identity.path) ? get(row, identity.path) : String(row);
  };
  const renderTableHeader = (header2) => {
    return /* @__PURE__ */ jsx(TableHeader, { column: header2.id, children: /* @__PURE__ */ jsxs(Stack, { align: { items: "center" }, gap: "2xs", orientation: "horizontal", children: [
      /* @__PURE__ */ jsx(ColumnHeader, { children: header2.name }),
      /* @__PURE__ */ jsx(Hidden, { on: { desktop: Boolean(!header2.description), mobile: true }, children: header2.description })
    ] }) }, header2.id);
  };
  const renderCell = (row, cell) => {
    const { path, dictionary, render } = cell;
    const value = path ? get(row, path) : String(row);
    if (cell.type === MetadataType.Text) {
      return /* @__PURE__ */ jsx(Body, { children: value });
    }
    if (cell.type === MetadataType.Lookup) {
      return /* @__PURE__ */ jsx(Body, { children: get(dictionary, value, value) });
    }
    return render == null ? void 0 : render.call(null, value, row);
  };
  const renderListRows = () => {
    if (isDataLoading(view)) {
      return /* @__PURE__ */ jsx(ListItem, { row: "loading", children: /* @__PURE__ */ jsx(ProgressSpinner, { "data-testid": "data-view-loading" }) });
    }
    if (isDataErrored(view)) {
      return /* @__PURE__ */ jsx(ListItem, { row: "error", children: /* @__PURE__ */ jsx(Body, { "data-testid": "data-view-error", children: view.message }) });
    }
    return view.map((row) => {
      const rowId = getRowId(row);
      const renderLabeledCell = (header2) => {
        const { id: headerId, name } = header2;
        const value = /* @__PURE__ */ jsx("div", { "data-column": headerId, "data-row": rowId, children: renderCell(row, header2) });
        if (name) {
          return /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsxs(ColumnHeader, { children: [
              name,
              ": "
            ] }),
            value
          ] }, `row-${rowId}-column-${headerId}`);
        }
        return /* @__PURE__ */ jsx(
          GridSpan,
          {
            columnEnd: { desktop: 3 },
            columnStart: { desktop: 1 },
            children: value
          },
          `row-${rowId}-column-${headerId}`
        );
      };
      return /* @__PURE__ */ jsx(ListItem, { row: rowId, children: /* @__PURE__ */ jsx(
        Grid,
        {
          align: { items: "center" },
          columns: { desktop: "auto 1fr" },
          gap: { y: "3xs", x: "sm" },
          children: headers.map(renderLabeledCell)
        }
      ) }, rowId);
    });
  };
  const renderTableRows = () => {
    if (isDataLoading(view)) {
      return /* @__PURE__ */ jsx(TableRow, { row: "loading", children: /* @__PURE__ */ jsx(TableCell, { colSpan: headers.length, column: "loading", row: "loading", children: /* @__PURE__ */ jsx(ProgressSpinner, { "data-testid": "data-view-loading" }) }) });
    }
    if (isDataErrored(view)) {
      return /* @__PURE__ */ jsx(TableRow, { row: "error", children: /* @__PURE__ */ jsx(TableCell, { colSpan: headers.length, column: "error", row: "error", children: /* @__PURE__ */ jsx(Body, { "data-testid": "data-view-error", children: view.message }) }) });
    }
    return view.map((row) => {
      const id = getRowId(row);
      return /* @__PURE__ */ jsx(TableRow, { row: id, children: headers.map((h) => /* @__PURE__ */ jsx(TableCell, { column: h.id, row: id, children: renderCell(row, h) }, `row-${id}-column-${h.id}`)) }, id);
    });
  };
  const handleRefresh = useCallback(() => {
    $setRequest(new DataRequestBuilder().copy($request).build());
  }, [$setRequest, $request]);
  return /* @__PURE__ */ jsxs(Stack, { "data-testid": "data-view", gap: "xl", orientation: "vertical", ...pickDataAttributes(props), children: [
    /* @__PURE__ */ jsxs(
      Stack,
      {
        align: { items: "flex-end" },
        "data-testid": "data-view-header",
        gap: "3xs",
        orientation: "horizontal",
        children: [
          /* @__PURE__ */ jsx(Grow, { children: renderHeaderLeft == null ? void 0 : renderHeaderLeft.call(null) }),
          /* @__PURE__ */ jsx(Hidden, { on: { desktop: Boolean(hideRefresh) }, children: /* @__PURE__ */ jsx(
            Button,
            {
              colorSchema: "primary",
              disabled: isDataLoading(view),
              onClick: handleRefresh,
              testId: "data-view-header-refresh",
              children: /* @__PURE__ */ jsx(IconRefresh, { width: "md" })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Hidden, { on: { desktop: true, mobile: false }, children: /* @__PURE__ */ jsx(List, { ...ListProps, children: renderListRows() }) }),
    /* @__PURE__ */ jsx(Hidden, { on: { desktop: false, mobile: true }, children: /* @__PURE__ */ jsxs(Table, { ...TableProps, children: [
      /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsx(TableRow, { row: "columns", children: headers.map(renderTableHeader) }) }),
      /* @__PURE__ */ jsx(TableBody, { children: renderTableRows() })
    ] }) })
  ] });
}
function IconInfoFilled(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-info-filled",
      ...icon2,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "m10,0c5.52,0,10,4.48,10,10s-4.48,10-10,10S0,15.52,0,10,4.48,0,10,0Zm-1,14h1.92v-4.98h-1.92v4.98Zm0-5.98h1.92v-1.99h-1.92v1.99Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      ) })
    }
  );
}
IconInfoFilled.displayName = "InfoFilled";
const SelectContext = createContext({});
class DropdownLabelFormatter {
  static parseLabel(dropdownItemString) {
    return JSON.parse(dropdownItemString);
  }
  static stringifyLabel(dropdownLabelObject) {
    return JSON.stringify(dropdownLabelObject);
  }
  static getFormattedLabelsArray(refArray) {
    return refArray.filter((item2) => item2 !== null).map((labelString) => this.parseLabel(labelString));
  }
}
const wrapper$6 = "GAFE-Option-wrapper";
const disabled$4 = "GAFE-Option-disabled";
const active = "GAFE-Option-active";
const large$3 = "GAFE-Option-large";
const multiselect = "GAFE-Option-multiselect";
const checkbox = "GAFE-Option-checkbox";
const medium$3 = "GAFE-Option-medium";
const checkMark = "GAFE-Option-checkMark";
const small$3 = "GAFE-Option-small";
const checkboxWrapper = "GAFE-Option-checkboxWrapper";
const divider = "GAFE-Option-divider";
const styles$n = {
  wrapper: wrapper$6,
  disabled: disabled$4,
  active,
  large: large$3,
  multiselect,
  checkbox,
  medium: medium$3,
  checkMark,
  small: small$3,
  checkboxWrapper,
  divider
};
const Option = ({
  label: label2,
  checkMark: checkMark2,
  classes,
  disabled: disabled2 = false,
  divider: divider2 = false,
  onClick,
  size: size2,
  text: text2
}) => {
  const formattedLabel = DropdownLabelFormatter.stringifyLabel({ id: label2, label: text2 ?? label2 });
  const {
    activeIndex,
    allIndicesSelected,
    getItemProps,
    handleSelect,
    isIndexBased,
    isMultiselect,
    parentSize,
    selectedIndices,
    withCheckMark
  } = useContext(SelectContext);
  const css2 = ClassService(classes, {
    wrapper: styles$n.wrapper,
    label: styles$n.label
  });
  const { ref, index } = useListItem({ label: formattedLabel });
  const optionLabel = text2 ?? label2;
  const stringifiedIndex = index.toLocaleString();
  const isActive = activeIndex === index;
  const isSelected = isMultiselect && index === 0 ? allIndicesSelected : Boolean(selectedIndices.includes(isIndexBased ? stringifiedIndex : label2));
  const highlightedOption = isIndexBased ? isActive : isSelected;
  const onOptionClick = useCallback(() => {
    if (!disabled2) {
      const selectedOption = DropdownLabelFormatter.parseLabel(formattedLabel);
      handleSelect(stringifiedIndex, selectedOption);
      if (typeof onClick === "function") {
        onClick();
      }
    }
  }, [disabled2, formattedLabel, handleSelect, stringifiedIndex, onClick]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(css2.wrapper, styles$n[size2 ?? parentSize ?? "medium"], {
        [styles$n.multiselect]: isMultiselect,
        [styles$n.active]: highlightedOption && !disabled2,
        [styles$n.disabled]: disabled2,
        [styles$n.divider]: divider2
      }),
      ref,
      role: "option",
      tabIndex: isActive ? 0 : -1,
      ...getItemProps({
        onClick: onOptionClick
      }),
      "data-testid": `dropdown-option-${label2}`,
      children: [
        isMultiselect && /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: isSelected,
            classes: { wrapper: styles$n.checkboxWrapper, checkmark: styles$n.checkbox },
            disabled: disabled2
          }
        ),
        /* @__PURE__ */ jsx("span", { className: classNames(css2.label), children: optionLabel }),
        (checkMark2 ?? (isSelected && withCheckMark)) && /* @__PURE__ */ jsx(IconCheckMark, { width: "md" })
      ]
    }
  );
};
Option.displayName = "Dropdown.Option";
const label$1 = "GAFE-Dropdown-label";
const large$2 = "GAFE-Dropdown-large";
const medium$2 = "GAFE-Dropdown-medium";
const small$2 = "GAFE-Dropdown-small";
const error$1 = "GAFE-Dropdown-error";
const disabled$3 = "GAFE-Dropdown-disabled";
const required$1 = "GAFE-Dropdown-required";
const wrapper$5 = "GAFE-Dropdown-wrapper";
const opened = "GAFE-Dropdown-opened";
const placeholder = "GAFE-Dropdown-placeholder";
const dropdown_icon = "GAFE-Dropdown-dropdown_icon";
const helper$1 = "GAFE-Dropdown-helper";
const listWrapper = "GAFE-Dropdown-listWrapper";
const styles$m = {
  label: label$1,
  large: large$2,
  medium: medium$2,
  small: small$2,
  error: error$1,
  disabled: disabled$3,
  required: required$1,
  wrapper: wrapper$5,
  opened,
  placeholder,
  dropdown_icon,
  helper: helper$1,
  listWrapper
};
const Dropdown = ({
  children,
  classes,
  defaultValue,
  disabled: disabled2 = false,
  dropdownIcon,
  error: error2 = false,
  helper: helper2,
  hideIcon = false,
  isIndexBased: indexMode,
  isLoading,
  isMultiselect,
  label: label2,
  multiselectOpts = {},
  onBlur,
  onMultiSelect = () => {
  },
  onSelect = () => {
  },
  placeholder: placeholder2 = "Select an option",
  placement = "bottom-start",
  setDropdownAsOpen,
  showHelperIcon = false,
  showRequired = false,
  size: size$1 = "medium",
  testId = "gafe-common-dropdown",
  tooltip,
  withCheckMark,
  borderless = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { selectAllLabel = "Select all", selectedLabelsPrefix = "" } = multiselectOpts;
  const isIndexBased = indexMode ?? true;
  const css2 = ClassService(classes, {
    label: styles$m.label,
    wrapper: styles$m.wrapper,
    listWrapper: styles$m.listWrapper,
    helper: styles$m.helper
  });
  const { refs, floatingStyles, context } = useFloating({
    placement,
    open: isOpen,
    onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset$1(4),
      flip(),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`
          });
        }
      })
    ]
  });
  const elementsRef = useRef([]);
  const labelsRef = useRef([]);
  const click = useClick(context);
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "listbox" });
  useEffect(() => {
    if (defaultValue) {
      if (isIndexBased && typeof defaultValue === "string") {
        setSelectedLabels([defaultValue]);
      } else if (Array.isArray(defaultValue)) {
        const initialIndices = defaultValue.map((option) => option.id);
        const initialLabels = defaultValue.map((option) => option.label);
        setSelectedIndices(initialIndices);
        setSelectedLabels(initialLabels);
      }
    }
  }, [defaultValue]);
  useEffect(() => {
    if (setDropdownAsOpen) {
      setDropdownAsOpen(isOpen);
    }
  }, [isOpen]);
  const handleSelect = useCallback(
    (index, selectedOption) => {
      const selectedIndex = isIndexBased ? index : selectedOption.id;
      if (!isMultiselect) {
        setIsOpen(false);
        if (!disabled2) {
          const selectedLabel = selectedOption.label;
          setSelectedIndices([selectedIndex]);
          setSelectedLabels([selectedLabel]);
          onSelect(selectedLabel);
        }
      } else if (!disabled2 && Number(index) !== 0 && !isIndexBased) {
        const allSelectableLabels = DropdownLabelFormatter.getFormattedLabelsArray(
          labelsRef.current
        ).filter((_, index2) => index2 > 0);
        const newSelectedIndices = selectedIndices.includes(selectedIndex) ? selectedIndices.filter((optionIndex) => optionIndex !== selectedIndex) : [...selectedIndices, selectedIndex];
        setSelectedIndices(newSelectedIndices);
        setSelectAll(newSelectedIndices.length === allSelectableLabels.length);
        const newSelectedLabels = newSelectedIndices.map(
          (labelIndex) => allSelectableLabels.filter((option) => option.id === labelIndex)[0].label
        );
        setSelectedLabels(newSelectedLabels);
        onMultiSelect(newSelectedIndices);
      }
    },
    [isMultiselect, disabled2, isIndexBased, onSelect, selectedIndices, onMultiSelect]
  );
  const handleSelectAll = useCallback(() => {
    if (selectAll) {
      setSelectedIndices([]);
      setSelectedLabels([]);
      setSelectAll(false);
      onMultiSelect([]);
    } else {
      const allSelectableLabels = DropdownLabelFormatter.getFormattedLabelsArray(
        labelsRef.current
      ).filter((_, index) => index > 0);
      const allIndices = allSelectableLabels.map(({ id }) => id);
      const allLabels = allSelectableLabels.map(({ label: label22 }) => label22);
      setSelectedIndices(allIndices);
      setSelectedLabels(allLabels);
      setSelectAll(true);
      onMultiSelect(allIndices);
    }
  }, [selectAll, onMultiSelect]);
  const listNav = useListNavigation(context, {
    listRef: elementsRef,
    activeIndex,
    selectedIndex: isIndexBased ? Number(selectedIndices[0]) : null,
    onNavigate: setActiveIndex,
    loop: true
  });
  const typeahead = useTypeahead(context, {
    listRef: labelsRef,
    activeIndex,
    selectedIndex: isIndexBased ? Number(selectedIndices[0]) : null
  });
  const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
    listNav,
    typeahead,
    click,
    dismiss,
    role
  ]);
  const selectContext = useMemo(
    () => ({
      activeIndex,
      allIndicesSelected: selectAll,
      getItemProps,
      handleSelect,
      isIndexBased,
      isMultiselect,
      parentSize: size$1,
      selectedIndices,
      withCheckMark
    }),
    [
      activeIndex,
      selectAll,
      getItemProps,
      handleSelect,
      isIndexBased,
      isMultiselect,
      size$1,
      selectedIndices,
      withCheckMark
    ]
  );
  const dropdownLabel = useMemo(() => {
    if (selectedLabels.length) {
      if (isMultiselect && selectedLabels.length > 1) {
        return [selectedLabels.length.toLocaleString(), selectedLabelsPrefix, "selected"].join(" ");
      }
      return selectedLabels[0];
    }
    return placeholder2;
  }, [isMultiselect, placeholder2, selectedLabels, selectedLabelsPrefix]);
  const getIcon = () => {
    if (hideIcon) {
      return null;
    }
    if (isLoading) {
      return /* @__PURE__ */ jsx(ProgressSpinner, { "data-testid": "gafe-common-dropdown-spinner", width: "sm" });
    }
    if (dropdownIcon) {
      return dropdownIcon;
    }
    return /* @__PURE__ */ jsx(
      IconChevronDown,
      {
        className: classNames(styles$m.dropdown_icon, styles$m[size$1], {
          [styles$m.opened]: isOpen && !disabled2
        })
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    label2 && /* @__PURE__ */ jsxs(
      Stack,
      {
        align: { items: "center" },
        className: classNames(css2.label, styles$m[size$1], {
          [styles$m.disabled]: disabled2,
          [styles$m.required]: showRequired
        }),
        orientation: "horizontal",
        children: [
          /* @__PURE__ */ jsx("span", { children: label2 }),
          " ",
          /* @__PURE__ */ jsx(Stack, { children: tooltip == null ? void 0 : tooltip.icon })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "section",
      {
        className: classNames(css2.wrapper, styles$m[size$1], {
          [styles$m.error]: error2,
          [styles$m.disabled]: disabled2,
          [styles$m.opened]: isOpen && !disabled2
        }),
        ref: refs.setReference,
        tabIndex: 0,
        ...getReferenceProps(),
        "data-borderless": borderless,
        "data-testid": testId,
        onBlur,
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: classNames(
                {
                  [styles$m.placeholder]: !selectedLabels.length
                },
                classes == null ? void 0 : classes.dropdownValue
              ),
              children: dropdownLabel
            }
          ),
          getIcon()
        ]
      }
    ),
    helper2 && /* @__PURE__ */ jsxs(
      "span",
      {
        className: classNames(css2.helper, styles$m[size$1], {
          [styles$m.error]: error2,
          [styles$m.disabled]: disabled2
        }),
        children: [
          showHelperIcon && /* @__PURE__ */ jsx(IconInfoFilled, {}),
          helper2
        ]
      }
    ),
    /* @__PURE__ */ jsx(SelectContext.Provider, { value: selectContext, children: isOpen && !disabled2 && /* @__PURE__ */ jsx(FloatingPortal, { children: /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames(css2.listWrapper),
        ref: refs.setFloating,
        style: floatingStyles,
        ...getFloatingProps(),
        children: /* @__PURE__ */ jsxs(FloatingList, { elementsRef, labelsRef, children: [
          isMultiselect && /* @__PURE__ */ jsx(Option, { divider: true, label: selectAllLabel, onClick: handleSelectAll }),
          children
        ] })
      }
    ) }) })
  ] });
};
Dropdown.Option = Option;
function IconCalendarOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-calendar-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6 4.5H8V5.5H16V4.5H18V5.5H22V20.5H2V5.5H6V4.5ZM16 7.5V8.5H18V7.5H20V9.5H4V7.5H6V8.5H8V7.5H16ZM4 18.5V11.5H20V18.5H4Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconCalendarOutlined.displayName = "CalendarOutlined";
var DateFormats = /* @__PURE__ */ ((DateFormats2) => {
  DateFormats2["DataBase"] = "yyyy-MM-dd HH:mm:ss.SSS";
  DateFormats2["UTC"] = "yyyy-MM-dd 00:00:00.000";
  DateFormats2["NumericUS"] = "MMM-dd";
  DateFormats2["Report"] = "M-d-yy";
  return DateFormats2;
})(DateFormats || {});
const formatDate = (date, dateFormat = DateFormats.NumericUS, timeZone = "Etc/UCT") => {
  if (!date || !isValid(date)) {
    return "Invalid Date";
  }
  switch (dateFormat) {
    case DateFormats.DataBase:
      return (format(date, DateFormats.DataBase) + "Z").replace(" ", "T");
    case DateFormats.UTC:
      return (formatInTimeZone(date, timeZone, DateFormats.UTC) + "Z").replace(" ", "T");
    case DateFormats.Report:
      return format(date, DateFormats.Report);
    default:
      return formatInTimeZone(date, timeZone, dateFormat);
  }
};
const convertDateToUTC = (date) => {
  return addMinutes(new Date(formatDate(date, DateFormats.UTC)), (/* @__PURE__ */ new Date()).getTimezoneOffset());
};
const root$5 = "GAFE-LegendKey-root";
const square = "GAFE-LegendKey-square";
const styles$l = {
  root: root$5,
  square
};
const LegendTypography = Caption;
const LegendKey = ({ className, colorSchema, children, ...props }) => {
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      align: { items: "center" },
      className: classNames(styles$l.root, className),
      "data-testid": "gafe-legend-key",
      gap: "2xs",
      orientation: "horizontal",
      ...pickDataAttributes(props),
      children: [
        /* @__PURE__ */ jsx(LegendTypography, { TElement: "span", display: "inline-flex", children: /* @__PURE__ */ jsx("div", { className: styles$l.square, "data-color-schema": colorSchema }) }),
        /* @__PURE__ */ jsx(LegendTypography, { TElement: "div", display: "inline-flex", children })
      ]
    }
  );
};
const Legend = ({ className, children, ...props }) => {
  return /* @__PURE__ */ jsx(
    Stack,
    {
      align: { items: "center" },
      className,
      "data-testid": "gafe-legend",
      gap: "2xs",
      justify: { content: "space-between" },
      orientation: "horizontal",
      ...pickDataAttributes(props),
      children
    }
  );
};
Legend.Key = LegendKey;
const SATURDAY = 6;
const SUNDAY = 0;
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const DEFAULT_YEARS = range(getYear(/* @__PURE__ */ new Date()), getYear(/* @__PURE__ */ new Date()) + 3, 1);
const getDropdownSize = (size2) => {
  switch (size2) {
    case "extra-large":
      return "large";
    case "small":
      return "small";
    default:
      return "medium";
  }
};
const dropdown_wrapper = "GAFE-Datepicker-dropdown_wrapper";
const dropdown_list_wrapper = "GAFE-Datepicker-dropdown_list_wrapper";
const months_list = "GAFE-Datepicker-months_list";
const small$1 = "GAFE-Datepicker-small";
const medium$1 = "GAFE-Datepicker-medium";
const large$1 = "GAFE-Datepicker-large";
const dropdown_value = "GAFE-Datepicker-dropdown_value";
const wrapper$4 = "GAFE-Datepicker-wrapper";
const label = "GAFE-Datepicker-label";
const error = "GAFE-Datepicker-error";
const required = "GAFE-Datepicker-required";
const input = "GAFE-Datepicker-input";
const open = "GAFE-Datepicker-open";
const icon$1 = "GAFE-Datepicker-icon";
const backdrop = "GAFE-Datepicker-backdrop";
const mobile_close = "GAFE-Datepicker-mobile_close";
const date_picker_custom_header = "GAFE-Datepicker-date_picker_custom_header";
const GAFEDropdownDisabled = "GAFE-Datepicker-GAFE-Dropdown-disabled";
const month = "GAFE-Datepicker-month";
const extra_large = "GAFE-Datepicker-extra_large";
const helper = "GAFE-Datepicker-helper";
const styles$k = {
  dropdown_wrapper,
  dropdown_list_wrapper,
  months_list,
  small: small$1,
  medium: medium$1,
  large: large$1,
  dropdown_value,
  wrapper: wrapper$4,
  label,
  error,
  required,
  input,
  open,
  icon: icon$1,
  backdrop,
  mobile_close,
  date_picker_custom_header,
  GAFEDropdownDisabled,
  month,
  extra_large,
  helper
};
const Datepicker = ({
  children,
  classes,
  deliveryDate,
  installDate,
  maxDate,
  minDate,
  onChange,
  onClickOutside,
  onFocus,
  onInputClick,
  availableLegend = "Available",
  deliveryDateLegend = "Delivery",
  disableWeekends = false,
  highlightDates = [],
  installDateLegend = "Install",
  placeholderText = "Select a date",
  rangeYears = DEFAULT_YEARS,
  showLegends = true,
  size: size2 = "large",
  label: label2 = "",
  showRequired = false,
  errorMessage,
  hasError = false,
  helperText = "",
  ...restProps
}) => {
  const legends = [];
  const dropdownSize = getDropdownSize(size2);
  const conditionalProps = {};
  const datePickerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [year, setYear] = useState(getYear(/* @__PURE__ */ new Date()));
  const css2 = ClassService(classes, {
    icon: styles$k.icon,
    label: styles$k.label,
    input: styles$k.input,
    wrapper: styles$k.wrapper
  });
  const showErrorMessage = hasError && Boolean(errorMessage);
  const shouldRenderHelperText = Boolean(helperText) || showErrorMessage;
  const openDatepicker = () => {
    setIsOpen(true);
    document.body.classList.add("datepicker-open");
  };
  const closeDatepicker = useCallback(() => {
    setIsOpen(false);
    document.body.classList.remove("datepicker-open");
  }, []);
  const toggleDatepicker = useCallback(() => {
    if (isOpen) {
      closeDatepicker();
    } else {
      openDatepicker();
    }
  }, [closeDatepicker, isOpen]);
  const handleChange = useCallback(
    (date, event) => {
      closeDatepicker();
      if (typeof onChange === "function") {
        onChange(date, event);
      }
    },
    [closeDatepicker, onChange]
  );
  const handleClickOutside = useCallback(
    (event) => {
      const dropdownElement = event.target;
      const isDropdownOption = dropdownElement.classList.contains("GAFE-Option-wrapper");
      const isDropdownList = dropdownElement.classList.contains("GAFE-Dropdown-listWrapper");
      if (isDropdownOption || isDropdownList) {
        return;
      }
      closeDatepicker();
      onClickOutside == null ? void 0 : onClickOutside(event);
    },
    [closeDatepicker, onClickOutside]
  );
  const handleInputClick = useCallback(() => {
    toggleDatepicker();
    onInputClick == null ? void 0 : onInputClick();
  }, [onInputClick, toggleDatepicker]);
  const handleFocus = useCallback(
    (event) => {
      event.target.blur();
      onFocus == null ? void 0 : onFocus(event);
    },
    [onFocus]
  );
  useEffect(() => {
    var _a;
    if (datePickerRef.current) {
      (_a = datePickerRef.current.input) == null ? void 0 : _a.setAttribute("data-testid", "date-picker-input");
    }
  }, [datePickerRef]);
  if (disableWeekends) {
    conditionalProps.filterDate = (date) => {
      const day = getDay(date);
      return day !== SUNDAY && day !== SATURDAY;
    };
  }
  const onSelectDropdown = useCallback(
    (fn) => (value) => {
      fn(value);
    },
    []
  );
  const customHeader = useCallback(
    ({ date, changeYear, changeMonth }) => /* @__PURE__ */ jsxs("div", { className: styles$k.date_picker_custom_header, children: [
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          classes: { wrapper: styles$k.dropdown_wrapper, dropdownValue: styles$k.dropdown_value },
          onSelect: onSelectDropdown((value) => {
            const selectedYear = Number.parseInt(value ?? "", 10);
            changeYear(selectedYear);
            setYear(selectedYear);
          }),
          placeholder: year.toString(),
          size: dropdownSize,
          testId: "year-dropdown",
          children: rangeYears.map((option) => /* @__PURE__ */ jsx(Dropdown.Option, { label: option.toString(), size: dropdownSize }, option))
        }
      ),
      /* @__PURE__ */ jsx(
        Dropdown,
        {
          classes: {
            wrapper: classNames(styles$k.dropdown_wrapper, styles$k.month),
            dropdownValue: classNames(styles$k.dropdown_value),
            listWrapper: classNames(
              styles$k.dropdown_list_wrapper,
              styles$k[dropdownSize],
              styles$k.months_list
            )
          },
          onSelect: onSelectDropdown((value) => {
            changeMonth(MONTHS.indexOf(value ?? ""));
            changeYear(year);
          }),
          placeholder: MONTHS[getMonth(date)],
          size: dropdownSize,
          testId: "month-dropdown",
          children: MONTHS.map((option) => /* @__PURE__ */ jsx(Dropdown.Option, { label: option, size: dropdownSize }, option))
        }
      )
    ] }),
    [dropdownSize, onSelectDropdown, rangeYears, year]
  );
  legends.push(
    /* @__PURE__ */ jsx(Legend.Key, { colorSchema: "success-light", children: availableLegend }, "available")
  );
  conditionalProps.highlightDates = [...highlightDates];
  if (deliveryDate !== void 0 && deliveryDate !== null) {
    conditionalProps.highlightDates.push({ delivery_date: [deliveryDate] });
    legends.push(
      /* @__PURE__ */ jsx(Legend.Key, { colorSchema: "success", children: deliveryDateLegend }, "delivery")
    );
  }
  if (installDate !== void 0 && installDate !== null) {
    conditionalProps.highlightDates.push({ install_date: [installDate] });
    legends.push(
      /* @__PURE__ */ jsx(Legend.Key, { colorSchema: "warning", children: installDateLegend }, "install")
    );
  }
  return /* @__PURE__ */ jsxs(Fragment$1, { children: [
    /* @__PURE__ */ jsx("div", { className: css2.wrapper, children: Boolean(label2) && /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(
          styles$k.label,
          styles$k[size2],
          { [styles$k.error]: hasError, [styles$k.required]: showRequired },
          classes == null ? void 0 : classes.label
        ),
        children: label2
      }
    ) }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames(
          css2.wrapper,
          { [styles$k.error]: hasError },
          styles$k[size2.replaceAll("-", "_")],
          {
            [styles$k.open]: isOpen
          }
        ),
        "data-testid": "date-picker-wrapper",
        children: [
          /* @__PURE__ */ jsx(
            DatePicker,
            {
              ...restProps,
              className: classNames(css2.input, {
                [styles$k.open]: isOpen
              }),
              "data-testid": "date-picker",
              maxDate: maxDate && convertDateToUTC(maxDate),
              minDate: minDate && convertDateToUTC(minDate),
              onChange: handleChange,
              onClickOutside: handleClickOutside,
              onFocus: handleFocus,
              onInputClick: handleInputClick,
              open: isOpen,
              placeholderText,
              ref: datePickerRef,
              renderCustomHeader: customHeader,
              ...conditionalProps,
              children: /* @__PURE__ */ jsxs(Fragment$1, { children: [
                showLegends && /* @__PURE__ */ jsx(Legend, { className: css2.legends, children: legends }),
                children,
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    className: styles$k.mobile_close,
                    "data-testid": "datepicker-close",
                    onClick: closeDatepicker,
                    type: "button",
                    children: /* @__PURE__ */ jsx("div", { className: styles$k.mobile_close_icon })
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ jsx("div", { className: styles$k.backdrop }),
          /* @__PURE__ */ jsx(IconCalendarOutlined, { className: css2.icon, colorSchema: "neutral-darkest" })
        ]
      }
    ),
    shouldRenderHelperText && /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames(styles$k.helper, styles$k[size2], { [styles$k.error]: showErrorMessage }),
        children: showErrorMessage ? errorMessage : helperText
      }
    )
  ] });
};
Datepicker.displayName = "Datepicker";
const Title3 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h3",
    "data-testid": "gafe-typography-title-three",
    ...props,
    "data-typography": "Title3",
    size: "xl",
    weight: "semibold"
  }
);
const text = "GAFE-HoleText-text";
const styles$j = {
  text
};
const HoleText = ({
  className,
  textVariant,
  testId = "gafe-common-donut-chart-hole-text",
  ...rest
}) => {
  const Component = textVariant === "heading" ? Title3 : Caption1;
  const $colorSchema = textVariant === "heading" ? "monochromatic-dark" : "dark";
  return /* @__PURE__ */ jsx(
    Component,
    {
      className: classNames(styles$j.text, className),
      colorSchema: $colorSchema,
      "data-testid": testId,
      ...rest
    }
  );
};
const slice_tooltip = "GAFE-SliceTooltip-slice_tooltip";
const styles$i = {
  slice_tooltip
};
const SliceTooltip = ({
  className,
  text: text2,
  value,
  testId = "gafe-common-donut-chart-slice-tooltip",
  ...rest
}) => /* @__PURE__ */ jsxs(
  Box,
  {
    border: { radius: "2xs" },
    className: classNames(styles$i.slice_tooltip, className),
    colorSchema: "monochromatic-dark",
    "data-testid": testId,
    padding: { y: "none", x: "3xs" },
    ...rest,
    children: [
      /* @__PURE__ */ jsxs(Caption2, { children: [
        text2,
        ":"
      ] }),
      /* @__PURE__ */ jsx(Caption2, { children: value })
    ]
  }
);
const getChartTotalCount = (slices) => slices.reduce((accumulator, { value }) => accumulator + value, 0);
const getChartData = (slices, isEmpty) => {
  if (isEmpty) {
    return [["Empty", 1, renderToString(/* @__PURE__ */ jsx(SliceTooltip, { text: "Empty", value: 1 }))]];
  }
  return slices.map(({ value, label: label2, tooltip }) => {
    return [
      label2,
      value,
      renderToString(tooltip || /* @__PURE__ */ jsx(SliceTooltip, { text: label2, value }, label2))
    ];
  });
};
const getSlicesStyle = (slices, isEmpty, defaultStyles) => {
  const slicesData = {};
  if (isEmpty) {
    const { color, offset: offset2 = 0 } = defaultStyles;
    return { 0: { color, offset: offset2 } };
  }
  slices.forEach(({ styles: { color, offset: offset2 = 0 } }, index) => {
    slicesData[index] = {
      color,
      offset: offset2
    };
  });
  return slicesData;
};
const colors = {
  button: {
    color: "#6daede",
    primary: {
      "background-color": "#2774ae",
      "font-color": "#ffffff",
      "icon-color": "#ffffff",
      hovered: {
        "background-color": "#2a7ebd"
      },
      focused: {
        "background-color": "#002e5d"
      },
      pressed: {
        "background-color": "#002e5d"
      },
      disabled: {
        "background-color": "#d9d9d6",
        "font-color": "#606366",
        "icon-color": "#606366"
      },
      destructive: {
        "background-color": "#a32b2b",
        "font-color": "#ffffff",
        hovered: {
          "background-color": "#cc4545"
        },
        focused: {
          "background-color": "#661b1b"
        },
        pressed: {
          "background-color": "#661b1b"
        }
      }
    },
    secondary: {
      "font-color": "#2774ae",
      "border-color": "#2774ae",
      hovered: {
        "background-color": "#eff9ff",
        "border-color": "#2774ae"
      },
      focused: {
        "background-color": "#d7ebfa",
        "border-color": "#2774ae",
        border: {
          color: "#2774ae"
        }
      },
      pressed: {
        "background-color": "#d7ebfa",
        "border-color": "#2774ae"
      },
      disabled: {
        "border-color": "#606366",
        "font-color": "#606366",
        border: {
          color: "#606366"
        }
      },
      border: {
        color: "#2774ae"
      },
      destructive: {
        "border-color": "#a32b2b",
        "font-color": "#a32b2b",
        hovered: {
          "background-color": "#ffedec",
          "border-color": "#a32b2b"
        },
        focused: {
          "background-color": "#fad8d7",
          "border-color": "#a32b2b",
          border: {
            color: "#a32b2b"
          }
        },
        pressed: {
          "background-color": "#fad8d7",
          "border-color": "#a32b2b"
        },
        border: {
          color: "#a32b2b"
        }
      }
    },
    tertiary: {
      "font-color": "#2774ae",
      hovered: {
        "background-color": "#eff9ff"
      },
      focused: {
        "background-color": "#d7ebfa"
      },
      pressed: {
        "background-color": "#d7ebfa"
      },
      disabled: {
        "font-color": "#919395"
      },
      destructive: {
        "font-color": "#a32b2b",
        hovered: {
          "background-color": "#ffedec"
        },
        focused: {
          "background-color": "#fad8d7"
        },
        pressed: {
          "background-color": "#fad8d7"
        }
      },
      "on-dark": {
        "font-color": "#6daede",
        hovered: {
          "background-color": "#1C242B"
        },
        focused: {
          "background-color": "#282F36"
        },
        pressed: {
          "background-color": "#282F36"
        },
        disabled: {
          "font-color": "#919395"
        }
      },
      neutral: {
        "font-color": "#606366",
        hovered: {
          "background-color": "#f2f5f7"
        },
        focused: {
          "background-color": "#dae5f0"
        },
        pressed: {
          "background-color": "#dae5f0"
        }
      }
    },
    link: {
      "on-dark": {
        "font-color": "#6daede",
        hovered: {
          "background-color": "#1C242B"
        },
        focused: {
          "background-color": "#282F36"
        },
        pressed: {
          "background-color": "#282F36"
        },
        disabled: {
          "font-color": "#919395"
        }
      },
      "on-light": {
        "font-color": "#2774ae",
        hovered: {
          "background-color": "#eff9ff"
        },
        focused: {
          "background-color": "#d7ebfa"
        },
        pressed: {
          "background-color": "#d7ebfa"
        },
        disabled: {
          "font-color": "#606366"
        }
      }
    },
    FAB: {
      border: {
        color: "#d7ebfa"
      },
      "background-color": "#2774ae",
      "border-color": "#d7ebfa",
      "icon-color": "#ffffff",
      hovered: {
        "background-color": "#2a7ebd"
      },
      focused: {
        "background-color": "#002e5d"
      },
      pressed: {
        "background-color-copy": "#002e5d"
      }
    }
  },
  card: {
    task: {
      header: {
        "background-color": "#f2f5f7",
        "border-color": "#e8e8e8",
        "font-color": "#002e5d"
      },
      hovered: {
        "background-color": "#ffffff",
        "border-color": "#2774ae"
      },
      focused: {
        "background-color": "#ffffff",
        "border-color": "#2774ae"
      },
      error: {
        "border-color": "#a32b2b",
        "background-color": "#ffffff"
      },
      disabled: {
        "font-color": "#606366",
        "border-color": "#606366",
        "icon-color": "#606366"
      },
      "icon-color": {
        "upload-needed": "#1a78ff",
        accepted: "#63b762",
        rejected: "#cc4545",
        "pending-review": "#f5a400"
      },
      footer: {
        "border-color": "#e8e8e8"
      },
      "background-color": "#ffffff",
      "font-color": "#101820"
    }
  },
  "date-picker": {
    "border-color": "#c8c9ca",
    "font-color": "#606366",
    "icon-color": "#606366",
    hovered: {
      "background-color": "#eff9ff",
      "border-color": "#c8c9ca"
    },
    focused: {
      border: {
        color: "#2774ae"
      },
      "background-color": "transparent",
      "border-color": "#2774ae"
    },
    pressed: {
      "background-color": "#d7ebfa",
      "border-color": "#c8c9ca"
    },
    selected: {
      "font-color": "#002e5d",
      "border-color": "#c8c9ca"
    },
    error: {
      "border-color": "#a32b2b",
      "font-color": "#002e5d",
      border: {
        color: "#a32b2b"
      }
    },
    disabled: {
      "background-color": "#f1f2f2",
      "border-color": "#e8e8e8",
      border: {
        color: "#e8e8e8"
      }
    },
    active: {
      "border-color": "#2774ae",
      border: {
        color: "#2774ae"
      }
    },
    border: {
      color: "#c8c9ca"
    }
  },
  dropdown: {
    focused: {
      border: {
        color: "#2774ae"
      },
      "border-color": "#2774ae"
    },
    "background-color": "transparent",
    "border-color": "#c8c9ca",
    "label-color": "#606366",
    "label-icon-color": "#0054cc",
    "icon-color": "#606366",
    "placeholder-color": "#919395",
    "font-color": "#002e5d",
    "helper-color": "#606366",
    "icon-helper-color": "#606366",
    selected: {
      "background-color": "transparent",
      "border-color": "#c8c9ca",
      "label-color": "#606366",
      "helper-color": "#919395",
      "font-color": "#002e5d",
      "icon-color": "#606366"
    },
    error: {
      "background-color": "transparent",
      "border-color": "#a32b2b",
      "label-color": "#606366",
      "helper-color": "#a32b2b",
      "icon-color": "#606366",
      "font-color": "#002e5d",
      border: {
        color: "#a32b2b"
      }
    },
    hovered: {
      "background-color": "#eff9ff",
      "border-color": "#c8c9ca",
      "label-color": "#606366",
      "placeholder-color": "#919395",
      "font-color": "#002e5d",
      "helper-color": "#919395",
      "icon-color": "#606366"
    },
    pressed: {
      "background-color": "#d7ebfa",
      "border-color": "#c8c9ca",
      "label-color": "#606366",
      "placeholder-color": "#919395",
      "font-color": "#002e5d",
      "helper-color": "#919395",
      "icon-color": "#606366"
    },
    disabled: {
      "background-color": "#f1f2f2",
      "border-color": "#e8e8e8",
      border: {
        color: "#e8e8e8"
      }
    },
    active: {
      "border-color": "#2774ae",
      border: {
        color: "#2774ae"
      }
    },
    border: {
      color: "#c8c9ca"
    }
  },
  calendar: {
    "background-color": "#ffffff",
    "date-box": {
      hovered: {
        "font-color": "#295728",
        "background-color": "#b3e5b3"
      },
      available: {
        "font-color": "#295728",
        "background-color": "#eeffee"
      },
      focused: {
        "background-color": "#b3e5b3",
        "border-color": "#397a38"
      },
      selected: {
        "background-color": "#397a38",
        "font-color": "#ffffff"
      },
      disabled: {
        "font-color": "#919395"
      },
      "font-color": "#606366"
    },
    today: {
      border: {
        color: "#002e5d"
      },
      focused: {
        border: {
          color: "#002e5d"
        }
      },
      disabled: {
        border: {
          color: "#919395"
        }
      }
    },
    focused: {
      border: {
        color: "#397a38"
      }
    },
    shadow: {
      "0": {
        color: "#10182014"
      },
      "1": {
        color: "#1018201f"
      }
    },
    "legend-box": {
      available: {
        "background-color": "#eeffee",
        "border-color": "#63b762"
      },
      delivery: {
        "background-color": "#295728"
      },
      install: {
        "background-color": "#dc6b2f"
      },
      "font-color": "#606366"
    }
  },
  "text-area": {
    helper: {
      "font-color": "#002e5d",
      "icon-color": "#002e5d"
    },
    "background-color": "transparent",
    "label-color": "#606366",
    "border-color": "#c8c9ca",
    "placeholder-color": "#919395",
    "font-color": "#002e5d",
    "icon-color": "#606366",
    "count-color": "#919395",
    "helper-icon-color": "#606366",
    "label-icon-color": "#0054cc",
    hovered: {
      "background-color": "#eff9ff"
    },
    pressed: {
      "background-color": "#d7ebfa"
    },
    active: {
      "border-color": "#2774ae",
      "icon-color": "#002e5d",
      border: {
        color: "#2774ae"
      }
    },
    error: {
      "border-color": "#a32b2b",
      "font-color": "#002e5d",
      "helper-color": "#a32b2b",
      helper: {
        "icon-color": "#a32b2b"
      },
      border: {
        color: "#a32b2b"
      }
    },
    disabled: {
      "background-color": "#f1f2f2",
      "border-color": "#e8e8e8",
      border: {
        color: "#e8e8e8"
      }
    },
    typed: {
      "border-color": "#c8c9ca",
      "icon-color": "#002e5d",
      "font-color": "#002e5d"
    },
    focused: {
      border: {
        color: "#2774ae"
      },
      "border-color": "#2774ae"
    },
    typing: {
      "border-color": "#2774ae",
      "font-color": "#002e5d"
    },
    border: {
      color: "#c8c9ca"
    }
  },
  checkbox: {
    "border-color": "#c8c9ca",
    hovered: {
      "background-color": "#EEF4F9",
      "border-color": "#c8c9ca"
    },
    focused: {
      "background-color": "#EEF4F9",
      "border-color": "#c8c9ca",
      "container-border-color": "#2774ae"
    },
    pressed: {
      "background-color": "#E5EEF5",
      "border-color": "#c8c9ca"
    },
    selected: {
      "background-color": "#2774ae",
      "icon-color": "#ffffff",
      hovered: {
        "background-color": "#2a7ebd"
      },
      focused: {
        "background-color": "#002e5d"
      },
      pressed: {
        "background-color": "#002e5d"
      },
      disabled: {
        "background-color": "#c8c9ca"
      }
    },
    indetermined: {
      "background-color": "#2774ae",
      "icon-color": "#ffffff",
      hovered: {
        "background-color": "#2a7ebd"
      },
      focused: {
        "background-color": "#002e5d"
      },
      pressed: {
        "background-color": "#002e5d"
      },
      disabled: {
        "background-color": "#c8c9ca"
      }
    },
    disabled: {
      "background-color": "#f1f2f2",
      "border-color": "#c8c9ca"
    },
    unselected: {
      border: {
        color: "#c8c9ca"
      },
      focused: {
        border: {
          color: "#2774ae"
        }
      }
    }
  },
  modal: {
    "background-color": "#ffffff",
    "font-color": "#101820"
  },
  "text-field": {
    outline: {
      enable: {
        "border-color": "#c8c9ca",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "helper-color": "#606366",
        "icon-color": "#606366",
        "text-color": "#002e5d"
      },
      hovered: {
        "border-color": "#c8c9ca",
        "background-color": "#eff9ff",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      pressed: {
        "border-color": "#c8c9ca",
        "background-color": "#d7ebfa",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      active: {
        "border-color": "#2774ae",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      error: {
        "border-color": "#a32b2b",
        "placeholder-color": "#919395",
        "label-color": "#606366",
        "text-color": "#002e5d",
        "icon-color": "#606366",
        "helper-color": "#a32b2b"
      },
      disabled: {
        "border-color": "#e8e8e8",
        "background-color": "#f1f2f2",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "text-color": "#919395",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      typed: {
        "border-color": "#c8c9ca",
        "label-color": "#606366",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      focused: {
        "border-color": "#2774ae",
        "label-color": "#606366",
        "placeholder-color": "#919395",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      typing: {
        "border-color": "#2774ae",
        "label-color": "#606366",
        "text-color": "#002e5d",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      "pricing-calculator": {
        enable: {
          "border-color": "#c8c9ca",
          "font-color": "#606366",
          "prefix-color": "#606366",
          "suffix-color": "#606366"
        },
        hovered: {
          "border-color": "#c8c9ca",
          "background-color": "#EEF4F9",
          "font-color": "#606366",
          "prefix-color": "#606366",
          "suffix-color": "#606366"
        },
        active: {
          "border-color": "#2774ae",
          "font-color": "#606366",
          "prefix-color": "#606366",
          "suffix-color": "#606366"
        },
        pressed: {
          "border-color": "#c8c9ca",
          "background-color": "#d7ebfa",
          "font-color": "#606366",
          "suffix-color": "#606366",
          "prefix-color": "#606366"
        },
        focused: {
          "border-color": "#002e5d",
          "font-color": "#606366",
          "prefix-color": "#606366",
          "suffix-color": "#606366"
        },
        typing: {
          "border-color": "#2774ae",
          "font-color": "#002e5d",
          "prefix-color": "#002e5d",
          "suffix-color": "#606366"
        },
        typed: {
          "border-color": "#c8c9ca",
          "text-color": "#002e5d",
          "prefix-color": "#002e5d",
          "suffix-color": "#606366"
        },
        error: {
          "border-color": "#a32b2b",
          "text-color": "#002e5d",
          "prefix-color": "#002e5d",
          "suffix-color": "#606366"
        },
        warning: {
          "border-color": "#f5a400",
          "text-color": "#002e5d",
          "prefix-color": "#002e5d",
          "suffix-color": "#606366"
        }
      },
      "label-icon-color": "#0054cc"
    },
    focused: {
      border: {
        color: "#2774ae"
      }
    },
    border: {
      color: "#c8c9ca"
    },
    active: {
      border: {
        color: "#2774ae"
      }
    },
    error: {
      border: {
        color: "#a32b2b"
      }
    },
    disabled: {
      border: {
        color: "#e8e8e8"
      }
    },
    filled: {
      enable: {
        "background-color": "#f1f2f2",
        "border-color": "#c8c9ca",
        "label-color": "#606366",
        "input-color": "#606366",
        "icon-color": "#606366",
        "helper-color": "#606366"
      },
      hovered: {
        "border-color": "#c8c9ca",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#606366",
        "icon-color": "#606366",
        "helper-color": "#606366"
      },
      pressed: {
        "border-color": "#c8c9ca",
        "background-color": "#c8c9ca",
        "label-color": "#606366",
        "helper-color": "#606366",
        "input-color": "#606366",
        "icon-color": "#606366"
      },
      active: {
        "border-color": "#2774ae",
        "background-color": "#c8c9ca",
        "label-color": "#606366",
        "input-color": "#606366",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      error: {
        "border-color": "#a32b2b",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#101820",
        "helper-color": "#a32b2b",
        "icon-color": "#101820"
      },
      disabled: {
        "border-color": "#e8e8e8",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#919395",
        "helper-color": "#919395",
        "icon-color": "#919395"
      },
      typed: {
        "border-color": "#e8e8e8",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#101820",
        "helper-color": "#919395",
        "icon-color": "#101820"
      },
      typing: {
        "border-color": "#2774ae",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#101820",
        "helper-color": "#919395",
        "icon-color": "#101820"
      },
      focused: {
        "border-color": "#2774ae",
        "background-color": "#e8e8e8",
        "label-color": "#606366",
        "input-color": "#606366",
        "helper-color": "#606366",
        "icon-color": "#606366"
      },
      "label-icon-color": "#0054cc"
    }
  },
  "message-box": {
    "font-color": "#101820",
    information: {
      "background-color": "#e5f0ff",
      "checkbox-selected": {
        "icon-color": "#0054cc"
      },
      "icon-color": "#101820"
    },
    success: {
      "background-color": "#eeffee",
      "checkbox-selected": {
        "icon-color": "#397a38"
      },
      "icon-color": "#101820"
    },
    warning: {
      "background-color": "#fff0cf",
      "checkbox-selected": {
        "icon-color": "#9d6900"
      },
      "icon-color": "#101820"
    },
    destructive: {
      "background-color": "#ffedec",
      "checkbox-selected": {
        "icon-color": "#a32b2b"
      },
      "icon-color": "#101820"
    },
    "icon-color": "#101820"
  },
  drawer: {
    "background-color": "#ffffff",
    "font-color": "#002e5d",
    "border-color": "#f1f2f2",
    border: {
      color: "#f1f2f2"
    }
  },
  "dropdown-item": {
    "font-color": "#002e5d",
    "background-color": "#ffffff",
    hovered: {
      "background-color": "#eff9ff",
      "font-color": "#002e5d"
    },
    focused: {
      "background-color": "#d7ebfa",
      "font-color": "#002e5d"
    },
    pressed: {
      "background-color": "#d7ebfa",
      "font-color": "#002e5d"
    },
    disabled: {
      "font-color": "#606366"
    }
  },
  stepper: {
    active: {
      "background-color": "#ffffff",
      "border-color": "#2774ae",
      "font-color": "#2774ae",
      "label-color": "#101820",
      border: {
        color: "#2774ae"
      }
    },
    complete: {
      "background-color": "#2774ae",
      "font-color": "#ffffff",
      "label-color": "#2774ae",
      "bg-color": "#2774ae"
    },
    incomplete: {
      "background-color": "#dae5f0",
      "font-color": "#ffffff",
      "label-color": "#101820"
    },
    "connector-color": "#dae5f0"
  },
  onboarding: {
    "background-color": "#ffffff",
    shadow: {
      color: "#1018201f"
    },
    "font-color": {
      content: "#101820",
      steps: "#606366"
    }
  },
  popover: {
    shadow: {
      "0": {
        color: "#10182014"
      },
      "1": {
        color: "#1018201f"
      }
    },
    "background-color": "#ffffff",
    "border-color": "#e8e8e8",
    "font-color": "#101820",
    "icon-color": "#101820",
    border: {
      color: "#e8e8e8"
    }
  },
  tooltip: {
    "background-color": "#e5f0ff",
    "font-color": "#002e5d",
    shadow: {
      "0": {
        color: "#10182014"
      },
      "1": {
        color: "#1018201f"
      }
    }
  },
  "selection-card": {
    "border-color": "#c8c9ca",
    "icon-color": "#002e5d",
    "font-color": "#002e5d",
    "not-started": {
      "highlight-color": "#919395",
      hovered: {
        "border-color": "#002e5d"
      },
      selected: {
        "border-color": "#002e5d",
        "background-color": "#f1f2f2"
      }
    },
    "in-progress": {
      "highlight-color": "#2a7ebd",
      hovered: {
        "border-color": "#002e5d"
      },
      selected: {
        "border-color": "#002e5d",
        "background-color": "#eff9ff"
      }
    },
    "re-opened": {
      "highlight-color": "#ffc44d",
      hovered: {
        "border-color": "#002e5d"
      },
      selected: {
        "border-color": "#002e5d",
        "background-color": "#fff0cf"
      }
    },
    complete: {
      "highlight-color": "#63b762",
      hovered: {
        "border-color": "#002e5d"
      },
      selected: {
        "border-color": "#002e5d",
        "background-color": "#eeffee"
      }
    },
    "running-behind": {
      "highlight-color": "#dc6b2f",
      hovered: {
        "border-color": "#002e5d"
      },
      selected: {
        "border-color": "#002e5d",
        "background-color": "#FFECE2"
      }
    },
    shadow: {
      "0": {
        color: "#10182014"
      },
      "1": {
        color: "#1018201f"
      }
    },
    border: {
      color: "#c8c9ca"
    },
    hovered: {
      border: {
        color: "#002e5d"
      }
    },
    selected: {
      border: {
        color: "#002e5d"
      }
    }
  },
  snackbar: {
    shadow: {
      "0": {
        color: "#10182014"
      },
      "1": {
        color: "#1018201f"
      }
    },
    "background-color": "#101820",
    "font-color": "#ffffff",
    "icon-color": "#ffffff"
  },
  "segmented-button": {
    enable: {
      "background-color": "#ffffff",
      "font-color": "#101820",
      "icon-color": "#101820",
      "border-color": "#d9d9d6"
    },
    hovered: {
      "background-color": "#eff9ff",
      "font-color": "#101820",
      "icon-color": "#101820",
      "border-color": "#d9d9d6"
    },
    focused: {
      "background-color": "#d7ebfa",
      "font-color": "#101820",
      "icon-color": "#101820",
      border: {
        color: "#2774ae"
      },
      "border-color": "#2774ae"
    },
    selected: {
      "background-color": "#ffffff",
      "font-color": "#2774ae",
      "icon-color": "#2774ae",
      border: {
        color: "#2774ae"
      },
      "border-color": "#2774ae"
    },
    disabled: {
      "background-color": "#ffffff",
      "font-color": "#75787b",
      "icon-color": "#75787b",
      "border-color": "#d9d9d6"
    },
    border: {
      color: "#d9d9d6"
    }
  },
  lozenge: {
    light: {
      information: {
        "background-color": "#e5f0ff",
        "font-color": "#003685",
        "left-icon-color": "#003685",
        "rigth-icon-color": "#101820"
      },
      success: {
        "background-color": "#eeffee",
        "font-color": "#295728",
        "left-icon-color": "#295728",
        "rigth-icon-color": "#101820"
      },
      warning: {
        "background-color": "#fff0cf",
        "font-color": "#9d6900",
        "left-icon-color": "#9d6900",
        "rigth-icon-color": "#101820"
      },
      destructive: {
        "background-color": "#ffedec",
        "font-color": "#a32b2b",
        "left-icon-color": "#a32b2b",
        "rigth-icon-color": "#101820"
      },
      disabled: {
        "background-color": "#e8e8e8",
        "font-color": "#919395",
        "left-icon-color": "#919395",
        "rigth-icon-color": "#919395"
      }
    },
    bold: {
      information: {
        "background-color": "#0054cc",
        "font-color": "#ffffff",
        "left-icon-color": "#ffffff",
        "right-icon-color": "#ffffff"
      },
      success: {
        "background-color": "#397a38",
        "font-color": "#ffffff",
        "left-icon-color": "#ffffff",
        "right-icon-color": "#ffffff"
      },
      warning: {
        "background-color": "#f5a400",
        "font-color": "#101820",
        "left-icon-color": "#101820",
        "right-icon-color": "#101820"
      },
      destructive: {
        "background-color": "#a32b2b",
        "font-color": "#ffffff",
        "left-icon-color": "#ffffff",
        "right-icon-color": "#ffffff"
      },
      disabled: {
        "background-color": "#919395",
        "font-color": "#f1f2f2",
        "left-icon-color": "#f1f2f2",
        "rigth-icon-color": "#ffffff"
      }
    }
  },
  "message-card": {
    "border-bottom": {
      color: "#b1b3b3"
    },
    hovered: {
      border: {
        color: "#2774ae"
      }
    },
    focused: {
      border: {
        color: "#2774ae"
      }
    },
    error: {
      border: {
        color: "#a32b2b"
      }
    },
    "background-color": "#ffffff",
    "font-color": "#101820",
    "role-font-color": "#606366"
  },
  "document-card": {
    "border-bottom": {
      color: "#e8e8e8"
    },
    hovered: {
      border: {
        color: "#2774ae"
      }
    },
    focused: {
      border: {
        color: "#2774ae"
      }
    },
    error: {
      border: {
        color: "#a32b2b"
      }
    },
    "background-color": "#ffffff",
    "background-color-inner-container": "#e8e8e8",
    "title-font-color": "#101820",
    "label-font-color": "#606366",
    "value-font-color": "#101820"
  },
  toast: {
    information: {
      "background-color": "#f2f5f7",
      "icon-left-color": "#0054cc",
      "font-color": "#003685",
      "icon-right-color": "#101820"
    },
    success: {
      "background-color": "#eeffee",
      "icon-left-color": "#397a38",
      "font-color": "#295728",
      "icon-right-color": "#101820"
    },
    "confirmation-destructive": {
      "background-color": "#ffedec",
      "icon-left-color": "#a32b2b",
      "font-color": "#661b1b",
      "icon-right-color": "#101820"
    },
    "confirmation-warning": {
      "background-color": "#fff0cf",
      "icon-left-color": "#f5a400",
      "font-color": "#9d6900",
      "icon-right-color": "#101820"
    }
  },
  banner: {
    light: {
      informative: {
        "background-color": "#ffffff",
        "font-title-color": "#0054cc",
        "font-body-color": "#101820",
        "icon-color": "#0054cc",
        "border-color": "#0054cc"
      },
      disabled: {
        "background-color": "#ffffff",
        "font-title-color": "#606366",
        "font-body-color": "#101820",
        "icon-color": "#606366",
        "border-color": "#606366"
      }
    },
    informative: {
      border: {
        color: "#0054cc"
      }
    },
    disabled: {
      border: {
        color: "#606366"
      }
    },
    bold: {
      informative: {
        "background-color": "#0054cc",
        "font-title-color": "#ffffff",
        "font-body-color": "#ffffff",
        "icon-color": "#ffffff"
      },
      disabled: {
        "background-color": "#f1f2f2",
        "font-title-color": "#919395",
        "font-body-color": "#919395",
        "icon-color": "#919395"
      }
    }
  },
  accordion: {
    focused: {
      border: {
        color: "#2774ae"
      },
      "background-color": "#eff9ff",
      "font-color": "#002e5d",
      "border-color": "#2774ae"
    },
    enable: {
      "background-color": "#ffffff",
      "font-color": "#002e5d"
    },
    hovered: {
      "background-color": "#eff9ff",
      "font-color": "#002e5d"
    },
    pressed: {
      "background-color": "#d7ebfa",
      "font-color": "#002e5d"
    },
    disabled: {
      "background-color": "#ffffff",
      "font-color": "#606366"
    }
  },
  breadcrumb: {
    inactive: {
      "font-color": "#606366",
      "icon-color": "#606366"
    },
    active: {
      "font-color": "#101820",
      "icon-color": "#101820"
    },
    hovered: {
      "font-color": "#606366",
      "icon-color": "#606366",
      highlight: "#606366"
    }
  },
  pill: {
    information: {
      border: {
        color: "#1a78ff"
      },
      "background-color": "#ffffff",
      "border-color": "#1a78ff",
      "font-color": "#101820"
    },
    success: {
      border: {
        color: "#63b762"
      },
      "background-color": "#ffffff",
      "border-color": "#63b762",
      "font-color": "#101820"
    },
    warning: {
      border: {
        color: "#ffc44d"
      },
      "background-color": "#ffffff",
      "border-color": "#ffc44d",
      "font-color": "#101820"
    },
    destructive: {
      border: {
        color: "#cc4545"
      },
      "background-color": "#ffffff",
      "border-color": "#cc4545",
      "font-color": "#101820"
    }
  },
  avatar: {
    default: {
      "background-color": {
        "01": "#002e5d",
        "02": "#dc6b2f"
      },
      "font-color": "#ffffff"
    },
    online: {
      "font-color": "#ffffff",
      "background-color": {
        "01": "#002e5d",
        "02": "#dc6b2f"
      },
      "badge-color": "#63b762"
    },
    offline: {
      "font-color": "#ffffff",
      "background-color": {
        "01": "#002e5d",
        "02": "#dc6b2f"
      },
      "badge-color": "#919395"
    }
  },
  header: {
    background: "#ffffff",
    "text-color": "#606366",
    "icon-color": "#002e5d"
  },
  "deal-assist-card": {
    "background-color": "#ffffff",
    "border-color": "#919395",
    "title-font-color": "#101820",
    "body-font-color": "#606366",
    "icon-color": "#2774ae",
    border: {
      color: "#919395"
    }
  },
  "contact-card": {
    "background-color": "#ffffff",
    "font-color": "#101820",
    "lean-foward-color-color": "#0054cc"
  },
  gauge: {
    container: {
      color: "#d9d9d6"
    },
    indicator: {
      color: "#0054cc"
    },
    "circular-container": "#d9d9d6"
  },
  "table-cell": {
    header: {
      "background-color": "#ffffff",
      "font-color": "#606366",
      "border-bottom-color": "#e8e8e8",
      hovered: {
        "background-color": "#eff9ff"
      },
      focused: {
        "background-color": "#d7ebfa"
      }
    },
    content: {
      "background-color": "#ffffff",
      "font-color": "#101820",
      "icon-color": "#101820",
      "border-bottom-color": "#e8e8e8",
      hover: {
        "background-color": "#eff9ff"
      },
      focused: {
        "background-color": "#d7ebfa"
      },
      error: {
        "background-color": "#ffedec"
      },
      disabled: {
        "font-color": "#606366",
        "icon-color": "#606366"
      }
    },
    "border-bottom": {
      color: "#e8e8e8"
    }
  },
  "fixed-button-footer": {
    error: {
      "font-color": "#a32b2b"
    },
    shadow: {
      "0": {
        color: "#8c8c8c0d"
      },
      "1": {
        color: "#8c8c8c33"
      }
    }
  },
  "bottom-sheet": {
    "background-color": "#ffffff",
    "handle-color": "#101820",
    "icon-color": "#101820"
  },
  toggle: {
    handle: {
      "background-color": "#ffffff",
      shadow: {
        "0": {
          color: "#10182005"
        },
        "1": {
          color: "#10182005"
        },
        "2": {
          color: "#1018200a"
        },
        "3": {
          color: "#1018201f"
        },
        "4": {
          color: "#10182014"
        }
      },
      disabled: {
        color: "#101820"
      }
    },
    off: {
      "background-color": "#ffffff",
      hovered: {
        "background-color": "#eff9ff"
      },
      pressed: {
        "background-color": "#d7ebfa"
      },
      disabled: {
        "background-color": "#f1f2f2",
        handle: {
          "background-color": "#c8c9ca"
        }
      }
    },
    on: {
      "background-color": "#2774ae",
      hovered: {
        "background-color": "#2a7ebd"
      },
      pressed: {
        "background-color": "#002e5d"
      },
      disabled: {
        "background-color": "#f1f2f2",
        handle: {
          "background-color": "#c8c9ca"
        }
      }
    },
    shadow: {
      "0": {
        color: "#10182005"
      },
      "1": {
        color: "#1018200a"
      },
      "2": {
        color: "#1018200f"
      },
      "3": {
        color: "#10182005"
      }
    }
  },
  spinner: {
    "background-color": "#002e5d"
  },
  icon: {
    "background-color": "#101820",
    "border-color": "#101820",
    information: {
      "01": "#1a78ff"
    }
  },
  "bottom-nav-bar": {
    "border-top": {
      color: "#f1f2f2"
    },
    enabled: {
      "icon-color": "#606366",
      "background-color": "#ffffff",
      "font-color": "#606366"
    },
    pressed: {
      "background-color": "#d7ebfa",
      "icon-color": "#606366",
      "font-color": "#606366"
    },
    selected: {
      "background-color": "#ffffff",
      "icon-color": "#2774ae",
      "font-color": "#2774ae"
    }
  },
  tab: {
    selected: {
      border: {
        color: "#d71920"
      }
    }
  },
  "task-card": {
    hovered: {
      border: {
        color: "#2774ae"
      }
    },
    focused: {
      border: {
        color: "#2774ae"
      }
    },
    error: {
      border: {
        color: "#a32b2b"
      }
    }
  },
  "content-card": {
    border: {
      color: "#e8e8e8"
    }
  },
  table: {
    border: {
      color: "#e8e8e8"
    }
  },
  upload: {
    border: {
      color: "#b1b3b3"
    },
    hovered: {
      border: {
        color: "#2774ae"
      },
      "background-color": "#eff9ff",
      "font-color": "#101820",
      "icon-color": "#2774ae"
    },
    focused: {
      border: {
        color: "#2774ae"
      },
      "background-color": "#d7ebfa",
      "font-color": "#101820",
      "icon-color": "#2774ae"
    },
    "background-color": "#ffffff",
    "font-color": "#101820",
    "icon-color": "#2774ae",
    disabled: {
      "background-color": "#ffffff",
      "font-color": "#606366",
      "icon-color": "#b1b3b3"
    }
  },
  "radio-button": {
    light: {
      "outer-border-color": "#c8c9ca",
      "outer-background-color": "transparent",
      selected: {
        "outer-border-color": "#2774ae",
        "inner-background-color": "#2774ae",
        hovered: {
          "outer-border-color": "#2774ae",
          "inner-background-color": "#2774ae",
          "container-background-color": "#eff9ff"
        },
        focused: {
          "container-border-color": "#002e5d"
        },
        disabled: {
          "outer-border-color": "#c8c9ca",
          "inner-background-color": "#c8c9ca"
        }
      },
      disabled: {
        "container-background-color": "#f1f2f2",
        "outer-border-color": "#c8c9ca",
        "inner-background-color": "#c8c9ca"
      },
      hovered: {
        "container-background-color": "#EFF9FF",
        "outer-border-color": "#2774AE",
        "inner-background-color": "#2774ae"
      },
      focused: {
        "container-border-color": "#002e5d",
        "container-background-color": "transparent"
      }
    },
    dark: {
      "outer-border-color": "#F1F2F2",
      "outer-background-color": "transparent",
      selected: {
        "outer-background-color": "#ffffff",
        "inner-background-color": "#ffffff",
        hovered: {
          "outer-background-color": "#ffffff",
          "inner-background-color": "#ffffff",
          "container-background-color": "#6daede"
        },
        focused: {
          "container-border-color": "#002e5d"
        },
        disabled: {
          "container-background-color": "transparent",
          "outer-background-color": "#c8c9ca",
          "inner-background-color": "#c8c9ca"
        }
      },
      hovered: {
        "container-background-color": "#6daede",
        "outer-border-color": "#ffffff",
        "inner-background-color": "#ffffff"
      },
      focused: {
        "container-border-color": "#002e5d",
        "container-background-color": "transparent"
      },
      disabled: {
        "outer-border-color": "#c8c9ca"
      }
    }
  },
  "bottom-shadown": {
    background: "#ffffff"
  },
  "scroll-enable": {
    "background-color": "#e8e8e8"
  },
  "scroll-hovered": {
    "background-color": "#c8c9ca"
  },
  "scroll-pressed": {
    "background-color": "#919395"
  },
  badge: {
    progress: "#2a7ebd",
    "to-do": "#1a78ff",
    success: "#63b762",
    "re-opened": "#ffc44d",
    "running-behind": "#FF7C3A",
    "not-started": "#919395"
  },
  "proposal-details-card": {
    "background-color": "#ffffff",
    "border-color": "#c8c9ca",
    "heading-font-color": "#919395",
    "title-font-color": "#101820",
    "body-font-color": "#101820",
    border: {
      color: "#c8c9ca"
    }
  },
  skeleton: {
    "gradient-1": "linear-gradient(90deg, #F1F2F2 0%, #E8E8E8 0%, #F1F2F2 100%)",
    "gradient-2": "linear-gradient(90deg, #F1F2F2 0%, #E8E8E8 15%, #F1F2F2 100%)",
    "gradient-3": "linear-gradient(90deg, #F1F2F2 0%, #E8E8E8 30%, #F1F2F2 100%)",
    "gradient-4": "linear-gradient(90deg, #F1F2F2 0%, #E8E8E8 50%, #F1F2F2 100%)",
    "gradient-5": "linear-gradient(90deg, #F1F2F2 15%, #E8E8E8 65%, #F1F2F2 100%)",
    "gradient-6": "linear-gradient(90deg, #F1F2F2 30%, #E8E8E8 80%, #F1F2F2 100%)",
    "gradient-7": "linear-gradient(90deg, #F1F2F2 45%, #E8E8E8 100%, #F1F2F2 100%)",
    "gradient-8": "linear-gradient(90deg, #F1F2F2 100%, #212121 100%, #F1F2F2 100%)"
  },
  "popover-warning": {
    "background-color": "#ffffff",
    "border-color": "#f5a400",
    "font-color": "#101820",
    "icon-color": "#f5a400"
  },
  background: {
    primary: "#ffffff"
  },
  "button-background": {
    primary: "#2774ae"
  },
  "button-foreground": {
    primary: "#ffffff"
  },
  foreground: {
    disabled: "#606366"
  },
  primary: {
    "gaf-energy-red": "#d71920",
    "gaf-energy-white": "#ffffff",
    "pms-648": "#002e5d",
    "pms-2383": "#2774ae"
  },
  secondary: {
    "gaf-energy-black": "#101820",
    "gaf-energy-gray": "#75787b",
    "pms-cool-gray-5": "#b1b3b3",
    "pms-cool-gray-1": "#d9d9d6",
    "pms-7578": "#dc6b2f",
    "pms-202": "#862633"
  },
  Neutrals: {
    "50": "#f1f2f2",
    "100": "#e8e8e8",
    "200": "#c8c9ca",
    "300": "#919395",
    "400": "#606366"
  },
  Gradients: {
    Linear: {
      Red: "linear-gradient(-13deg, #862633 0%, #d71920 100%)",
      Blue: "linear-gradient(-13deg, #002e5d 0%, #2774ae 100%)",
      Gray: "linear-gradient(180deg, #d9d9d6 0%, #75787b 100%)"
    },
    Angled: {
      Red: "linear-gradient(176deg, #e05359 0%, #cf142b 100%)",
      Blue: "linear-gradient(176deg, #2774ae 0%, #002e5d 100%)",
      Gray: "linear-gradient(176deg, #d9d9d6 0%, #75787b 100%)"
    }
  },
  Blue: {
    "50": "#f2f5f7",
    "100": "#dae5f0",
    "200": "#658eb7",
    "300": "#18497a",
    "400": "#002e5d"
  },
  Semantic: {
    Destructive: {
      "50": "#ffedec",
      "100": "#fad8d7",
      "200": "#cc4545",
      "300": "#a32b2b",
      "400": "#661b1b"
    },
    Information: {
      "50": "#e5f0ff",
      "100": "#adcfff",
      "200": "#1a78ff",
      "300": "#0054cc",
      "400": "#003685"
    },
    Success: {
      "50": "#eeffee",
      "100": "#b3e5b3",
      "200": "#63b762",
      "300": "#397a38",
      "400": "#295728"
    },
    Warning: {
      "50": "#fff0cf",
      "100": "#ffd580",
      "200": "#ffc44d",
      "300": "#f5a400",
      "400": "#9d6900"
    },
    Orange: {
      "50": "#FFECE2",
      "100": "#FFCBB0",
      "200": "#FFA070",
      "300": "#FF7C3A",
      "400": "#8F3F17"
    }
  },
  "Light blue": {
    "50": "#eff9ff",
    "100": "#d7ebfa",
    "200": "#b2daf8",
    "300": "#6daede",
    "400": "#2a7ebd"
  },
  test: {
    color: "#10182026"
  },
  small: {
    "0": {
      color: "#0000001f"
    },
    "1": {
      color: "#00000014"
    }
  },
  large: {
    "0": {
      color: "#0000001f"
    },
    "1": {
      color: "#0000001f"
    }
  },
  FAB: {
    "0": {
      color: "#11192124"
    },
    "1": {
      color: "#1119211f"
    },
    "2": {
      color: "#11192133"
    }
  },
  "data-visualization": {
    navy: {
      "200": "#183B5E"
    },
    violet: {
      "200": "#685CB8"
    },
    purple: {
      "200": "#A5249A"
    },
    coral: {
      "200": "#E5325B"
    },
    orange: {
      "200": "#E57031"
    },
    yellow: {
      "200": "#F4A500"
    }
  }
};
const wrapper$3 = "GAFE-DonutChart-wrapper";
const chart = "GAFE-DonutChart-chart";
const chart_details = "GAFE-DonutChart-chart_details";
const styles$h = {
  wrapper: wrapper$3,
  chart,
  chart_details
};
const DonutChart = ({
  chartActions,
  chartEvents,
  chartSize,
  children,
  classes,
  data,
  emptyStyle = { color: colors.secondary["pms-cool-gray-1"], offset: 0 },
  options,
  rootProps = {},
  testId = "gafe-common-donut-chart",
  ...rest
}) => {
  const [isChartLoaded, setIsChartLoaded] = useState(false);
  const totalCount = getChartTotalCount(data);
  const allZero = totalCount === 0;
  const shouldRenderHoleContent = Boolean(children) && isChartLoaded;
  const chartData = useMemo(
    () => [
      [
        "Category",
        "Count",
        {
          role: "tooltip",
          type: "string",
          p: { html: true }
        }
      ],
      ...getChartData(data, allZero)
    ],
    [allZero, data]
  );
  const handleChartLoaded = useCallback(() => {
    setIsChartLoaded(true);
  }, [setIsChartLoaded]);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: classNames(styles$h.wrapper, classes == null ? void 0 : classes.wrapper),
      style: { width: chartSize, height: chartSize, ...rest.style },
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          Chart,
          {
            chartActions,
            chartEvents,
            chartType: "PieChart",
            className: classNames(styles$h.chart, classes == null ? void 0 : classes.chart),
            data: chartData,
            height: "100%",
            loader: /* @__PURE__ */ jsx(ProgressSpinner, { width: "full" }),
            onLoad: handleChartLoaded,
            options: {
              backgroundColor: "transparent",
              pieHole: 0.8,
              pieResidueSliceColor: "transparent",
              pieSliceText: "none",
              pieStartAngle: 0,
              pieSliceBorderColor: "transparent",
              legend: "none",
              slices: {
                ...getSlicesStyle(data, allZero, emptyStyle),
                ...options == null ? void 0 : options.slices
              },
              chartArea: {
                width: "100%",
                height: "100%",
                ...options == null ? void 0 : options.chartArea
              },
              tooltip: {
                isHtml: true,
                trigger: "focus",
                ignoreBounds: false,
                ...options == null ? void 0 : options.tooltip
              },
              enableInteractivity: !allZero,
              ...options
            },
            rootProps: {
              "data-testid": testId,
              ...rootProps
            },
            width: "100%"
          }
        ),
        shouldRenderHoleContent && /* @__PURE__ */ jsx("div", { className: classNames(styles$h.chart_details, classes == null ? void 0 : classes.hole), children: typeof children === "function" ? children({ totalCount }) : children })
      ]
    }
  );
};
DonutChart.HoleText = HoleText;
DonutChart.SliceTooltip = SliceTooltip;
DonutChart.displayName = "DonutChart";
const useClickOutside = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && event.target.getAttribute("role") !== "menuitem") {
        callback();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback, ref]);
};
const item = "GAFE-components-item";
const disabled$2 = "GAFE-components-disabled";
const small = "GAFE-components-small";
const medium = "GAFE-components-medium";
const large = "GAFE-components-large";
const styles$g = {
  item,
  disabled: disabled$2,
  small,
  medium,
  large
};
const Item = ({
  children,
  className,
  disabled: disabled2,
  handleToggle,
  onClick,
  size: size2 = "medium",
  hidden,
  testId
}) => {
  const handleClick = useCallback(() => {
    if (!disabled2) {
      if (typeof handleToggle === "function") {
        handleToggle();
      }
      if (typeof onClick === "function") {
        onClick();
      }
    }
  }, [disabled2, handleToggle, onClick]);
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: classNames(className || styles$g.item, styles$g[size2], {
        [styles$g.disabled]: disabled2
      }),
      "data-testid": testId,
      onClick: handleClick,
      role: "menuitem",
      children
    }
  );
};
Item.displayName = "DropdownButton.Item";
const wrapper$2 = "GAFE-DropdownButton-wrapper";
const button = "GAFE-DropdownButton-button";
const menu = "GAFE-DropdownButton-menu";
const styles$f = {
  wrapper: wrapper$2,
  button,
  menu
};
const DropdownButton = ({
  isOpen,
  text: text2,
  children,
  width,
  testId = "dropdown-button",
  classes,
  dropdownWidth,
  dropdownPosition,
  ...buttonProps
}) => {
  var _a;
  const device = useDeviceDetection();
  const $width = useDeviceValue(device, width);
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOpened, setIsOpened] = useState(Boolean(isOpen));
  const [positions, setPositions] = useState({
    visibility: "hidden",
    top: 0
  });
  const css2 = ClassService(classes, {
    wrapper: styles$f.wrapper,
    button: styles$f.button,
    menu: styles$f.menu
  });
  const handleToggle = useCallback(() => {
    setIsOpened((open2) => !open2);
  }, []);
  useClickOutside(wrapperRef, () => {
    setIsOpened(false);
  });
  useEffect(() => {
    if (isOpened && buttonRef.current && menuRef.current) {
      const button2 = buttonRef.current.getBoundingClientRect();
      setPositions(() => {
        var _a2;
        const placements = {
          visibility: "visible",
          top: button2.top + button2.height + window.pageYOffset,
          left: button2.left + window.pageXOffset
        };
        if (dropdownPosition === "right") {
          return {
            ...placements,
            left: button2.left - (((_a2 = menuRef.current) == null ? void 0 : _a2.clientWidth) ?? 0) + button2.width
          };
        }
        return placements;
      });
    }
  }, [dropdownPosition, isOpened]);
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className: css2.wrapper,
      "data-testid": testId,
      ref: wrapperRef,
      style: { width: $width },
      children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            appendIcon: isOpened ? /* @__PURE__ */ jsx(IconChevronUp, {}) : /* @__PURE__ */ jsx(IconChevronDown, {}),
            className: css2.button,
            colorSchema: "primary",
            ...buttonProps,
            buttonRef,
            onClick: handleToggle,
            testId: `${testId}-button`,
            children: text2
          }
        ),
        isOpened && createPortal(
          /* @__PURE__ */ jsx(
            "section",
            {
              className: css2.menu,
              "data-testid": `${testId}-menu`,
              ref: menuRef,
              role: "menu",
              style: {
                width: dropdownWidth || ((_a = buttonRef.current) == null ? void 0 : _a.offsetWidth) || $width,
                ...positions
              },
              children: children.map(
                (child) => cloneElement(child, {
                  key: child.props.children.toString(),
                  handleToggle,
                  size: buttonProps.size,
                  className: classes == null ? void 0 : classes.item,
                  testId: `${testId}-${child.props.children.toString()}`
                })
              )
            }
          ),
          document.body
        )
      ]
    }
  );
};
DropdownButton.displayName = "DropdownButton";
DropdownButton.Item = Item;
const icon_popover = "GAFE-DropdownWithSearch-icon_popover";
const input_wrapper = "GAFE-DropdownWithSearch-input_wrapper";
const options_wrapper = "GAFE-DropdownWithSearch-options_wrapper";
const option_not_found_wrapper = "GAFE-DropdownWithSearch-option_not_found_wrapper";
const option_not_found_label = "GAFE-DropdownWithSearch-option_not_found_label";
const styles$e = {
  icon_popover,
  input_wrapper,
  options_wrapper,
  option_not_found_wrapper,
  option_not_found_label
};
const DropdownWithSearch = ({
  disabled: disabled2 = false,
  dropdownClasses,
  dropdownOptions,
  dropdownPlaceholder = "Select an option",
  dropdowntestId = "gafe-common-dropdown-with-search-dropdown",
  error: error2 = false,
  helper: helper2,
  inputClasses,
  inputPlaceholder = "Search...",
  inputTestId = "gafe-common-dropdown-with-search-input",
  noOptionsText = "No results found",
  onInputChange,
  onOptionClick,
  onOptionSelect,
  selectedOption,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const searchInputRef = useRef(null);
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);
  const setSearchInputRef = useCallback((element) => {
    searchInputRef.current = element;
  }, []);
  const dropdownCSS = ClassService(dropdownClasses, {
    label: styles$e.label,
    wrapper: styles$e.wrapper,
    dropdownValue: styles$e.dropdownValue,
    listWrapper: styles$e.listWrapper,
    helper: styles$e.helper
  });
  const inputCSS = ClassService(inputClasses, {
    input_label: styles$e.input_label,
    input_wrapper: styles$e.input_wrapper,
    input_listWrapper: styles$e.input_listWrapper,
    input_helper: styles$e.input_helper
  });
  const onInputChangeHandler = useCallback(
    (evt) => {
      if (typeof onInputChange === "function") {
        onInputChange(evt.target.value);
      }
      setInputValue(evt.target.value);
    },
    [onInputChange]
  );
  const onSelectOptionHandler = useCallback(
    (value) => {
      if (typeof onOptionSelect === "function") {
        onOptionSelect(value);
      }
    },
    [onOptionSelect]
  );
  const onOptionClickHandler = useCallback(
    (value) => {
      if (typeof onOptionClick === "function") {
        onOptionClick(value);
      }
    },
    [onOptionClick]
  );
  const getOptionClickHandler = (id) => {
    return () => onOptionClickHandler(id);
  };
  const onKeyDownHandler = useCallback((e) => {
    e.stopPropagation();
  }, []);
  const getDefaultOption = selectedOption ? dropdownOptions.filter((option) => option.id === selectedOption) : void 0;
  const filteredOptions = dropdownOptions.filter(
    (option) => toLower(option.label).includes(toLower(inputValue))
  );
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
    Dropdown,
    {
      classes: {
        label: dropdownCSS.label,
        wrapper: dropdownCSS.wrapper,
        dropdownValue: dropdownCSS.dropdownValue,
        listWrapper: dropdownCSS.listWrapper,
        helper: dropdownCSS.helper
      },
      defaultValue: getDefaultOption,
      disabled: disabled2,
      error: error2,
      helper: helper2,
      isIndexBased: false,
      onSelect: onSelectOptionHandler,
      placeholder: dropdownPlaceholder,
      setDropdownAsOpen: setIsOpen,
      testId: dropdowntestId,
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          TextInput,
          {
            classes: {
              wrapper: inputCSS.input_wrapper,
              label: inputCSS.input_label,
              input: inputCSS.input_input,
              helper: inputCSS.input_helper
            },
            innerRef: setSearchInputRef,
            onChange: onInputChangeHandler,
            onKeyDown: onKeyDownHandler,
            placeholder: inputPlaceholder,
            suffix: /* @__PURE__ */ jsx(IconSearch, { height: "xs", width: "xs" }),
            testId: inputTestId,
            value: inputValue
          }
        ),
        filteredOptions.length > 0 ? /* @__PURE__ */ jsx("div", { className: styles$e.options_wrapper, children: filteredOptions.map((option) => /* @__PURE__ */ jsx(
          Option,
          {
            label: option.id,
            onClick: getOptionClickHandler(option.id),
            text: option.label
          },
          option.id
        )) }) : /* @__PURE__ */ jsx(
          Option,
          {
            classes: {
              wrapper: styles$e.option_not_found_wrapper,
              label: styles$e.option_not_found_label
            },
            disabled: true,
            label: noOptionsText
          }
        )
      ]
    }
  ) });
};
function offset(anchor, amount) {
  const Offsets = {
    "3xs": "0.5rem",
    // 8px
    "2xs": "1rem",
    // 16px
    xs: "2rem",
    // 32px
    sm: "3rem",
    // 48px
    md: "4rem",
    // 64px
    lg: "5rem",
    // 80px
    xl: "6rem",
    // 96px
    "2xl": "7rem",
    // 112px
    "3xl": "8rem",
    // 128px
    none: "0px"
    // 0px
  };
  return `calc(env(safe-area-inset-${anchor}) + ${Offsets[amount]})`;
}
const offsetBottom = offset.bind(null, "bottom");
const offsetLeft = offset.bind(null, "left");
const offsetRight = offset.bind(null, "right");
const offsetTop = offset.bind(null, "top");
function FeedbackContainer({
  anchor = { desktop: [AnchorX.Right, AnchorY.Top], mobile: [AnchorX.Center, AnchorY.Top] },
  className,
  name,
  limit,
  offset: offset2
}) {
  const device = useDeviceDetection();
  const $anchor = useMemo(() => new DeviceValues(anchor).select(device), [anchor, device]);
  const $offset = useRectangle("none", device, offset2);
  const position = useMemo(() => {
    const [x, y] = $anchor;
    const $x = device === MediaType.Mobile ? AnchorX.Center : x;
    return `${y}-${$x}`;
  }, [$anchor, device]);
  const style = useMemo(() => {
    const $style = {
      bottom: offsetBottom($offset.bottom),
      height: "fit-content",
      left: offsetLeft($offset.left),
      padding: "var(--gap-xl)",
      right: offsetRight($offset.right),
      top: offsetTop($offset.top),
      width: device === MediaType.Mobile ? "100%" : "fit-content",
      transform: "translateX(0)"
    };
    const [x, y] = $anchor;
    if (device === MediaType.Mobile || x === AnchorX.Center) {
      $style.right = 0;
      $style.left = "50%";
      $style.transform = "translateX(-50%)";
    } else if (x === AnchorX.Right) {
      delete $style.left;
    } else {
      delete $style.right;
    }
    if (y === AnchorY.Bottom) {
      delete $style.top;
    } else {
      delete $style.bottom;
    }
    return $style;
  }, [$offset, $anchor, device]);
  return /* @__PURE__ */ jsx(
    ToastContainer$1,
    {
      className,
      containerId: name,
      limit,
      newestOnTop: true,
      position,
      style
    }
  );
}
class ListComponentModel {
  constructor(element) {
    this.element = element;
  }
  row(row) {
    const query = `[role="listitem"][data-row="${row}"]`;
    const found = this.element.querySelector(query);
    return Promise.resolve(firstDefined(null, found));
  }
}
const LoadingSkeleton = ({
  containerTestId = "gafe-loading-skeleton",
  flexParent = false,
  containerClassName,
  ...props
}) => {
  const flexClass = flexParent ? "flex-1" : "";
  return /* @__PURE__ */ jsx(
    Skeleton,
    {
      containerClassName: classNames(containerClassName, flexClass),
      containerTestId,
      ...props
    }
  );
};
const LoadingSkeletonTheme = (props) => {
  return /* @__PURE__ */ jsx(SkeletonTheme, { ...props });
};
const root$4 = "GAFE-Lozenge-root";
const prefix = "GAFE-Lozenge-prefix";
const suffix = "GAFE-Lozenge-suffix";
const styles$d = {
  root: root$4,
  prefix,
  suffix
};
const LozengeStatusStyleToColorSchema = {
  bold: {
    destructive: "destructive",
    disabled: "neutral-darkest",
    information: "information",
    success: "success",
    warning: "warning"
  },
  default: {
    destructive: "error-light",
    disabled: "neutral-lightest",
    information: "information-light",
    success: "success-light",
    warning: "warning-light"
  }
};
const Lozenge = ({
  children,
  className,
  classes,
  disabled: disabled2,
  onClose,
  prependIcon: prependIcon2,
  showCloseButton = false,
  status: status2 = "information",
  style = "default",
  testId,
  prefix: prefix2 = prependIcon2,
  variant = style,
  colorSchema = LozengeStatusStyleToColorSchema[variant][status2],
  ...props
}) => {
  const device = useDeviceDetection();
  const $prefix = useDeviceValue(device, prefix2);
  const $testId = firstDefined("gafe-common-lozenge", get(props, "data-testid"), testId);
  const handleClose = useCallback(
    (e) => {
      if (disabled2) {
        e.stopPropagation();
        return;
      }
      onClose == null ? void 0 : onClose.call(null);
    },
    [disabled2, onClose]
  );
  return /* @__PURE__ */ jsxs(
    Stack,
    {
      align: { items: "center" },
      className: classNames(styles$d.root, className, classes == null ? void 0 : classes.container),
      display: "inline-flex",
      gap: "2xs",
      orientation: "horizontal",
      ...pickDataAttributes(props),
      "data-color-schema": colorSchema,
      "data-disabled": disabled2,
      "data-testid": $testId,
      children: [
        $prefix && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$d.prefix, classes == null ? void 0 : classes.prependIcon),
            "data-color-iconography": true,
            "data-testid": `${$testId}-prefix`,
            children: $prefix
          }
        ),
        /* @__PURE__ */ jsx(Body, { "data-color-iconography": true, children }),
        showCloseButton && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$d.suffix, classes == null ? void 0 : classes.closeIcon),
            "data-color-iconography": true,
            "data-testid": `${$testId}-close`,
            children: /* @__PURE__ */ jsx(IconCancelOutlined, { onClick: handleClose })
          }
        )
      ]
    }
  );
};
function IconCheckboxSelected(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-checkbox-selected",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m2,2v20h20V2H2Zm9.33,13.21l-1.33,1.29-1.33-1.29-2.67-2.57,1.33-1.29,2.67,2.57,6.67-6.43,1.33,1.29-6.67,6.43Z",
            fill: "currentcolor"
          }
        )
      ] })
    }
  );
}
IconCheckboxSelected.displayName = "CheckboxSelected";
function IconCheckboxUnselected(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-checkbox-unselected",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("path", { d: "m20,4v16H4V4h16Zm2-2H2v20h20V2Z", fill: "currentcolor" })
      ] })
    }
  );
}
IconCheckboxUnselected.displayName = "CheckboxUnselected";
const container$1 = "GAFE-MessageBox-container";
const header = "GAFE-MessageBox-header";
const icon = "GAFE-MessageBox-icon";
const list = "GAFE-MessageBox-list";
const styles$c = {
  container: container$1,
  header,
  icon,
  list
};
const MessageBoxVariantToColorSchema = {
  error: "error-light",
  info: "information-light",
  success: "success-light",
  warning: "warning-light"
};
const MessageBoxSizeToWidth = {
  auto: "auto",
  full: "full",
  medium: "md",
  small: "sm"
};
const MessageBox = ({
  className,
  collapsibleContent = "list",
  disabled: disabled2,
  hideCollapseButton = false,
  isChecked,
  isExpanded = true,
  list: list2,
  listCollapse = 2,
  onClick,
  showCheckbox = true,
  size: size2 = "auto",
  subtitle,
  title: title2,
  variant = "info",
  colorSchema = MessageBoxVariantToColorSchema[variant],
  header: header2 = title2,
  width = MessageBoxSizeToWidth[size2],
  ...props
}) => {
  const device = useDeviceDetection();
  const [checked2, setChecked] = useState(Boolean(isChecked));
  const [collapse, setCollapse] = useState(Boolean(isExpanded));
  const showCollapseButton = list2 && list2.length > listCollapse && !hideCollapseButton;
  const isPartialCollapse = collapsibleContent === "list";
  const $header = useDeviceValue(device, header2);
  const $headerGap = isPartialCollapse ? true : collapse;
  const $showCheckbox = showCheckbox && (isPartialCollapse || collapse);
  useEffect(() => {
    setChecked(Boolean(isChecked));
  }, [isChecked]);
  useEffect(() => {
    if (hideCollapseButton) {
      setCollapse(true);
    }
  }, [hideCollapseButton]);
  const handleClick = useCallback(() => {
    if (typeof onClick === "function") {
      onClick(!checked2);
    }
    if (!disabled2) {
      setChecked(() => !checked2);
    }
  }, [checked2, disabled2, onClick]);
  const handleCollapse = useCallback(() => {
    setCollapse(() => !collapse);
  }, [collapse]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$c.container, className),
      "data-testid": "gafe-message-box",
      ...pickDataAttributes(props),
      "data-color-schema": colorSchema,
      "data-width": width,
      children: [
        /* @__PURE__ */ jsx(Hidden, { on: !$header, children: /* @__PURE__ */ jsx(Box, { className: styles$c.header, margin: { bottom: $headerGap ? "sm" : "none" }, children: /* @__PURE__ */ jsx(Subtitle3, { "data-testid": "gafe-message-box-header", children: $header }) }) }),
        /* @__PURE__ */ jsxs(Stack, { gap: "2xs", orientation: "horizontal", children: [
          /* @__PURE__ */ jsx(Hidden, { on: !$showCheckbox, children: /* @__PURE__ */ jsx(
            Box,
            {
              className: styles$c.icon,
              cursor: disabled2 ? "default" : "pointer",
              "data-checked": checked2,
              "data-color-iconography": true,
              "data-testid": "gafe-message-box-checkbox",
              children: checked2 ? /* @__PURE__ */ jsx(IconCheckboxSelected, { height: "sm", onClick: handleClick, width: "sm" }) : /* @__PURE__ */ jsx(
                IconCheckboxUnselected,
                {
                  colorSchema: "monochromatic-dark",
                  height: "sm",
                  onClick: handleClick,
                  width: "sm"
                }
              )
            }
          ) }),
          /* @__PURE__ */ jsx("section", { children: isPartialCollapse ? /* @__PURE__ */ jsxs(Fragment$1, { children: [
            /* @__PURE__ */ jsx(Hidden, { on: !subtitle, children: /* @__PURE__ */ jsx(Caption2, { "data-testid": "gafe-message-box-subtitle", children: subtitle }) }),
            /* @__PURE__ */ jsx(Hidden, { on: !(list2 == null ? void 0 : list2.length), children: /* @__PURE__ */ jsx("ul", { className: styles$c.list, "data-testid": "gafe-message-box-list", children: list2 == null ? void 0 : list2.slice(0, collapse ? list2.length : listCollapse).map((item2) => /* @__PURE__ */ jsx(Caption2, { TElement: "li", children: item2 }, item2.toString())) }) })
          ] }) : /* @__PURE__ */ jsxs(Collapsible, { isOpened: collapse, children: [
            /* @__PURE__ */ jsx(Hidden, { on: !subtitle, children: /* @__PURE__ */ jsx(Caption2, { "data-testid": "gafe-message-box-subtitle", children: subtitle }) }),
            /* @__PURE__ */ jsx(Hidden, { on: !(list2 == null ? void 0 : list2.length), children: /* @__PURE__ */ jsx("ul", { className: styles$c.list, "data-testid": "gafe-message-box-list", children: list2 == null ? void 0 : list2.map((item2) => /* @__PURE__ */ jsx(Caption2, { TElement: "li", children: item2 }, item2.toString())) }) })
          ] }) })
        ] }),
        /* @__PURE__ */ jsx(Hidden, { on: !showCollapseButton, children: /* @__PURE__ */ jsx(Box, { margin: { top: "sm" }, children: /* @__PURE__ */ jsx(
          Button,
          {
            colorSchema: "primary",
            "data-testid": "gafe-message-box-collapse-button",
            gutter: "sm",
            onClick: handleCollapse,
            suffix: /* @__PURE__ */ jsx(
              DualityIndicator,
              {
                disengaged: /* @__PURE__ */ jsx(IconChevronDown, {}),
                engaged: /* @__PURE__ */ jsx(IconChevronUp, {}),
                value: collapse
              }
            ),
            variant: "text",
            children: /* @__PURE__ */ jsx(DualityIndicator, { disengaged: "View more", engaged: "View less", value: collapse })
          }
        ) }) })
      ]
    }
  );
};
const useMobileOverflow = (isOpen) => {
  const mediaType = useDeviceDetection();
  useEffect(() => {
    if (mediaType === MediaType.Mobile && isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      if (mediaType === MediaType.Mobile && isOpen) {
        document.body.style.overflow = "initial";
      }
    };
  });
};
const wrapper$1 = "GAFE-MobileDrawer-wrapper";
const container = "GAFE-MobileDrawer-container";
const full = "GAFE-MobileDrawer-full";
const closed = "GAFE-MobileDrawer-closed";
const scroll_pipe_wrapper = "GAFE-MobileDrawer-scroll_pipe_wrapper";
const scroll_pipe = "GAFE-MobileDrawer-scroll_pipe";
const content$1 = "GAFE-MobileDrawer-content";
const styles$b = {
  wrapper: wrapper$1,
  container,
  full,
  closed,
  scroll_pipe_wrapper,
  scroll_pipe,
  content: content$1
};
const MobileDrawer = ({
  isOpen,
  classes,
  children,
  onClose,
  onRequestClose,
  disableHalf
}) => {
  const [mobileView, setMobileView] = useState("closed");
  const mediaType = useDeviceDetection();
  const css2 = ClassService(classes, {
    wrapper: styles$b.wrapper,
    container: styles$b.container,
    content: styles$b.content
  });
  const closeDrawer = useCallback(() => {
    if (onClose) {
      setMobileView("closed");
      setTimeout(onClose, 500);
    }
  }, [onClose]);
  const swipeHandler = useSwipeable({
    onSwipedUp: () => {
      setMobileView("full");
    },
    onSwipedDown: () => {
      if (mobileView === "half" || disableHalf) {
        if (typeof onRequestClose === "function") {
          onRequestClose();
          return;
        }
        closeDrawer();
        return;
      }
      setMobileView("half");
    },
    preventScrollOnSwipe: true,
    trackMouse: true
  });
  useMobileOverflow(isOpen);
  useEffect(() => {
    if (isOpen) {
      setMobileView(disableHalf ? "full" : "half");
    }
  }, [disableHalf, isOpen]);
  useEffect(() => {
    if (!isOpen) {
      closeDrawer();
    }
  }, [isOpen, closeDrawer]);
  if (mediaType === MediaType.Mobile && isOpen) {
    return /* @__PURE__ */ jsx("section", { className: css2.wrapper, "data-testid": "gafe-mobile-drawer", children: /* @__PURE__ */ jsxs(
      "section",
      {
        className: classNames(css2.container, {
          [styles$b.full]: mobileView === "full",
          [styles$b.closed]: mobileView === "closed"
        }),
        "data-testid": "gafe-mobile-drawer-container",
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: styles$b.scroll_pipe_wrapper,
              ...swipeHandler,
              "data-testid": "gafe-mobile-drawer-scroll-pipe",
              children: /* @__PURE__ */ jsx("div", { className: styles$b.scroll_pipe })
            }
          ),
          /* @__PURE__ */ jsx("section", { className: css2.content, "data-testid": "gafe-mobile-drawer-content", children })
        ]
      }
    ) });
  }
  return null;
};
const CustomTextInput = ({ customSuffix, customPrefix, ...rest }) => {
  const prefix2 = /* @__PURE__ */ jsx(Caption1, { colorSchema: "neutral-darkest", children: customPrefix });
  const suffix2 = /* @__PURE__ */ jsx(Caption1, { colorSchema: "neutral-darkest", children: customSuffix });
  return /* @__PURE__ */ jsx(TextInput, { prefix: prefix2, suffix: suffix2, ...rest });
};
const NumericInput = ({
  allowLeadingZeros = false,
  allowNegative = false,
  decimalScale = 0,
  decimalSeparator = ".",
  fixedDecimalScale = true,
  onChange,
  popover = {
    disabled: true
  },
  prefix: prefix2,
  suffix: suffix2,
  thousandSeparator = ",",
  BalloonProps = popover,
  ...rest
}) => {
  const device = useDeviceDetection();
  const $prefix = useDeviceValue(device, prefix2);
  const $suffix = useDeviceValue(device, suffix2);
  const handleChange = useCallback(
    (values, sourceInfo) => {
      if ((sourceInfo == null ? void 0 : sourceInfo.source) === "prop" || (sourceInfo == null ? void 0 : sourceInfo.event) === void 0 || values.value[0] === ".") {
        return;
      }
      if (typeof onChange === "function") {
        onChange(values.value);
      }
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx(Balloon, { placement: "top-end", ...BalloonProps, children: /* @__PURE__ */ jsx(
    NumericFormat,
    {
      allowLeadingZeros,
      allowNegative,
      customInput: CustomTextInput,
      customPrefix: $prefix,
      customSuffix: $suffix,
      "data-testid": "gafe-common-numeric-input",
      decimalScale,
      decimalSeparator,
      fixedDecimalScale,
      onValueChange: handleChange,
      thousandSeparator,
      ...rest
    }
  ) });
};
function IconWarningOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-warning-outlined",
      ...icon2,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M8.00016 2L14.6668 14H1.3335L8.00016 2ZM8.00016 4.66667L3.55572 12.6667H12.4446L8.00016 4.66667Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M7.3335 6.66667H8.66683V10H7.3335V6.66667Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx("path", { d: "M7.3335 10.6667H8.66683V12H7.3335V10.6667Z", fill: "currentcolor" })
      ]
    }
  );
}
IconWarningOutlined.displayName = "WarningOutlined";
function Popover({
  children,
  closeButton,
  footer: footer2,
  hidden = false,
  openByClick = false,
  placement = "top-start",
  testId,
  text: text2,
  title: title2,
  type = "info",
  ...props
}) {
  const device = useDeviceDetection();
  const $testId = firstDefined("gafe-common-popover", get(props, "data-testid"), testId);
  const $footer = useDeviceValue(device, footer2);
  const on = openByClick ? "click" : "hover";
  const warning = type === "warning" ? /* @__PURE__ */ jsx(IconWarningOutlined, {}) : void 0;
  const colorSchema = type === "warning" ? "warning" : "monochromatic-light";
  const variant = type === "warning" ? "outlined" : "contained";
  return /* @__PURE__ */ jsx(
    Balloon,
    {
      ...pickDataAttributes(props),
      PopupProps: {
        children: text2,
        header: title2,
        footer: $footer && /* @__PURE__ */ jsx(
          Stack,
          {
            gap: "3xs",
            justify: { content: "flex-end" },
            orientation: { desktop: "horizontal", mobile: "vertical" },
            children: $footer
          }
        ),
        prefix: warning,
        variant,
        width: { desktop: "md", mobile: "sm" },
        CloseProps: closeButton ? void 0 : false
      },
      colorSchema,
      "data-testid": $testId,
      disabled: hidden,
      on,
      placement,
      children
    }
  );
}
const root$3 = "GAFE-RadioButton-root";
const radio_input = "GAFE-RadioButton-radio_input";
const radio_icon = "GAFE-RadioButton-radio_icon";
const styles$a = {
  root: root$3,
  radio_input,
  radio_icon
};
const RadioButton = ({
  checked: checked2,
  className,
  disabled: disabled2,
  groupName,
  LabeledProps,
  onCheckedChanged,
  ...props
}) => {
  const [$checked, setChecked] = useAmbassadorState(checked2, onCheckedChanged, false);
  const id = useId();
  const checkRadioButtonHandler = useCallback(
    (e) => {
      setChecked(e.target.checked);
    },
    [setChecked]
  );
  const check = useCallback(() => {
    if ($checked) {
      return;
    }
    setChecked(true);
  }, [$checked, setChecked]);
  return /* @__PURE__ */ jsxs(
    Labeled,
    {
      ...LabeledProps,
      LabelProps: { ...LabeledProps == null ? void 0 : LabeledProps.LabelProps, Typography: Body, htmlFor: id },
      className: classNames(className, styles$a.root),
      "data-testid": "gafe-radio-button",
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            className: styles$a.radio_input,
            "data-testid": "gafe-radio-button-input",
            disabled: disabled2,
            id,
            type: "radio",
            ...pickDataAttributes(props),
            checked: $checked,
            name: groupName,
            onChange: checkRadioButtonHandler
          }
        ),
        /* @__PURE__ */ jsx("span", { className: styles$a.radio_icon, "data-testid": "gafe-radio-button-toggler", onClick: check })
      ]
    }
  );
};
function IconCheckmarkWithCircleOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-checkmark-with-circle-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { "data-name": "Layer 2", id: "Layer_2-2", children: [
        /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "m18.23,16.95c-1.11,1.41-2.66,2.41-4.41,2.83-1.74.42-3.58.24-5.2-.52-1.63-.75-2.95-2.04-3.77-3.64-.81-1.6-1.06-3.43-.71-5.2.35-1.76,1.29-3.36,2.65-4.52,1.36-1.17,3.08-1.84,4.87-1.9,1.79-.07,3.55.47,5,1.53l1.18-1.62c-1.81-1.33-4.01-2-6.25-1.92-2.24.08-4.39.92-6.09,2.38-1.71,1.46-2.87,3.45-3.31,5.65s-.13,4.49.89,6.49c1.01,2,2.67,3.61,4.71,4.55,2.03.94,4.33,1.17,6.5.65,2.18-.52,4.12-1.77,5.51-3.53,1.39-1.76,2.14-3.95,2.14-6.19h-1.99c0,1.8-.6,3.54-1.71,4.95Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "polygon",
            {
              fill: "currentcolor",
              points: "8.94 10.04 7.53 11.46 11.95 15.89 22 6.48 20.64 5.02 12 13.11 8.94 10.04"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: 24, width: 24 })
      ] })
    }
  );
}
IconCheckmarkWithCircleOutlined.displayName = "CheckmarkWithCircleOutlined";
function IconInfoOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-info-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "m11,16h1.92v-4.98h-1.92v4.98Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx("path", { d: "m11,10.02h1.92v-1.99h-1.92v1.99Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m22,12c0-5.52-4.48-10-10-10S2,6.48,2,12s4.48,10,10,10,10-4.48,10-10Zm-2,0c0-4.42-3.58-8-8-8S4,7.58,4,12s3.58,8,8,8,8-3.58,8-8Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" })
      ] })
    }
  );
}
IconInfoOutlined.displayName = "InfoOutlined";
function Reminder({
  className,
  children,
  header: header2,
  type = "info",
  onClose,
  ...props
}) {
  const prefixMap = {
    error: /* @__PURE__ */ jsx(IconWarningOutlined, { width: "sm" }),
    info: /* @__PURE__ */ jsx(IconInfoOutlined, { width: "sm" }),
    success: /* @__PURE__ */ jsx(IconCheckmarkWithCircleOutlined, { width: "sm" }),
    warning: /* @__PURE__ */ jsx(IconWarningOutlined, { width: "sm" })
  };
  const colorSchemaMap = {
    error: "error-light",
    info: "information-light",
    success: "success-light",
    warning: "warning-light"
  };
  return /* @__PURE__ */ jsx(
    Alert,
    {
      "data-testid": "gafe-reminder",
      ...pickDataAttributes(props),
      className: classNames(className),
      colorSchema: colorSchemaMap[type],
      header: /* @__PURE__ */ jsx(Subtitle3, { TElement: "header", children: header2 }),
      prefix: prefixMap[type],
      suffix: /* @__PURE__ */ jsx(IconCancelOutlined, { onClick: onClose, width: "md" }),
      variant: "contained",
      children: /* @__PURE__ */ jsx(Caption2, { colorSchema: "dark", children })
    }
  );
}
const Title6 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h6",
    "data-testid": "gafe-typography-title-six",
    ...props,
    "data-typography": "Title6",
    size: "md",
    weight: "semibold"
  }
);
const SectionTitle = ({ className, type, title: title2, subtitle }) => /* @__PURE__ */ jsx(
  Box,
  {
    className: classNames(className),
    "data-testid": "gafe-section-title",
    margin: { desktop: { bottom: "xl" }, mobile: { bottom: "md" } },
    children: /* @__PURE__ */ jsxs(Stack, { className: classNames(className), gap: "sm", children: [
      /* @__PURE__ */ jsxs(Stack, { align: { items: "center" }, gap: "3xs", orientation: "horizontal", children: [
        /* @__PURE__ */ jsx(
          Title6,
          {
            TElement: "h3",
            colorSchema: "monochromatic-dark",
            "data-testid": "gafe-section-title-header",
            children: title2
          }
        ),
        /* @__PURE__ */ jsx(Hidden, { on: !type, children: /* @__PURE__ */ jsxs(Caption, { "data-testid": "gafe-section-title-recommendation", children: [
          "(",
          type,
          ")"
        ] }) })
      ] }),
      /* @__PURE__ */ jsx(Hidden, { on: !subtitle, children: /* @__PURE__ */ jsx(
        Body,
        {
          TElement: "h4",
          colorSchema: "monochromatic-dark",
          "data-testid": "gafe-section-title-subtitle",
          children: subtitle
        }
      ) })
    ] })
  }
);
const SegmentedControlContext = createContext({});
const root$2 = "GAFE-Segment-root";
const styles$9 = {
  root: root$2
};
const PaddingToTypography = {
  "3xl": Body,
  "2xl": Body,
  xl: Body,
  lg: Body,
  md: Body,
  sm: Caption,
  xs: Caption,
  "2xs": Caption,
  "3xs": Caption
};
function Segment({ children, className, value, ...props }) {
  const {
    colorSchema,
    disabled: disabled2,
    padding,
    value: selected,
    onValueChange
  } = useContext(SegmentedControlContext);
  const device = useDeviceDetection();
  const $padding = useDeviceValue(device, padding, "md");
  const SegmentTypography = PaddingToTypography[$padding];
  const handleClick = useCallback(() => {
    if (selected !== value) {
      onValueChange == null ? void 0 : onValueChange.call(null, value);
    }
  }, [onValueChange, selected, value]);
  return /* @__PURE__ */ jsx(
    "button",
    {
      "data-testid": "gafe-common-segmented-button-segment",
      ...pickDataAttributes(props),
      className: classNames(styles$9.root, className),
      "data-color-schema": colorSchema,
      "data-padding": $padding,
      "data-selected": selected === value,
      "data-value": value,
      disabled: disabled2,
      onClick: handleClick,
      type: "button",
      children: /* @__PURE__ */ jsx(SegmentTypography, { TElement: "div", wrap: "ellipsis", children })
    }
  );
}
const root$1 = "GAFE-SegmentedControl-root";
const styles$8 = {
  root: root$1
};
const SegmentedControl = (props) => {
  const { children, className, value, onValueChange, width } = props;
  const device = useDeviceDetection();
  const $width = useDeviceValue(device, width);
  const [$value, setValue] = useAmbassadorState(value, onValueChange, "");
  return /* @__PURE__ */ jsx(SegmentedControlContext.Provider, { value: { ...props, value: $value, onValueChange: setValue }, children: /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": "gafe-common-segmented-button",
      ...pickDataAttributes(props),
      className: classNames(styles$8.root, className),
      "data-width": $width,
      children
    }
  ) });
};
SegmentedControl.Segment = Segment;
const sidebar = "GAFE-SidebarPanel-sidebar";
const show = "GAFE-SidebarPanel-show";
const sidebar_overlay = "GAFE-SidebarPanel-sidebar_overlay";
const sidebar_panel = "GAFE-SidebarPanel-sidebar_panel";
const close_button = "GAFE-SidebarPanel-close_button";
const styles$7 = {
  sidebar,
  show,
  sidebar_overlay,
  sidebar_panel,
  close_button
};
const SidebarPanel = ({ isOpen, onClose, children, classes }) => {
  const css2 = ClassService(classes, {
    container: styles$7.container,
    content: styles$7.content,
    wrapper: styles$7.wrapper
  });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$7.sidebar, css2.wrapper, { [styles$7.show]: isOpen }),
      "data-testid": "sidebar",
      children: [
        /* @__PURE__ */ jsx("div", { className: styles$7.sidebar_overlay, "data-testid": "sidebar-overlay", onClick: onClose }),
        /* @__PURE__ */ jsx("div", { className: classNames(styles$7.sidebar_panel, css2.container), children: /* @__PURE__ */ jsx("div", { className: classNames(styles$7.sidebar_panel_content, css2.content), children }) })
      ]
    }
  );
};
const calculateMark = (value, min, max, formatToPercents) => {
  if (formatToPercents) {
    const percentValue = Math.ceil(value * 100 / max);
    return `${percentValue}%`;
  }
  return (min + value).toFixed(2);
};
const getMarks = (marksCount, min, max, formatToPercents = false) => {
  const interval = (max - min) / marksCount;
  const marks = [];
  for (let i = 0; i <= marksCount; i++) {
    const value = i * interval;
    const mark2 = calculateMark(value, min, max, formatToPercents);
    marks.push(mark2);
  }
  return marks;
};
const thumb_wrapper = "GAFE-Thumb-thumb_wrapper";
const thumb = "GAFE-Thumb-thumb";
const dragging = "GAFE-Thumb-dragging";
const styles$6 = {
  thumb_wrapper,
  thumb,
  dragging
};
const Thumb = ({ props, value, renderTooltipValue, isDragged }) => {
  const renderValue = useCallback(
    (value2) => {
      if (renderTooltipValue) {
        return renderTooltipValue(value2);
      }
      return /* @__PURE__ */ jsx(Caption2, { children: value2 });
    },
    [renderTooltipValue]
  );
  return /* @__PURE__ */ createElement(
    "div",
    {
      ...props,
      className: styles$6.thumb_wrapper,
      "data-testid": "gafe-slider-thumb",
      key: props.key,
      style: props.style,
      ...pickDataAttributes(props)
    },
    /* @__PURE__ */ jsx(
      Balloon,
      {
        PopupProps: {
          width: "md",
          CloseProps: false,
          children: renderValue(value)
        },
        colorSchema: "primary",
        gap: "md",
        placement: "top",
        show: isDragged,
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$6.thumb, {
              [styles$6.dragging]: !isDragged
            })
          }
        )
      }
    )
  );
};
const track_wrapper = "GAFE-Track-track_wrapper";
const track = "GAFE-Track-track";
const styles$5 = {
  track_wrapper,
  track
};
const Track = ({ values, min, max, props, children }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: styles$5.track_wrapper,
      "data-testid": "gafe-slider-track",
      onMouseDown: props.onMouseDown,
      onTouchStart: props.onTouchStart,
      style: props.style,
      ...pickDataAttributes(props),
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: styles$5.track,
          ref: props.ref,
          style: {
            background: getTrackBackground({
              values,
              colors: ["#2774AE", "#F1F2F2"],
              min,
              max
            })
          },
          children
        }
      )
    }
  );
};
const marks_wrapper = "GAFE-Slider-marks_wrapper";
const mark = "GAFE-Slider-mark";
const styles$4 = {
  marks_wrapper,
  mark
};
const Slider = ({
  min,
  max,
  values,
  marksCount = 0,
  marksAsPercents = false,
  allowOverlap = false,
  disabled: disabled2 = false,
  renderTooltipValue,
  ...props
}) => {
  const marks = useMemo(() => {
    if (marksCount > 0) {
      return getMarks(marksCount, min, max, marksAsPercents);
    }
    return [];
  }, [marksAsPercents, marksCount, max, min]);
  const getThumb = useCallback(
    (props2) => {
      return /* @__PURE__ */ jsx(Thumb, { ...props2, renderTooltipValue });
    },
    [renderTooltipValue]
  );
  const getTrack = useCallback(
    ({ children, props: props2, ...restProps }) => {
      return /* @__PURE__ */ jsx(Track, { ...restProps, max, min, props: props2, values, children });
    },
    [max, min, values]
  );
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      Range,
      {
        ...props,
        allowOverlap,
        disabled: disabled2,
        renderThumb: getThumb,
        renderTrack: getTrack,
        values
      }
    ),
    marks.length > 0 && /* @__PURE__ */ jsx("div", { className: styles$4.marks_wrapper, children: marks.map((mark2) => /* @__PURE__ */ jsx("div", { className: styles$4.mark, children: /* @__PURE__ */ jsx(Caption, { children: mark2 }) }, mark2)) })
  ] });
};
class TableComponentModel {
  constructor(element) {
    this.element = element;
  }
  $section(name) {
    return Promise.resolve(this.element.querySelector(name));
  }
  head() {
    return this.$section("thead");
  }
  body() {
    return this.$section("tbody");
  }
  async row(row) {
    const body2 = await this.body();
    const query = `tr[data-row="${row}"]`;
    return firstDefined(null, body2 == null ? void 0 : body2.querySelector(query));
  }
  async header(column) {
    const head = await this.head();
    const query = `th[data-column="${column}"]`;
    return firstDefined(null, head == null ? void 0 : head.querySelector(query));
  }
  async cell(row, column) {
    const body2 = await this.body();
    const query = `td[data-row="${row}"][data-column="${column}"]`;
    return firstDefined(null, body2 == null ? void 0 : body2.querySelector(query));
  }
}
const tabs = "GAFE-Tabs-tabs";
const tab = "GAFE-Tabs-tab";
const styles$3 = {
  tabs,
  tab
};
function Tab({
  children,
  disabled: disabled2,
  className,
  name,
  width,
  border = "bottom",
  ...props
}) {
  return /* @__PURE__ */ jsx(
    Body,
    {
      ...pickDataAttributes(props),
      TElement: "div",
      className: classNames(styles$3.tab, className),
      "data-border": border,
      "data-disabled": disabled2,
      "data-name": name,
      "data-width": width,
      role: "tab",
      children
    }
  );
}
function Tabs({ active: active2, className, children, onActiveChange, ...props }) {
  const tabs2 = useRef(null);
  const [$active, $setActive] = useAmbassadorState(active2, onActiveChange);
  useEffect(() => {
    var _a, _b;
    const currentActive = (_a = tabs2.current) == null ? void 0 : _a.querySelector(`[role="tab"][data-active="true"]`);
    const targetActive = (_b = tabs2.current) == null ? void 0 : _b.querySelector(`[role="tab"][data-name="${$active}"]`);
    currentActive == null ? void 0 : currentActive.removeAttribute("data-active");
    targetActive == null ? void 0 : targetActive.setAttribute("data-active", "true");
  }, [$active]);
  const handleSwitchActive = useCallback(
    (e) => {
      const { target: target2 } = e;
      const tab2 = target2.closest('[role="tab"]');
      const disabled2 = tab2 == null ? void 0 : tab2.getAttribute("data-disabled");
      const next = tab2 == null ? void 0 : tab2.getAttribute("data-name");
      if (disabled2 !== "true" && next) {
        $setActive(next);
      }
    },
    [$setActive]
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles$3.tabs, className),
      onClick: handleSwitchActive,
      ref: tabs2,
      role: "tabList",
      ...pickDataAttributes(props),
      children
    }
  );
}
function IconFilledCircularCheckmark(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-filled-circular-checkmark",
      ...icon2,
      viewBox: "0 0 34 34",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.9987 0.333374C7.7987 0.333374 0.332031 7.80004 0.332031 17C0.332031 26.2 7.7987 33.6667 16.9987 33.6667C26.1987 33.6667 33.6654 26.2 33.6654 17C33.6654 7.80004 26.1987 0.333374 16.9987 0.333374ZM15.882 22.35L13.6654 24.5L11.4487 22.35L6.9987 18.0667L9.21536 15.9167L13.6654 20.2L24.782 9.48337L26.9987 11.6334L15.882 22.35Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconFilledCircularCheckmark.displayName = "FilledCircularCheckmark";
function IconFilledClock(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-filled-clock",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13.5 7.5L14.7287 8.36036L12.4384 11.6313L16.9065 14.7598L16.0457 15.9891L10.3515 12.002L11.2079 10.7789L11.2053 10.7771L13.5 7.5Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconFilledClock.displayName = "FilledClock";
function IconFilledExclamationSign(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-filled-exclamation-sign",
      ...icon2,
      viewBox: "0 0 34 34",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M16.9987 33.6667C26.2034 33.6667 33.6654 26.2048 33.6654 17C33.6654 7.79529 26.2034 0.333374 16.9987 0.333374C7.79395 0.333374 0.332031 7.79529 0.332031 17C0.332031 26.2048 7.79395 33.6667 16.9987 33.6667ZM15.332 10.3334H18.5273V18.6322H15.332V10.3334ZM15.332 20.2922H18.5273V23.6117H15.332V20.2922Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconFilledExclamationSign.displayName = "FilledExclamationSign";
function IconFilledRoundedCamera(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-filled-rounded-camera",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            fill: "color"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.4608 7.40054H13.3411L14.3012 8.36064H16.2214C16.4866 8.36064 16.7015 8.57556 16.7015 8.84068V15.5614C16.7015 15.8265 16.4866 16.0414 16.2214 16.0414H7.58056C7.31544 16.0414 7.10051 15.8265 7.10051 15.5614V8.84068C7.10051 8.57556 7.31544 8.36064 7.58056 8.36064H9.50075L10.4608 7.40054ZM11.901 15.0813C13.4917 15.0813 14.7813 13.7918 14.7813 12.201C14.7813 10.6103 13.4917 9.32073 11.901 9.32073C10.3102 9.32073 9.0207 10.6103 9.0207 12.201C9.0207 13.7918 10.3102 15.0813 11.901 15.0813ZM11.901 14.1212C10.8405 14.1212 9.9808 13.2615 9.9808 12.201C9.9808 11.1405 10.8405 10.2808 11.901 10.2808C12.9615 10.2808 13.8212 11.1405 13.8212 12.201C13.8212 13.2615 12.9615 14.1212 11.901 14.1212Z",
            fill: "white"
          }
        )
      ]
    }
  );
}
IconFilledRoundedCamera.displayName = "FilledRoundedCamera";
function IconFilledUpload(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-filled-upload",
      ...icon2,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M10 0L0 9H6V16H14V9H20L10 0Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx("path", { d: "M20 18H0V20H20V18Z", fill: "currentcolor" })
      ]
    }
  );
}
IconFilledUpload.displayName = "FilledUpload";
const card_wrapper = "GAFE-TaskCard-card_wrapper";
const title = "GAFE-TaskCard-title";
const title_hint_icon = "GAFE-TaskCard-title_hint_icon";
const title_disabled = "GAFE-TaskCard-title_disabled";
const content = "GAFE-TaskCard-content";
const icon_wrapper = "GAFE-TaskCard-icon_wrapper";
const accepted = "GAFE-TaskCard-accepted";
const pending_review = "GAFE-TaskCard-pending_review";
const rejected = "GAFE-TaskCard-rejected";
const upload_needed = "GAFE-TaskCard-upload_needed";
const photo_needed = "GAFE-TaskCard-photo_needed";
const no_action = "GAFE-TaskCard-no_action";
const status = "GAFE-TaskCard-status";
const sub_status = "GAFE-TaskCard-sub_status";
const disabled_status = "GAFE-TaskCard-disabled_status";
const action_button = "GAFE-TaskCard-action_button";
const action_button_disabled = "GAFE-TaskCard-action_button_disabled";
const footer = "GAFE-TaskCard-footer";
const disabled$1 = "GAFE-TaskCard-disabled";
const sub_status_footer = "GAFE-TaskCard-sub_status_footer";
const hidden_footer = "GAFE-TaskCard-hidden_footer";
const disabled_card = "GAFE-TaskCard-disabled_card";
const styles$2 = {
  card_wrapper,
  title,
  title_hint_icon,
  title_disabled,
  content,
  icon_wrapper,
  accepted,
  pending_review,
  rejected,
  upload_needed,
  photo_needed,
  no_action,
  status,
  sub_status,
  disabled_status,
  action_button,
  action_button_disabled,
  footer,
  disabled: disabled$1,
  sub_status_footer,
  hidden_footer,
  disabled_card
};
const TaskCard = ({
  title: title2,
  icon: icon2,
  status: status2,
  statusText,
  footer: footer2,
  disabled: disabled2 = false,
  disabledStatus = false,
  actionButtonText,
  actionButtonVariant,
  onActionButtonClick,
  hint,
  subStatus,
  testId = "gafe-common-task-card"
}) => {
  const getStatusIcon = useCallback(() => {
    switch (status2) {
      case "accepted":
        return /* @__PURE__ */ jsx(IconFilledCircularCheckmark, {});
      case "photo needed":
        return /* @__PURE__ */ jsx(IconFilledRoundedCamera, {});
      case "pending review":
        return /* @__PURE__ */ jsx(IconFilledClock, {});
      case "rejected":
        return /* @__PURE__ */ jsx(IconFilledExclamationSign, {});
      case "upload needed":
        return /* @__PURE__ */ jsx(IconFilledUpload, {});
      default: {
        return /* @__PURE__ */ jsx(IconFilledExclamationSign, {});
      }
    }
  }, [status2]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles$2.card_wrapper, { [styles$2.disabled_card]: disabled2 }),
      "data-testid": testId,
      children: [
        /* @__PURE__ */ jsxs("div", { className: classNames(styles$2.title, { [styles$2.title_disabled]: disabled2 }), children: [
          title2,
          hint && /* @__PURE__ */ jsx(
            Popover,
            {
              closeButton: true,
              placement: "bottom-start",
              testId: "task-card-popover-hint",
              text: hint.description,
              title: hint.title,
              children: /* @__PURE__ */ jsx(IconInfoOutlined, { className: styles$2.title_hint_icon })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: styles$2.content, children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames(styles$2.icon_wrapper, styles$2[snakeCase(status2)]),
              "data-testid": "task-card-icon-wrapper",
              children: icon2 ? icon2 : getStatusIcon()
            }
          ),
          /* @__PURE__ */ jsx(
            "span",
            {
              className: classNames(styles$2.status, {
                [styles$2.disabled_status]: disabledStatus
              }),
              children: statusText
            }
          ),
          subStatus && /* @__PURE__ */ jsx("span", { className: styles$2.sub_status, children: subStatus }),
          actionButtonText && /* @__PURE__ */ jsx(
            Button,
            {
              className: classNames(styles$2.action_button, {
                [styles$2.action_button_disabled]: disabled2
              }),
              colorSchema: "primary",
              "data-testid": "action-button",
              disabled: disabled2,
              onClick: onActionButtonClick,
              variant: actionButtonVariant ? "text" : "outlined",
              children: actionButtonText
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames(styles$2.footer, {
              [styles$2.hidden_footer]: !footer2,
              [styles$2.sub_status_footer]: subStatus,
              [styles$2.disabled]: disabled2
            }),
            children: footer2
          }
        )
      ]
    }
  );
};
const root = "GAFE-Textarea-root";
const resize_both = "GAFE-Textarea-resize_both";
const resize_horizontal = "GAFE-Textarea-resize_horizontal";
const resize_none = "GAFE-Textarea-resize_none";
const resize_vertical = "GAFE-Textarea-resize_vertical";
const textareaWrapper = "GAFE-Textarea-textareaWrapper";
const styles$1 = {
  root,
  resize_both,
  resize_horizontal,
  resize_none,
  resize_vertical,
  textareaWrapper
};
const Textarea = ({
  autofocus = false,
  classes,
  textareaRef,
  cols,
  counter,
  disabled: disabled2 = false,
  hasError = false,
  helper: helper2,
  id,
  label: label2,
  maxlength,
  name,
  onChange,
  placeholder: placeholder2,
  resize = "vertical",
  rows,
  size: size2 = "medium",
  tabIndex = 0,
  testId = "gafe-textarea",
  value,
  colorSchema = "form-field"
}) => {
  const [input2, setInput] = useState(value);
  const css2 = ClassService(classes, {
    wrapper: styles$1.wrapper,
    label: styles$1.label,
    textarea: styles$1.textarea,
    textareaWrapper: styles$1.textareaWrapper,
    helper: styles$1.helper,
    helperWrapper: styles$1.helperWrapper,
    counter: styles$1.counter,
    error: styles$1.error,
    disabled: styles$1.disabled
  });
  useEffect(() => {
    setInput(value);
  }, [value]);
  const onHandleChange = useCallback(
    (event) => {
      if (typeof onChange === "function" && !disabled2) {
        setInput(event.target.value);
        onChange(event.target.value);
      }
    },
    [disabled2, onChange]
  );
  const renderHelper = () => {
    return /* @__PURE__ */ jsxs(Grid, { columns: { desktop: "1fr 1fr" }, children: [
      /* @__PURE__ */ jsx(Hidden, { on: !helper2, children: /* @__PURE__ */ jsx(Caption1, { colorSchema: hasError ? "destructive" : "dark", children: helper2 }) }),
      /* @__PURE__ */ jsx(Hidden, { on: !counter, children: /* @__PURE__ */ jsx(GridSpan, { columnEnd: { desktop: 3 }, children: /* @__PURE__ */ jsx(Stack, { justify: { content: "flex-end" }, orientation: "horizontal", children: /* @__PURE__ */ jsxs(Caption1, { colorSchema: "dark", children: [
        (input2 == null ? void 0 : input2.toString().length) ?? 0,
        " / ",
        maxlength ?? /* @__PURE__ */ jsx(Fragment$1, { children: "∞" })
      ] }) }) }) })
    ] });
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: classNames(styles$1[size2], styles$1.root),
      "data-color-schema": colorSchema,
      "data-disabled": disabled2,
      children: /* @__PURE__ */ jsx(
        Labeled,
        {
          LabelProps: {
            htmlFor: id
          },
          label: label2,
          notes: renderHelper(),
          children: /* @__PURE__ */ jsx(Body, { TElement: "div", className: css2.textareaWrapper, children: /* @__PURE__ */ jsx(
            "textarea",
            {
              autoComplete: "off",
              autoFocus: autofocus,
              className: classNames(css2.textarea, styles$1[`resize_${resize}`]),
              cols,
              "data-error": hasError,
              "data-testid": testId,
              disabled: disabled2,
              id,
              maxLength: maxlength,
              name,
              onChange: onHandleChange,
              placeholder: placeholder2,
              ref: textareaRef,
              rows,
              tabIndex,
              value: input2
            }
          ) })
        }
      )
    }
  );
};
class FeedbackBuilder {
  constructor() {
    __publicField(this, "$feedback");
    __publicField(this, "success", this.severity.bind(this, "success"));
    __publicField(this, "information", this.severity.bind(this, "information"));
    __publicField(this, "warning", this.severity.bind(this, "warning"));
    __publicField(this, "error", this.severity.bind(this, "error"));
    __publicField(this, "short", this.timeout.bind(this, 5e3));
    __publicField(this, "long", this.timeout.bind(this, 3e4));
    __publicField(this, "forever", this.timeout.bind(this, 0));
    this.$feedback = {
      severity: "information",
      timeout: 0
    };
  }
  id(id) {
    this.$feedback.id = id;
    return this;
  }
  actions(actions) {
    this.$feedback.actions = actions;
    return this;
  }
  message(msg) {
    this.$feedback.message = msg;
    return this;
  }
  severity(severity) {
    this.$feedback.severity = severity;
    return this;
  }
  target(target2) {
    this.$feedback.target = target2;
    return this;
  }
  timeout(timeout) {
    this.$feedback.timeout = timeout;
    return this;
  }
  title(title2) {
    this.$feedback.title = title2;
    return this;
  }
  copy(other) {
    this.$feedback = { ...other };
    return this;
  }
  build() {
    return { ...this.$feedback };
  }
}
function IconWarning(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-warning",
      ...icon2,
      viewBox: "0 0 16 17",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M7.99998 2.5L14.6666 14.5H1.33331L7.99998 2.5ZM7.33331 7.16667H8.66665V10.5H7.33331V7.16667ZM8.66665 12.5V11.1667H7.33331V12.5H8.66665Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconWarning.displayName = "Warning";
function uuid() {
  return v4();
}
const ToastSeverityIcon = {
  error: /* @__PURE__ */ jsx(IconFilledExclamationSign, { height: "md", width: "md" }),
  information: /* @__PURE__ */ jsx(IconInfoFilled, { height: "md", width: "md" }),
  success: /* @__PURE__ */ jsx(IconFilledCircularCheckmark, { height: "md", width: "md" }),
  warning: /* @__PURE__ */ jsx(IconWarning, { height: "md", width: "md" })
};
const ToastDefaultTitle = {
  error: "Error",
  information: "Information",
  success: "Success",
  warning: "Warning"
};
class FeedbackServiceToast {
  show(feedback) {
    const { severity, actions, title: title2 } = feedback;
    const icon2 = ToastSeverityIcon[severity];
    const $title = firstTruthy(ToastDefaultTitle[severity], title2);
    const $id = `${firstDefined(`feedback-${uuid()}`, feedback.id)}`;
    const id = toast(
      ({ toastProps: { closeToast } }) => /* @__PURE__ */ jsx(
        Alert,
        {
          colorSchema: severity,
          footer: actions,
          header: $title,
          prefix: icon2,
          suffix: /* @__PURE__ */ jsx(IconCancelOutlined, { onClick: closeToast, width: "sm" }),
          width: { desktop: "md", mobile: "full" },
          children: feedback.message
        }
      ),
      {
        autoClose: feedback.timeout > 0 ? feedback.timeout : false,
        closeButton: false,
        closeOnClick: false,
        containerId: feedback.target,
        draggable: false,
        hideProgressBar: true,
        icon: void 0,
        pauseOnHover: true,
        rtl: false,
        bodyStyle: { padding: 0 },
        style: {
          padding: 0,
          borderWidth: "0",
          borderRadius: 0,
          backgroundColor: "transparent",
          marginBottom: `var(--gap-md)`
        },
        transition: Slide,
        toastId: $id
      }
    );
    return Promise.resolve(new FeedbackBuilder().copy(feedback).id(String(id)).build());
  }
  dismiss(feedback) {
    const id = typeof feedback === "string" ? feedback : feedback.id;
    const containerId = typeof feedback === "string" ? void 0 : feedback.target;
    if (id && containerId) {
      toast.dismiss({ id, containerId });
    } else if (id) {
      toast.dismiss(id);
    }
    return Promise.resolve();
  }
}
const Toast = ({
  action,
  containerId = "gafe-common-toast-container",
  dismissive = true,
  dismissTimeout = 5e3,
  message,
  toastId,
  type = "information",
  title: title2
}) => {
  const service = new FeedbackServiceToast();
  const feedback = new FeedbackBuilder().actions(action && /* @__PURE__ */ jsx(LinkButton, { onClick: action.onClick, text: action.label })).target(containerId).timeout(dismissive ? dismissTimeout : 0).severity(type === "destructive" ? "error" : type).id(toastId ? String(toastId) : void 0).target(containerId).message(message).title(title2).build();
  service.show(feedback);
};
const ToastContainer = ({
  containerId = "gafe-common-toast-container",
  limit = 1
}) => {
  return /* @__PURE__ */ jsx(FeedbackContainer, { limit, name: String(containerId), offset: { top: "md" } });
};
ToastContainer.displayName = "ToastContainer";
const wrapper = "GAFE-Toggle-wrapper";
const disabled = "GAFE-Toggle-disabled";
const checked = "GAFE-Toggle-checked";
const always_active = "GAFE-Toggle-always_active";
const styles = {
  wrapper,
  disabled,
  checked,
  always_active
};
const Toggle = ({
  checked: checked2,
  disabled: disabled2 = false,
  alwaysActive = false,
  onClick,
  tabIndex = 0,
  testId = "gafe-common-toggle-wrapper"
}) => {
  const [isChecked, setChecked] = useAmbassadorState(checked2, onClick, false);
  const handleClick = useCallback(() => {
    if (!disabled2) {
      setChecked(!isChecked);
    }
  }, [disabled2, isChecked, setChecked]);
  const handleKeyPress = useCallback(
    (e) => {
      if (!disabled2 && ["Space", "Enter"].includes(e.code)) {
        setChecked((checked22) => !checked22);
      }
    },
    [disabled2, setChecked]
  );
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: classNames(styles.wrapper, {
        [styles.disabled]: disabled2,
        [styles.checked]: isChecked,
        [styles.always_active]: alwaysActive
      }),
      "data-testid": testId,
      onClick: handleClick,
      onKeyDown: handleKeyPress,
      tabIndex
    }
  );
};
const ToggleableCard = ({
  opened: opened2,
  disabled: disabled2 = false,
  title: title2,
  description,
  children,
  hideToggle,
  onCheckChanged,
  borderless = false,
  ...extraProps
}) => {
  const [isChecked, setChecked] = useState(opened2);
  const handleToggleClick = useCallback(
    (value) => {
      setChecked(value);
      onCheckChanged == null ? void 0 : onCheckChanged.call(null, value);
    },
    [onCheckChanged]
  );
  useEffect(() => {
    setChecked(opened2);
  }, [opened2]);
  const renderHeader = useCallback(() => {
    return /* @__PURE__ */ jsxs(
      Stack,
      {
        align: { items: "center" },
        justify: { content: "space-between" },
        orientation: { desktop: "horizontal" },
        children: [
          /* @__PURE__ */ jsx(Typography, { TElement: "label", colorSchema: "primary-dark", size: "xs", weight: "medium", children: title2 }),
          /* @__PURE__ */ jsx(Hidden, { on: Boolean(hideToggle), children: /* @__PURE__ */ jsx(
            Labeled,
            {
              LabelProps: {
                Typography: Body,
                TypographyProps: {
                  colorSchema: "dark"
                }
              },
              LayoutProps: {
                align: {
                  items: "center"
                },
                orientation: "horizontal"
              },
              label: isChecked ? "Yes" : "No",
              position: "prefix",
              children: /* @__PURE__ */ jsx(Toggle, { checked: isChecked, disabled: disabled2, onClick: handleToggleClick })
            }
          ) })
        ]
      }
    );
  }, [title2, isChecked, disabled2, hideToggle, handleToggleClick]);
  return /* @__PURE__ */ jsx(
    Card,
    {
      borderless,
      compact: true,
      flat: true,
      renderHeader,
      rounded: true,
      width: "full",
      ...pickDataAttributes(extraProps),
      children: /* @__PURE__ */ jsx(Collapsible, { isOpened: isChecked, children: /* @__PURE__ */ jsxs(Stack, { gap: "sm", orientation: "vertical", children: [
        description && /* @__PURE__ */ jsx(Body, { colorSchema: "dark", "data-testid": "toggleablecard-description", children: description }),
        children
      ] }) })
    }
  );
};
const Tooltip = ({
  children,
  hidden = false,
  disabled: disabled2 = hidden,
  placement = "top-start",
  testId = "gafe-common-tooltip",
  text: text2,
  ...props
}) => {
  const $testId = firstDefined("gafe-common-tooltip", get(props, "data-testid"), testId);
  return /* @__PURE__ */ jsx(
    Balloon,
    {
      ...props,
      PopupProps: {
        children: /* @__PURE__ */ jsx(Caption2, { children: text2 }),
        CloseProps: false
      },
      colorSchema: "information-light",
      "data-testid": $testId,
      disabled: disabled2,
      on: "hover",
      placement,
      children
    }
  );
};
const ButtonTextLarge = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-button-text-large",
    ...props,
    "data-typography": "ButtonTextLarge",
    size: "xs",
    transform: "uppercase",
    weight: "semibold"
  }
);
const Subtitle = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    "data-testid": "gafe-typography-subtitle",
    ...props,
    "data-typography": "Subtitle",
    size: "sm",
    weight: "semibold"
  }
);
const Subtitle1 = Subtitle;
const Title = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h1",
    "data-testid": "gafe-typography-title",
    ...props,
    "data-typography": "Title",
    size: "3xl",
    weight: "semibold"
  }
);
const Title1 = Title;
const Title2 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h2",
    "data-testid": "gafe-typography-title-two",
    ...props,
    "data-typography": "Title2",
    size: "2xl",
    weight: "semibold"
  }
);
const Title4 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h4",
    "data-testid": "gafe-typography-title-four",
    ...props,
    "data-typography": "Title4",
    size: "lg",
    weight: "semibold"
  }
);
const Title5 = ({ ...props }) => /* @__PURE__ */ jsx(
  Typography,
  {
    TElement: "h5",
    "data-testid": "gafe-typography-title-five",
    ...props,
    "data-typography": "Title5",
    size: "md",
    weight: "bold"
  }
);
function Wizard({ children, pageId: page, ...props }) {
  const $children = useMemo(() => castArray(children), [children]);
  const $current = useMemo(
    () => firstDefined(null, first($children.filter((ch) => ch.props.pageId === page)), first($children)),
    [$children, page]
  );
  return /* @__PURE__ */ jsx("div", { "data-testid": "gafe-common-wizard", ...pickDataAttributes(props), children: $current });
}
function WizardPage({ children, pageId: id, ...props }) {
  return /* @__PURE__ */ jsx("div", { "data-testid": "gafe-common-wizard-page", ...pickDataAttributes(props), "data-wizard-page": id, children });
}
function useToday() {
  return useMemo(() => startOfDay(/* @__PURE__ */ new Date()), []);
}
function IconAdditionalActions(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-additional-actions",
      ...icon2,
      viewBox: "0 0 4 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: "2", cy: "2", fill: "currentColor", r: "2" }),
        /* @__PURE__ */ jsx("circle", { cx: "2", cy: "10", fill: "currentColor", r: "2" }),
        /* @__PURE__ */ jsx("circle", { cx: "2", cy: "18", fill: "currentColor", r: "2" })
      ] })
    }
  );
}
IconAdditionalActions.displayName = "AdditionalActions";
function IconAddPerson(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-add-person",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M11.3333 10C12.9901 10 14.3333 8.65685 14.3333 7C14.3333 5.34315 12.9901 4 11.3333 4C9.6764 4 8.33325 5.34315 8.33325 7C8.33325 8.65685 9.6764 10 11.3333 10ZM11.3333 12C14.0947 12 16.3333 9.76142 16.3333 7C16.3333 4.23858 14.0947 2 11.3333 2C8.57183 2 6.33325 4.23858 6.33325 7C6.33325 9.76142 8.57183 12 11.3333 12Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M2.33325 16C2.33325 14.8954 3.34061 14 4.58325 14H16.3333C16.3333 15 16.3333 15 16.3333 16H15.8333H15.3333H13.3333C13.3333 16 11.5833 16 11.3333 16C11.0833 16 5.08325 16 5.08325 16C4.80711 16 4.58325 16.2239 4.58325 16.5V22H2.33325V16Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19.1233 14L17.5333 14V17.2059H14.3333V18.8059H17.5333V22H19.1333V18.8H22.3333V17.2059L19.1233 17.2159V14Z",
            fill: "currentcolor"
          }
        )
      ]
    }
  );
}
IconAddPerson.displayName = "AddPerson";
function IconBulletedListFilled({ ...props }) {
  const icon2 = useIcon({ ...props });
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-bulleted-list-filled",
      ...icon2,
      fill: "none",
      viewBox: "0 0 12 10",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M1.33333 0.333496H0V1.66683H1.33333V0.333496Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M1.33333 4.3335H0V5.66683H1.33333V4.3335Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M1.33333 8.3335H0V9.66683H1.33333V8.3335Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M12 0.333496H2.66667V1.66683H12V0.333496Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M12 4.3335H2.66667V5.66683H12V4.3335Z", fill: "currentColor" }),
        /* @__PURE__ */ jsx("path", { d: "M12 8.3335H2.66667V9.66683H12V8.3335Z", fill: "currentColor" })
      ]
    }
  );
}
IconBulletedListFilled.displayName = "BulletedListFilled";
function IconCalendar(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-calendar",
      ...icon2,
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M29.9987 8.33366V6.66699H26.6654V8.33366H13.332V6.66699H9.9987V8.33366H3.33203V33.3337H36.6654V8.33366H29.9987ZM33.332 18.3337H6.66536V15.0003H33.332V18.3337Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconCalendar.displayName = "Calendar";
function IconCancelFilled(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-cancel-filled",
      ...icon2,
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "m0,0v20h20V0H0Zm16,14.67l-1.33,1.33-4.67-4.67-4.67,4.67-1.33-1.33,4.67-4.67-4.67-4.67,1.33-1.33,4.67,4.67,4.67-4.67,1.33,1.33-4.67,4.67,4.67,4.67Z",
          fill: "currentcolor"
        }
      ) })
    }
  );
}
IconCancelFilled.displayName = "CancelFilled";
function IconCartOutlined({ ...props }) {
  const icon2 = useIcon({ ...props });
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-cart-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 14 12",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M0.332031 0H2.66536L3.14156 2.66667H13.6654L11.7765 9.33333H2.96166L2.91197 8.80717L1.68002 1.33333H0.332031V0ZM4.13362 8.22222H10.7933L12.0525 3.77778H3.33997L4.13362 8.22222Z",
            fill: "currentColor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.33203 12C9.88432 12 10.332 11.5523 10.332 11C10.332 10.4477 9.88432 10 9.33203 10C8.77975 10 8.33203 10.4477 8.33203 11C8.33203 11.5523 8.77975 12 9.33203 12Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6.33203 11C6.33203 11.5523 5.88432 12 5.33203 12C4.77975 12 4.33203 11.5523 4.33203 11C4.33203 10.4477 4.77975 10 5.33203 10C5.88432 10 6.33203 10.4477 6.33203 11Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
IconCartOutlined.displayName = "CartOutlined";
function IconChevronUpDown(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-chevron-up-down",
      ...icon2,
      viewBox: "0 0 11 14",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M5.70832 0.000230098C5.54834 0.00468286 5.3959 0.0692516 5.2814 0.18107L0.643581 4.70454C0.583762 4.76293 0.53603 4.83253 0.503109 4.90937C0.470189 4.98621 0.452725 5.06878 0.451715 5.15237C0.450705 5.23595 0.466169 5.31892 0.497224 5.39653C0.528278 5.47414 0.574315 5.54488 0.632706 5.6047C0.691097 5.66452 0.760699 5.71225 0.837537 5.74517C0.914375 5.77809 0.996945 5.79555 1.08053 5.79656C1.16412 5.79757 1.24709 5.78211 1.3247 5.75105C1.40231 5.72 1.47304 5.67396 1.53286 5.61557L5.72572 1.52525L9.91859 5.61557C9.9784 5.67398 10.0491 5.72002 10.1268 5.75109C10.2044 5.78215 10.2873 5.79762 10.3709 5.79662C10.4545 5.79561 10.5371 5.77815 10.614 5.74523C10.6908 5.71231 10.7604 5.66458 10.8188 5.60475C10.8772 5.54493 10.9232 5.47419 10.9543 5.39657C10.9853 5.31895 11.0008 5.23598 10.9998 5.15238C10.9988 5.06879 10.9813 4.98621 10.9484 4.90937C10.9154 4.83253 10.8677 4.76293 10.8079 4.70454L6.17006 0.18107C6.10911 0.121561 6.03684 0.0748926 5.95753 0.0438292C5.87821 0.0127658 5.79347 -0.00206014 5.70832 0.000230098ZM1.07362 8.19766C0.946874 8.19912 0.823452 8.23839 0.71917 8.31044C0.614888 8.38249 0.534496 8.48404 0.488298 8.60208C0.442099 8.72011 0.432198 8.84925 0.459864 8.97295C0.487529 9.09664 0.551501 9.20926 0.643581 9.29637L5.2814 13.8192C5.40026 13.9351 5.5597 14 5.72572 14C5.89175 14 6.0512 13.9351 6.17006 13.8192L10.8079 9.29637C10.9288 9.17844 10.9979 9.01732 11 8.84845C11.0021 8.67958 10.937 8.51679 10.8191 8.3959C10.7011 8.27501 10.54 8.20591 10.3711 8.20381C10.2023 8.20172 10.0395 8.26679 9.91859 8.38471L5.72572 12.475L1.53286 8.38471C1.47273 8.32439 1.40109 8.27675 1.32221 8.24462C1.24332 8.21249 1.15879 8.19652 1.07362 8.19766Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconChevronUpDown.displayName = "ChevronUpDown";
function IconClock(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-clock",
      ...icon2,
      viewBox: "0 0 21 23",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { id: "Group 544", children: [
        /* @__PURE__ */ jsx("ellipse", { cx: "10.6797", cy: "12.0449", fill: "currentcolor", id: "Ellipse 64", rx: "10", ry: "10" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.2468 5.10937C11.2468 4.87813 11.0594 4.69066 10.8281 4.69066C10.5969 4.69066 10.4094 4.87813 10.4094 5.10938L11.2468 5.10937ZM10.4094 5.10938L10.4094 12.0447L11.2468 12.0447L11.2468 5.10937L10.4094 5.10938Z",
            fill: "white",
            id: "Line 8"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.526 1.45117L11.526 0.753319L10.1303 0.753319L10.1303 1.45117L11.526 1.45117ZM10.1303 1.45117L10.1303 4.12812L11.526 4.12812L11.526 1.45117L10.1303 1.45117Z",
            fill: "currentcolor",
            id: "Line 9"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18.5865 4.91902C18.8309 4.62097 18.7874 4.18127 18.4893 3.93691C18.1913 3.69254 17.7516 3.73606 17.5072 4.03411L18.5865 4.91902ZM17.5072 4.03411L15.81 6.10422L16.8893 6.98913L18.5865 4.91902L17.5072 4.03411Z",
            fill: "currentcolor",
            id: "Line 10"
          }
        ),
        /* @__PURE__ */ jsx("ellipse", { cx: "10.8222", cy: "12.0448", fill: "white", id: "Ellipse 65", rx: "1.26747", ry: "1.26747" })
      ] })
    }
  );
}
IconClock.displayName = "Clock";
function IconEditFilled(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-filled-edit",
      ...icon2,
      fill: "none",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M16.747 2L20.0532 5.34546L7.52028 17.7563L4.1961 17.7384L4.21403 14.4109L16.747 2Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M2.99695 22H20.979V20H2.99695V22Z", fill: "currentColor" })
      ]
    }
  );
}
IconEditFilled.displayName = "EditFilled";
function IconEditOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-edit-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M16.0629 2L4.06662 13.8794L4.04328 18.212L8.3715 18.2354L20.3678 6.35593L16.0629 2ZM6.06013 14.7186L16.0477 4.82839L17.5422 6.34067L7.55469 16.2309L6.05202 16.2228L6.06013 14.7186Z",
            fill: "currentColor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M2.99695 22H20.979V20H2.99695V22Z", fill: "currentColor" })
      ]
    }
  );
}
IconEditOutlined.displayName = "EditOutlined";
function IconExclamationSignOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-exclamation-sign-outlined",
      ...icon2,
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M7.3335 5.33337H8.61161V8.6529H7.3335V5.33337Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx("path", { d: "M7.3335 9.31691H8.61161V10.6447H7.3335V9.31691Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004ZM13.3335 8.00004C13.3335 10.9456 10.9457 13.3334 8.00016 13.3334C5.05464 13.3334 2.66683 10.9456 2.66683 8.00004C2.66683 5.05452 5.05464 2.66671 8.00016 2.66671C10.9457 2.66671 13.3335 5.05452 13.3335 8.00004Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        )
      ]
    }
  );
}
IconExclamationSignOutlined.displayName = "ExclamationSignOutlined";
function IconExit(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-exit",
      ...icon2,
      viewBox: "0 0 21 21",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M6.16602 0.5H20.166V20.5H6.16602V13.5H13.166V7.5H6.16602V0.5Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M3.85832 14.5L0.166016 10.5L3.85832 6.5L4.7814 7.5L2.93525 9.5H12.166V11.5H2.93525L4.7814 13.5L3.85832 14.5Z",
            fill: "currentcolor"
          }
        )
      ]
    }
  );
}
IconExit.displayName = "Exit";
function IconExternalLinkOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-external-link-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { children: [
          /* @__PURE__ */ jsx(
            "rect",
            {
              fill: "currentcolor",
              height: "2",
              transform: "translate(-3.46 12.62) rotate(-45)",
              width: "14",
              x: "6.51",
              y: "9.48"
            }
          ),
          /* @__PURE__ */ jsx(
            "polygon",
            {
              fill: "currentcolor",
              points: "18 20 4 20 4 6 13.86 6 13.86 4 2 4 2 22 20 22 20 10.14 18 10.14 18 20"
            }
          ),
          /* @__PURE__ */ jsx("polygon", { fill: "currentcolor", points: "14.93 2 22 9.07 22 2 14.93 2" })
        ] }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" })
      ]
    }
  );
}
IconExternalLinkOutlined.displayName = "ExternalLinkOutlined";
function IconFilledDelete(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-filled-delete",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M19 6H5V21H19V6Z", fill: "currentcolor" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M14.7429 2H9.25715L8 3H4V5H20V3H16L14.7429 2Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        )
      ]
    }
  );
}
IconFilledDelete.displayName = "FilledDelete";
function IconFilterFunnel({ ...props }) {
  const icon2 = useIcon({ ...props });
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-filter-funnel",
      ...icon2,
      fill: "none",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.81735 4.72239C2.18706 4.01796 1.87192 3.66574 1.86003 3.3664C1.84971 3.10636 1.96145 2.85643 2.16213 2.69074C2.39313 2.5 2.86576 2.5 3.811 2.5H16.1801C17.1254 2.5 17.598 2.5 17.829 2.69074C18.0297 2.85643 18.1414 3.10636 18.1311 3.3664C18.1192 3.66574 17.8041 4.01796 17.1738 4.72239L12.4186 10.037C12.2929 10.1774 12.2301 10.2477 12.1853 10.3276C12.1456 10.3984 12.1164 10.4747 12.0988 10.554C12.0789 10.6435 12.0789 10.7377 12.0789 10.9261V15.382C12.0789 15.5449 12.0789 15.6264 12.0526 15.6969C12.0294 15.7591 11.9916 15.8149 11.9424 15.8596C11.8868 15.9102 11.8111 15.9404 11.6598 16.001L8.82648 17.1343C8.5202 17.2568 8.36705 17.3181 8.24412 17.2925C8.13661 17.2702 8.04227 17.2063 7.9816 17.1148C7.91222 17.0101 7.91222 16.8452 7.91222 16.5153V10.9261C7.91222 10.7377 7.91222 10.6435 7.89232 10.554C7.87468 10.4747 7.84553 10.3984 7.8058 10.3276C7.761 10.2477 7.69818 10.1774 7.57254 10.037L2.81735 4.72239Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.66667"
        }
      )
    }
  );
}
IconFilterFunnel.displayName = "FilterFunnel";
function IconGafeIsoLogo(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-gafe-iso-logo",
      ...icon2,
      viewBox: "0 0 80 80",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_2855_1334)", children: [
          /* @__PURE__ */ jsx("path", { d: "M77.607 77.6075H2.39282V2.39233H77.607V77.6075Z", fill: "white" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M80 80V0H0V80H80ZM77.6071 77.6076H2.39289V2.39244H77.6073V77.6076H77.6071Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M39.9939 36.8102L42.4206 28.8118L44.881 36.8102H39.9939ZM71.147 26.6649V21.6436H53.4092V42.8056L45.737 21.6436H39.1041L31.4335 42.8056V31.3873H21.3237V36.1696H24.297C24.297 36.9331 22.8108 38.8596 20.2346 38.8596C18.6599 38.8596 15.5108 38.5002 15.5108 32.0453C15.5108 25.5889 19.9315 25.6489 19.9315 25.6489C23.6843 25.6489 24.1697 28.5785 24.1697 28.5785H30.8886C29.7388 22.3009 24.5928 20.8078 20.3552 20.688C16.1174 20.5673 8.85278 23.1985 8.85278 32.0453C8.85278 40.8922 13.8177 44.2369 19.1443 44.3596C24.2903 44.4791 26.5299 41.1311 26.5299 41.1311V44.1207H37.7301L38.6095 41.2509H46.2363L47.1128 44.1207H60.5526V36.1696H68.9681V31.3873H60.5526V26.6651H71.147V26.6649Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M18.7833 58.3562V56.1011H14.0724V54.6511H17.8464V52.3964H14.0724V50.9473H18.7831V48.6926H10.9053V58.3562H18.7833Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M23.0407 48.6926H20.0745V58.3562H23.1076V55.2962V53.2793L26.4362 58.3562H29.4025V48.6926H26.3694V51.7662V53.7822L23.0407 48.6926Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M38.9876 58.3562V56.1011H34.2767V54.6511H38.0505V52.3964H34.2767V50.9473H38.9869V48.6926H31.1094V58.3562H38.9876Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M43.4457 50.9473H44.9223C45.6603 50.9473 46.1972 51.2695 46.1972 51.9542C46.1972 52.6255 45.6739 52.8669 44.6939 52.8669H43.4457V50.9473V50.9473ZM44.4121 54.9871C45.8886 54.9871 46.103 55.4033 46.103 56.6649C46.103 57.524 46.1837 58.1411 46.2639 58.356H49.4717C49.4717 58.356 49.1363 57.6309 49.1363 56.3695C49.1363 54.4237 48.5192 54.1817 47.499 53.8062C48.6263 53.4971 49.123 52.558 49.123 51.4442C49.123 49.5648 48.0628 48.6926 44.8419 48.6926H40.2786V58.356H43.4457V54.9871H44.4121V54.9871Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M59.8513 53.0411H55.5162V55.1351H56.912C56.7506 55.8064 55.9324 56.2491 55.288 56.2491C53.6906 56.2491 53.2611 55.0011 53.2611 53.6322C53.2611 51.9275 53.8517 50.8004 55.0999 50.8004C55.9188 50.8004 56.4955 51.2298 56.7237 52.0213H59.7302C59.3411 49.6458 57.4755 48.438 55.1533 48.438C52.0264 48.438 50.0935 50.5582 50.0935 53.6453C50.0935 57.0142 52.3082 58.6115 54.7775 58.6115C56.2942 58.6115 57.1666 58.0475 57.6897 57.4307V58.3838H59.8508V53.0411H59.8513Z",
              fill: "currentcolor"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              d: "M66.3831 54.8395L69.98 48.6926H66.4636L64.7993 51.9673L63.1349 48.6926H59.6189L63.2158 54.8395V58.3562H66.3831V54.8395Z",
              fill: "currentcolor"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_2855_1334", children: /* @__PURE__ */ jsx("rect", { fill: "white", height: 80, width: 80 }) }) })
      ]
    }
  );
}
IconGafeIsoLogo.displayName = "GafeIsoLogo";
function IconHomeOutlined({ ...props }) {
  const icon2 = useIcon({ ...props });
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-home-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.9987 3.0135L13.332 7.1135V13.3268H10.6654V8.54016H5.33203V13.3268H2.66536V7.12016L7.9987 3.0135ZM7.9987 1.3335L1.33203 6.46016V14.6668H6.66536V9.88016H9.33203V14.6668H14.6654V6.46016L7.9987 1.3335Z",
          fill: "currentColor"
        }
      )
    }
  );
}
IconHomeOutlined.displayName = "HomeOutlined";
function IconHomeRepairFullColor(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-home-repair-full-color",
      ...icon2,
      viewBox: "0 0 36 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.2047 0.355469H12.0034L3.3125 9.18838V21.5334H33.328V10.6951L23.2047 0.355469Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18.0483 0.0239601L17.5117 0.560547L17.7099 0.75874L18.2465 0.222153L18.0483 0.0239601Z",
            fill: "#101820"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.9872 21.4194C24.9784 21.3084 24.9471 21.2003 24.8952 21.1018C24.8433 21.0033 24.7718 20.9164 24.6851 20.8464L13.6899 11.9531C13.3542 12.8134 12.7243 13.5268 11.9121 13.9662L22.0804 23.7716C22.2333 23.9193 22.4377 24.0016 22.6503 24.0008H22.6813C22.7918 23.9969 22.9005 23.9706 23.0006 23.9235C23.1006 23.8764 23.1901 23.8094 23.2635 23.7267L24.775 22.0357C24.8511 21.9533 24.9093 21.8559 24.9459 21.7498C24.9824 21.6437 24.9964 21.5312 24.9872 21.4194Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M8.52855 7.32437L10.3234 8.96583C10.413 9.04881 10.4664 9.16375 10.4719 9.28577C10.4774 9.40778 10.4347 9.52705 10.3529 9.61777L9.179 10.9015C9.09602 10.9911 8.98101 11.0445 8.85899 11.05C8.73697 11.0555 8.61776 11.0127 8.52704 10.9309L6.7322 9.28948C6.44701 10.0591 6.43822 10.9039 6.70739 11.6793C6.97657 12.4547 7.50689 13.1124 8.20763 13.5397C8.90837 13.9671 9.73595 14.1376 10.5486 14.0221C11.3612 13.9065 12.1084 13.5121 12.6622 12.9063C13.216 12.3005 13.542 11.521 13.5843 10.7013C13.6266 9.88167 13.3827 9.07279 12.8942 8.41318C12.4057 7.75358 11.7031 7.28428 10.9067 7.08565C10.1103 6.88702 9.26958 6.97141 8.52855 7.32437Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.8277 23.99H10.7967C10.6853 23.9862 10.576 23.9596 10.4753 23.9119C10.3746 23.8643 10.2847 23.7965 10.2112 23.7128L8.71069 22.0094C8.63732 21.9267 8.58138 21.83 8.5463 21.7252C8.51122 21.6203 8.4977 21.5095 8.50653 21.3993C8.51535 21.2891 8.54626 21.1818 8.59757 21.0839C8.64888 20.9859 8.71947 20.8994 8.80506 20.8294L20.4555 11.3027L22.1992 13.2353L11.4005 23.7546C11.2478 23.9052 11.0421 23.9897 10.8277 23.99Z",
            fill: "#2774AE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.8313 14.1607C24.9862 13.5815 23.9734 12.3892 21.5792 13.4375L20.1963 11.8565C21.7279 9.258 16.7227 7.84572 16.7227 7.84572C19.3708 6.65954 21.655 7.07145 23.7565 9.08456C25.6768 10.9196 25.8209 12.3969 25.9015 12.9915",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.7668 9.0792C24.2968 9.57307 24.7596 10.1343 25.1435 10.7485L34.4539 10.8012L24.5241 0.224609L12.5996 0.379464L19.2123 7.19307C20.8554 7.10016 22.356 7.72732 23.7668 9.0792Z",
            fill: "#B1B1B3"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.5896 15.4956C24.4522 15.3464 24.3788 15.1493 24.3851 14.9466C24.3915 14.7439 24.4773 14.5518 24.6238 14.4116L25.9834 13.1325L26.4047 12.7361C26.5539 12.5987 26.751 12.5253 26.9537 12.5316C27.1564 12.538 27.3485 12.6236 27.4888 12.7702C27.6264 12.9191 27.7001 13.1161 27.694 13.3188C27.6879 13.5215 27.6025 13.7137 27.4562 13.8541L25.6753 15.5297C25.5261 15.6675 25.3285 15.7412 25.1254 15.7349C24.9224 15.7285 24.7299 15.6426 24.5896 15.4956Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M14.0505 21.1777L13.2715 21.9365H20.1954L19.4072 21.1777H14.0505Z", fill: "#101820" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.7754 0H11.722L0.914062 11.1031H2.92728V21.9336H8.64648C8.53772 21.7777 8.48668 21.5888 8.50236 21.3994C8.50965 21.3226 8.52684 21.2472 8.55347 21.1748H3.68617V9.33774L12.2439 0.546637L18.3114 6.92355C17.7122 7.04799 17.1289 7.23913 16.5723 7.49342L15.6199 7.92082L16.625 8.2042C17.4117 8.42719 19.5565 9.26031 20.0211 10.4217C20.1759 10.8151 20.1311 11.2192 19.8741 11.6606L19.7346 11.8975L21.4815 13.8951L21.737 13.7836C23.3568 13.0713 24.0816 13.5358 24.2644 13.6953C24.3181 13.7348 24.3635 13.7845 24.3978 13.8417C24.4321 13.8989 24.4546 13.9623 24.4641 14.0283L24.3589 14.1289C24.1373 14.3377 24.0076 14.6259 23.9983 14.9301C23.9891 15.2344 24.1009 15.5299 24.3093 15.7518C24.5178 15.9733 24.8057 16.1029 25.1098 16.1122C25.4138 16.1215 25.709 16.0097 25.9307 15.8014L27.7131 14.1258C27.934 13.9229 28.0667 13.6416 28.0827 13.3421C28.0987 13.0426 27.9968 12.7487 27.7988 12.5234C27.6008 12.2981 27.3226 12.1592 27.0235 12.1366C26.7244 12.114 26.4283 12.2093 26.1986 12.4023C26.109 11.9497 25.9617 11.5105 25.7604 11.0953H32.9429V21.1764H24.9272C24.9573 21.251 24.9756 21.3299 24.9814 21.4102C24.9969 21.5958 24.9483 21.7811 24.8436 21.9352H33.7016V11.0953H35.3324L24.7754 0ZM21.6952 12.983L20.6623 11.8015C20.7907 11.546 20.8632 11.266 20.8749 10.9803C20.8867 10.6946 20.8373 10.4097 20.7303 10.1445C20.2766 9.01254 18.8287 8.24446 17.8313 7.8341C18.1959 7.72021 18.5701 7.64037 18.9494 7.59562C19.0377 7.58478 19.1245 7.57704 19.2112 7.57084C19.2948 7.57084 19.38 7.57084 19.4636 7.56155H19.4745C19.6435 7.55841 19.8125 7.56461 19.9808 7.58014C21.2197 7.69008 22.3781 8.27698 23.5025 9.35322C23.825 9.65828 24.1236 9.98753 24.3959 10.3381C24.4981 10.4713 24.5896 10.5998 24.6748 10.7268C24.712 10.7825 24.7475 10.8383 24.7816 10.894L24.797 10.9204C24.8326 10.9776 24.8668 11.0349 24.8977 11.0907C25.234 11.6685 25.445 12.3106 25.5172 12.9753V13.0233L25.0526 13.4677C24.9732 13.3365 24.8739 13.2185 24.7583 13.1177C24.4393 12.8375 23.4994 12.28 21.6952 12.983ZM26.6647 13.0078C26.7017 12.9727 26.7451 12.9454 26.7927 12.9273C26.8403 12.9092 26.8911 12.9008 26.942 12.9025C27.019 12.9045 27.0937 12.9295 27.1566 12.974C27.2194 13.0186 27.2675 13.0809 27.2949 13.1529C27.3223 13.2249 27.3277 13.3035 27.3104 13.3786C27.293 13.4536 27.2536 13.5219 27.1974 13.5746L25.4165 15.2501C25.3792 15.2852 25.3356 15.3126 25.2878 15.3307C25.24 15.3489 25.189 15.3575 25.1379 15.356C25.0868 15.3545 25.0365 15.3429 24.9898 15.3219C24.9432 15.301 24.9011 15.271 24.866 15.2338C24.8309 15.1966 24.8035 15.1529 24.7854 15.105C24.7672 15.0572 24.7586 15.0063 24.7601 14.9552C24.7616 14.9041 24.7732 14.8538 24.7941 14.8071C24.8151 14.7605 24.8451 14.7184 24.8823 14.6833L26.6647 13.0078ZM25.3313 10.3381C24.9556 9.77971 24.5188 9.26499 24.0289 8.80349C22.5438 7.38502 20.9643 6.72379 19.2499 6.81051L13.4905 0.758788H24.4502L33.567 10.3381H25.3313Z",
            fill: "#101820"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.6941 7.62129C12.1201 7.09335 11.401 6.74963 10.6297 6.63452C9.85842 6.5194 9.07024 6.6382 8.36713 6.97555L7.85763 7.21712L10.0691 9.23952C10.0773 9.24669 10.0838 9.2555 10.0883 9.26537C10.0929 9.27524 10.0953 9.28596 10.0954 9.29682C10.0963 9.30761 10.0948 9.31847 10.091 9.32864C10.0873 9.3388 10.0815 9.34803 10.0738 9.35566L8.89993 10.6394C8.89293 10.6474 8.88426 10.6538 8.87467 10.6584C8.86508 10.6629 8.85472 10.6654 8.84412 10.6657C8.83308 10.6668 8.82189 10.6653 8.81145 10.6616C8.80102 10.6578 8.79165 10.6519 8.78378 10.6441L6.57229 8.6232L6.3772 9.15125C6.13012 9.81761 6.06895 10.5386 6.20026 11.2371C6.33156 11.9355 6.65027 12.5851 7.12248 13.1163C7.59468 13.6474 8.20257 14.0401 8.88087 14.2523C9.55917 14.4646 10.2824 14.4883 10.9732 14.321C11.6639 14.1537 12.2962 13.8017 12.8022 13.3026C13.3082 12.8035 13.6689 12.1762 13.8457 11.4879C14.0225 10.7996 14.0087 10.0761 13.8058 9.39497C13.6029 8.71385 13.2187 8.10074 12.6941 7.62129ZM12.3843 12.6432C11.924 13.1469 11.3129 13.4879 10.6426 13.6154C9.97228 13.7429 9.27875 13.65 8.66567 13.3505C8.05258 13.051 7.55297 12.5611 7.2415 11.9541C6.93003 11.347 6.82352 10.6555 6.93782 9.98283L8.27427 11.2046C8.35564 11.2793 8.45087 11.3372 8.55466 11.375C8.65845 11.4128 8.76871 11.4297 8.87906 11.4249C8.9894 11.42 9.09767 11.3933 9.19771 11.3465C9.29774 11.2997 9.38763 11.2336 9.46206 11.152L10.6359 9.86668C10.7864 9.70218 10.8654 9.48464 10.8555 9.26192C10.8457 9.03919 10.7478 8.82949 10.5833 8.67895L9.2467 7.45714C9.90644 7.2831 10.6049 7.32732 11.2374 7.58317C11.8699 7.83902 12.4026 8.29276 12.7558 8.87652C13.1089 9.46028 13.2636 10.1427 13.1966 10.8217C13.1297 11.5006 12.8447 12.1397 12.3843 12.6432Z",
            fill: "#101820"
          }
        )
      ]
    }
  );
}
IconHomeRepairFullColor.displayName = "HomeRepairFullColor";
function IconLeadsOutlined({ ...props }) {
  const icon2 = useIcon({ ...props });
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-leads-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 14 14",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M9.66537 3.66683C9.66537 5.50778 8.17298 7.00016 6.33203 7.00016C4.49108 7.00016 2.9987 5.50778 2.9987 3.66683C2.9987 1.82588 4.49108 0.333496 6.33203 0.333496C8.17298 0.333496 9.66537 1.82588 9.66537 3.66683ZM8.33203 3.66683C8.33203 4.7714 7.4366 5.66683 6.33203 5.66683C5.22746 5.66683 4.33203 4.7714 4.33203 3.66683C4.33203 2.56226 5.22746 1.66683 6.33203 1.66683C7.4366 1.66683 8.33203 2.56226 8.33203 3.66683Z",
            fill: "currentColor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M1.83203 8.3335C1.0036 8.3335 0.332031 8.93045 0.332031 9.66683V13.6668H1.83203V10.0002C1.83203 9.81607 1.98127 9.66683 2.16536 9.66683H9.66537V8.3335H1.83203Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.6469 9.00016L13.6654 9.79035L10.363 13.6668L8.33203 12.091L9.15762 11.1219L10.1702 11.9075L12.6469 9.00016Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
IconLeadsOutlined.displayName = "LeadsOutlined";
function IconNotApplicable(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-not-applicable",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M12 3.81818C7.48131 3.81818 3.81818 7.48131 3.81818 12C3.81818 16.5187 7.48131 20.1818 12 20.1818C16.5187 20.1818 20.1818 16.5187 20.1818 12C20.1818 7.48131 16.5187 3.81818 12 3.81818ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M5.99996 19L16.5 4.00005L18.1384 5.14697L7.63843 20.147L5.99996 19Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        )
      ]
    }
  );
}
IconNotApplicable.displayName = "NotApplicable";
function IconOutlinedCamera(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-outlined-camera",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M14.1716 6L16.1716 8H20V18H4V8H7.82843L9.82843 6H14.1716ZM22 20V6H17L15 4H9L7 6H2V20H22ZM14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13ZM16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconOutlinedCamera.displayName = "OutlinedCamera";
function IconPendingReview(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-pending-review",
      ...icon2,
      viewBox: "0 0 40 41",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.0007 37.4329C29.2054 37.4329 36.6673 29.971 36.6673 20.7663C36.6673 11.5615 29.2054 4.09961 20.0007 4.09961C10.7959 4.09961 3.33398 11.5615 3.33398 20.7663C3.33398 29.971 10.7959 37.4329 20.0007 37.4329ZM22.5007 13.2663L24.5485 14.7002L20.7314 20.1517L28.1782 25.366L26.7436 27.4149L17.2531 20.7696L18.6805 18.7311L18.6762 18.7281L22.5007 13.2663Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconPendingReview.displayName = "PendingReview";
function IconPlus(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-plus",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("path", { d: "m13,2h-2v9H2v2h9v9h2v-9h9v-2h-9V2Z" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" })
      ] })
    }
  );
}
IconPlus.displayName = "Plus";
function IconQuestionMark(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-question-mark",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 19C12.8284 19 13.5 19.6716 13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19ZM12 2C15.3137 2 18 4.68629 18 8C18 10.1646 17.2474 11.2907 15.3259 12.9231C13.3986 14.5604 13 15.2969 13 17H11C11 14.526 11.787 13.3052 14.031 11.3989C15.5479 10.1102 16 9.43374 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8V9H6V8C6 4.68629 8.68629 2 12 2Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconQuestionMark.displayName = "QuestionMark";
function IconQuestionMarkOutline(props) {
  const icon2 = useIcon(props);
  const { fill } = icon2;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-question-mark-outline",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12.5 14.65H12.65V14.5C12.65 14.0868 12.6984 13.8113 12.8506 13.5423C13.0068 13.2664 13.2794 12.9842 13.7601 12.5759L13.663 12.4616L13.7601 12.5759C14.2441 12.1647 14.5948 11.8061 14.8223 11.4045C15.0522 10.9987 15.15 10.5603 15.15 10C15.15 8.2603 13.7397 6.85 12 6.85C10.2603 6.85 8.85 8.2603 8.85 10V10.5V10.65H9H10H10.15V10.5V10C10.15 8.97827 10.9783 8.15 12 8.15C13.0217 8.15 13.85 8.97827 13.85 10C13.85 10.3404 13.7968 10.5754 13.6632 10.8003C13.5256 11.0319 13.2964 11.264 12.9184 11.5851C12.3541 12.0645 11.9583 12.4695 11.7061 12.92C11.4514 13.375 11.35 13.8641 11.35 14.5V14.65H11.5H12.5ZM12.9 16.25C12.9 15.753 12.497 15.35 12 15.35C11.503 15.35 11.1 15.753 11.1 16.25C11.1 16.747 11.503 17.15 12 17.15C12.497 17.15 12.9 16.747 12.9 16.25Z",
            stroke: fill,
            strokeWidth: "0.3"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
            fillRule: "evenodd"
          }
        )
      ]
    }
  );
}
IconQuestionMarkOutline.displayName = "QuestionMarkOutline";
function IconReportsOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-reports-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 12 14",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M0.667969 0.333496H8.15862L11.3346 3.88671V13.6668H0.667969V0.333496ZM1.85019 1.54314V12.4572H10.1524V4.7264H7.30708V1.54314H1.85019ZM8.4893 2.49582L9.40186 3.51676H8.4893V2.49582ZM5.55729 10.9429V6.39534H6.73951V10.9429H5.55729ZM3.18692 10.9429V7.7596H4.36914V10.9429H3.18692ZM7.77951 10.9429V8.6691H8.96173V10.9429H7.77951Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconReportsOutlined.displayName = "ReportsOutlined";
function IconSendFilled(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-send-filled",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m14.41,22L22,2,2,9.59l7.35,2.83,7.82-5.59-5.59,7.82,2.83,7.35Z",
            fill: "currentcolor"
          }
        )
      ] })
    }
  );
}
IconSendFilled.displayName = "SendFilled";
function IconSendOutlined(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-send-outlined",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { fill: "none", height: "24", width: "24" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m21,2l-7.59,20-3.45-8.96h0s0,0,0,0L1,9.59,21,2Zm-14.4,7.6l4.08,1.57.82.32.32.82,1.57,4.08,4.15-10.95-10.95,4.15Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        )
      ] })
    }
  );
}
IconSendOutlined.displayName = "SendOutlined";
function IconShield(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-shield",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4.69606 3.65998L12 2L19.3039 3.65998C19.7107 3.75242 20 4.12134 20 4.54743V13.6263C20 15.45 19.1088 17.1531 17.6251 18.1647L12 22L6.37493 18.1647C4.89121 17.1531 4 15.45 4 13.6263V4.54743C4 4.12134 4.28936 3.75242 4.69606 3.65998ZM12.8889 10.1818V5.63636L8.44444 12H11.1111V16.5455L15.5556 10.1818H12.8889Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconShield.displayName = "Shield";
function IconShieldNotApplicable(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-shield-not-applicable",
      ...icon2,
      viewBox: "0 0 89 88",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M44.5 3.66699L14.3713 10.3623C12.6936 10.7351 11.5 12.223 11.5 13.9416V50.5596C11.5 57.9153 15.1762 64.7845 21.2966 68.8647L44.5 84.3337L67.7034 68.8647C73.8238 64.7845 77.5 57.9153 77.5 50.5596V13.9416C77.5 12.223 76.3065 10.7351 74.6286 10.3623L44.5 3.66699ZM44.5009 58.667C54.6261 58.667 62.8342 50.4589 62.8342 40.3337C62.8342 30.2084 54.6261 22.0003 44.5009 22.0003C34.3757 22.0003 26.1676 30.2084 26.1676 40.3337C26.1676 50.4589 34.3757 58.667 44.5009 58.667ZM44.5009 54.8409C52.513 54.8409 59.0081 48.3458 59.0081 40.3337C59.0081 37.7143 58.3139 35.257 57.0995 33.1359C57.0191 33.2578 56.9233 33.3724 56.8124 33.4769L36.6005 52.503C38.8736 53.9818 41.5869 54.8409 44.5009 54.8409ZM54.1899 30.6909C54.4098 30.4839 54.6658 30.339 54.9362 30.2557C52.2981 27.5247 48.5978 25.8264 44.5009 25.8264C36.4888 25.8264 29.9936 32.3215 29.9936 40.3337C29.9936 44.0453 31.3876 47.4315 33.6805 49.9971L54.1899 30.6909Z",
          fill: "currentcolor",
          fillRule: "evenodd"
        }
      )
    }
  );
}
IconShieldNotApplicable.displayName = "ShieldNotApplicable";
function IconShingleFilled(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-shingle-filled",
      ...icon2,
      viewBox: "0 0 40 40",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M34.8135 3.3335H5.18388L4.8238 9.39345H35.1736L34.8135 3.3335Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M35.3279 11.9906H4.66948L4.66305 12.0988L4.3094 18.0505H26.8986C27.2434 17.7752 27.6201 17.5206 28.0211 17.3135C29.1407 16.7354 30.6029 16.4717 31.9606 17.3871L33.1125 18.0505H35.688L35.3343 12.0988L35.3279 11.9906Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M29.1503 26.7076L30.6945 24.4195L33.9508 26.6314L36.0358 23.9029L36.1363 25.5945L36.2024 26.7076H29.1503Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.8918 34.499L27.3974 29.3047H36.3567L36.6654 34.499H23.8918Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M21.2638 29.3047L16.9353 34.499H3.33203L3.64067 29.3047H21.2638Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M25.2585 20.6476H4.15508L3.86113 25.5945L3.79499 26.7076H23.428L27.7164 21.5615L27.8241 21.2708C27.7822 21.258 27.7385 21.2462 27.6931 21.2357C27.6389 21.2491 27.5331 21.243 27.408 21.2358C27.2572 21.2271 27.0783 21.2168 26.9277 21.237C26.8752 21.244 26.8262 21.2548 26.783 21.2705C26.2207 21.4756 25.6564 21.2616 25.3753 20.8618C25.3279 20.7944 25.2889 20.7225 25.2585 20.6476Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M28.947 20.8851L28.5415 21.9803L18.0996 34.5108L21.3341 36.6668L30.3815 23.2616L31.1456 22.7836L32.1865 23.4907L31.7478 24.0647L33.7403 25.4181L36.6419 21.6209L34.6238 20.2501L34.1125 20.9192L33.1352 20.2958L33.7617 19.441L31.4448 18.1065C30.4726 17.4364 29.4122 17.5842 28.4691 18.0713C27.5369 18.5526 26.718 19.3638 26.1824 20.0378C26.0785 20.1685 26.0941 20.3076 26.1494 20.3862C26.2032 20.4628 26.3132 20.5127 26.4468 20.464C26.9262 20.2891 27.4465 20.2871 27.9151 20.3951C28.339 20.4928 28.7056 20.6772 28.947 20.8851Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.66305 12.0988L4.66948 11.9906H35.3279L35.3343 12.0988M4.66305 12.0988H35.3343M4.66305 12.0988L4.3094 18.0505H26.8986C27.2434 17.7752 27.6201 17.5206 28.0211 17.3135C29.1407 16.7354 30.6029 16.4717 31.9606 17.3871L33.1125 18.0505H35.688L35.3343 12.0988M36.1363 25.5945L36.0358 23.9029L33.9508 26.6314L30.6945 24.4195L29.1503 26.7076H36.2024L36.1363 25.5945ZM36.1363 25.5945H34.7431M3.86113 25.5945L4.15508 20.6476H25.2585C25.2889 20.7225 25.3279 20.7944 25.3753 20.8618C25.6564 21.2616 26.2207 21.4756 26.783 21.2705C26.8262 21.2548 26.8752 21.244 26.9277 21.237C27.0783 21.2168 27.2572 21.2271 27.408 21.2358C27.5331 21.243 27.6389 21.2491 27.6931 21.2357C27.7385 21.2462 27.7822 21.258 27.8241 21.2708L27.7164 21.5615L23.428 26.7076H3.79499L3.86113 25.5945ZM3.86113 25.5945H24.3555M29.9015 25.5945H32.4244M25.708 25.3804L24.6921 26.5995M5.18388 3.3335H34.8135L35.1736 9.39345H4.8238L5.18388 3.3335ZM27.3974 29.3047L23.8918 34.499H36.6654L36.3567 29.3047H27.3974ZM16.9353 34.499L21.2638 29.3047H3.64067L3.33203 34.499H16.9353ZM28.947 20.8851C28.7056 20.6772 28.339 20.4928 27.9151 20.3951C27.4465 20.2871 26.9262 20.2891 26.4468 20.464C26.3132 20.5127 26.2032 20.4628 26.1494 20.3862C26.0941 20.3076 26.0785 20.1685 26.1824 20.0378C26.718 19.3638 27.5369 18.5526 28.4691 18.0713C29.4122 17.5842 30.4726 17.4364 31.4448 18.1065L33.7617 19.441L33.1352 20.2958L34.1125 20.9192L34.6238 20.2501L36.6419 21.6209L33.7403 25.4181L31.7478 24.0647L32.1865 23.4907L31.1456 22.7836L30.3815 23.2616L21.3341 36.6668L18.0996 34.5108L28.5415 21.9803L28.947 20.8851Z",
            stroke: "currentcolor",
            strokeWidth: "0.107597"
          }
        )
      ]
    }
  );
}
IconShingleFilled.displayName = "ShingleFilled";
function IconSolarHouseFullColor(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-solar-house-full-color",
      ...icon2,
      viewBox: "0 0 38 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M24.3789 0.396484H12.1272L2.62012 10.0573V23.5632H35.4528V11.7052L24.3789 0.396484Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.779 11.748L12.7881 0.419014L25.8292 0.25L36.6849 11.8207L23.779 11.748Z",
            fill: "#B1B1B3"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M15.6772 12.2402H9.10938V23.2532H15.6772V12.2402Z", fill: "#D71920" }),
        /* @__PURE__ */ jsx("path", { d: "M32.2616 14.1914H23.6875V20.3942H32.2616V14.1914Z", fill: "#B1B1B3" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M37.6495 12.142L26.0991 0H11.8208L0 12.1454H2.19718V24H35.8597V12.142H37.6495ZM25.7442 0.831549L35.716 11.3104H23.7245L13.7527 0.831549H25.7442ZM35.04 23.1718H3.03375V10.2254L12.3955 0.606761L23.373 12.142H35.0349L35.04 23.1718Z",
            fill: "#101820"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23.2734 20.8083H32.6758V13.7773H23.2734V20.8083ZM31.8475 19.9802H28.4791V14.6055H31.8475V19.9802ZM24.1017 14.6055H27.651V19.9802H24.1017V14.6055Z",
            fill: "#101820"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M11.0995 17.9277H10.1699V18.8573H11.0995V17.9277Z", fill: "#101820" }),
        /* @__PURE__ */ jsx("path", { d: "M32.5596 9.88658H24.2931L17.0322 2.25391H25.297L32.5596 9.88658Z", fill: "white" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M33.5268 10.3111H24.1178L16.0693 1.8418H25.4767L33.5268 10.3111ZM24.4744 9.48292H31.5967L25.1217 2.67842H17.9995L24.4744 9.48292Z",
            fill: "#2774AE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20.0962 1.94673L19.4961 2.51758L26.7582 10.1515L27.3582 9.58065L20.0962 1.94673Z",
            fill: "#2774AE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M22.85 1.94678L22.25 2.51758L29.5121 10.1515L30.1121 9.5807L22.85 1.94678Z",
            fill: "#2774AE"
          }
        ),
        /* @__PURE__ */ jsx("path", { d: "M27.7091 4.38281H19.4443V5.21098H27.7091V4.38281Z", fill: "#2774AE" }),
        /* @__PURE__ */ jsx("path", { d: "M30.132 6.92969H21.8672V7.75786H30.132V6.92969Z", fill: "#2774AE" })
      ]
    }
  );
}
IconSolarHouseFullColor.displayName = "SolarHouseFullColor";
function IconSort(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-sort-outlined",
      ...icon2,
      fill: "none",
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M10.668 7.66663L11.668 6.66663L6.66797 1.66663L1.66797 6.66663L2.66797 7.66663L5.83464 4.49996V18.3333H7.5013V4.49996L10.668 7.66663Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M18.168 12.3333L19.168 13.3333L14.168 18.3333L9.16797 13.3333L10.168 12.3333L13.3346 15.5V1.66663H15.0013V15.5L18.168 12.3333Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
IconSort.displayName = "Sort";
function IconStar(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsx(
    "svg",
    {
      "data-testid": "gafe-icon-star",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 2L8.90897 8.58571L2 9.63571L7 14.7643L5.81793 22L12 18.5857L18.1821 22L17 14.7643L22 9.64286L15.091 8.58571L12 2Z",
          fill: "currentcolor"
        }
      )
    }
  );
}
IconStar.displayName = "Star";
function IconUserPlus(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-user-plus",
      ...icon2,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            clipRule: "evenodd",
            d: "M8.5 2C5.73858 2 3.5 4.23858 3.5 7C3.5 9.76142 5.73858 12 8.5 12C11.2614 12 13.5 9.76142 13.5 7C13.5 4.23858 11.2614 2 8.5 2ZM5.5 7C5.5 5.34315 6.84315 4 8.5 4C10.1569 4 11.5 5.34315 11.5 7C11.5 8.65685 10.1569 10 8.5 10C6.84315 10 5.5 8.65685 5.5 7Z",
            fill: "currentcolor",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M5 14C3.67392 14 2.40215 14.5268 1.46447 15.4645C0.526784 16.4021 0 17.6739 0 19V21C0 21.5523 0.447715 22 1 22C1.55228 22 2 21.5523 2 21V19C2 18.2044 2.31607 17.4413 2.87868 16.8787C3.44129 16.3161 4.20435 16 5 16H12C12.7956 16 13.5587 16.3161 14.1213 16.8787C14.6839 17.4413 15 18.2043 15 19V21C15 21.5523 15.4477 22 16 22C16.5523 22 17 21.5523 17 21V19C17 17.6739 16.4732 16.4021 15.5355 15.4645C14.5979 14.5268 13.3261 14 12 14H5Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20 7C20.5523 7 21 7.44772 21 8V10H23C23.5523 10 24 10.4477 24 11C24 11.5523 23.5523 12 23 12H21V14C21 14.5523 20.5523 15 20 15C19.4477 15 19 14.5523 19 14V12H17C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10H19V8C19 7.44772 19.4477 7 20 7Z",
            fill: "currentcolor"
          }
        )
      ]
    }
  );
}
IconUserPlus.displayName = "UserPlus";
function IconWalletFullColor(props) {
  const icon2 = useIcon(props);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      "data-testid": "gafe-icon-wallet-full-color",
      ...icon2,
      viewBox: "0 0 23 26",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.7108 10.9391L11.6807 10.5875H17.4537L20.2218 6.66147L12.1671 0.980472L11.0062 2.62637L10.9432 1.87732L6.70995 0.558594L5.7384 3.38116L5.51166 2.90188L1.57834 2.96215L1.5555 10.9391H0.84375V25.6488H21.8891V10.9391H11.7108Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.6445 9.24411C11.507 9.15531 11.4022 9.02394 11.3462 8.87005C11.2902 8.71616 11.2862 8.54818 11.3346 8.39175L10.9701 8.13776L11.2571 7.73884L11.6115 7.98709C11.8511 7.75032 12.1855 7.73023 12.5127 7.9383L12.5686 7.97418L12.2616 8.4061L12.2114 8.37453C12.1837 8.35204 12.1513 8.33591 12.1167 8.32728C12.082 8.31865 12.0459 8.31772 12.0109 8.32456C11.9758 8.3314 11.9427 8.34585 11.9139 8.36688C11.885 8.38791 11.8612 8.41501 11.844 8.44628C11.8243 8.47664 11.811 8.51073 11.805 8.54643C11.799 8.58213 11.8005 8.61868 11.8092 8.6538C11.818 8.68892 11.8339 8.72187 11.8559 8.7506C11.8779 8.77933 11.9057 8.80322 11.9373 8.8208C12.0406 8.89542 12.1511 8.90833 12.3492 8.73183C12.5121 8.56586 12.7246 8.45755 12.9547 8.42332L16.3598 3.59325L12.1984 0.638672L5.02344 10.8082L11.1667 10.9417L12.2931 9.346C12.1855 9.38737 12.0691 9.39973 11.9552 9.38185C11.8414 9.36397 11.7342 9.31647 11.6445 9.24411Z",
            fill: "#B1B1B3"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M14.1121 6.77237C13.5274 6.36002 12.8028 6.19685 12.0977 6.31875C11.3926 6.44066 10.7648 6.83765 10.3525 7.42241C9.94009 8.00716 9.77692 8.73177 9.89883 9.43683C10.0207 10.1419 10.4178 10.7696 11.0025 11.182C11.0571 11.2207 11.1145 11.2566 11.1704 11.2911H13.9457C14.3305 11.0598 14.6516 10.7362 14.8798 10.3496C15.108 9.96294 15.2363 9.52547 15.2528 9.0768C15.2694 8.62812 15.1737 8.18241 14.9745 7.78003C14.7754 7.37764 14.4789 7.0313 14.1121 6.77237ZM13.8783 10.189L13.5223 9.93789C13.3821 10.0587 13.2055 10.1291 13.0206 10.138C12.8357 10.1468 12.6532 10.0936 12.5021 9.98668L12.4433 9.9508L12.7432 9.52031L12.7933 9.54758C12.9368 9.62937 13.1478 9.68103 13.2985 9.46866C13.4119 9.30794 13.3688 9.13288 13.1822 9.00229C13.0545 8.91189 12.9168 8.89467 12.6643 9.10992C12.2854 9.43278 11.9711 9.47296 11.6425 9.2405C11.505 9.15169 11.4001 9.02033 11.3442 8.86643C11.2882 8.71254 11.2842 8.54457 11.3326 8.38813L10.9681 8.13988L11.2551 7.74097L11.6095 7.98921C11.8491 7.75245 12.1835 7.73236 12.5107 7.94043L12.5666 7.9763L12.2596 8.40822L12.2094 8.37665C12.1817 8.35417 12.1493 8.33804 12.1147 8.3294C12.08 8.32077 12.0439 8.31984 12.0088 8.32668C11.9738 8.33352 11.9407 8.34797 11.9119 8.369C11.883 8.39003 11.8592 8.41714 11.8419 8.4484C11.8222 8.47876 11.809 8.51285 11.803 8.54855C11.797 8.58425 11.7984 8.6208 11.8072 8.65592C11.8159 8.69105 11.8318 8.72399 11.8539 8.75272C11.8759 8.78145 11.9036 8.80535 11.9353 8.82292C12.0386 8.89754 12.1491 8.91046 12.3471 8.73396C12.7504 8.37378 13.109 8.32643 13.4749 8.59046C13.8409 8.85449 13.9471 9.20175 13.8008 9.55188L14.1538 9.80157L13.8783 10.189Z",
            fill: "#D71920"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M2.82588 10.5871H1.90897L1.92901 3.67206L4.39427 3.62901L4.6297 2.92157L1.22876 2.98041L1.20577 10.5943H0.488281V26H22.2369V10.5871H18.3108L21.198 6.49175L11.994 0L4.53203 10.5871H3.56916L6.67596 1.28285L9.57031 2.18544L10.0008 1.58132L6.23117 0.406093M12.1733 0.980076L20.2279 6.66107L17.4599 10.5871H5.39736L12.1733 0.980076ZM21.5439 25.2969H1.19568V11.2902H21.5381L21.5439 25.2969Z",
            fill: "#101820"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M23 15.877H15.1736C14.5428 15.8788 13.9384 16.1303 13.4924 16.5763C13.0463 17.0223 12.7949 17.6268 12.793 18.2575V18.3293C12.7949 18.9601 13.0463 19.5645 13.4924 20.0105C13.9384 20.4566 14.5428 20.708 15.1736 20.7099H23V15.877Z",
            fill: "#2774AE"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.3158 19.4461C15.953 19.4461 16.4696 18.9296 16.4696 18.2924C16.4696 17.6552 15.953 17.1387 15.3158 17.1387C14.6787 17.1387 14.1621 17.6552 14.1621 18.2924C14.1621 18.9296 14.6787 19.4461 15.3158 19.4461Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M15.3158 19.7977C15.0181 19.7977 14.727 19.7094 14.4795 19.544C14.2319 19.3786 14.039 19.1435 13.9251 18.8684C13.8112 18.5934 13.7814 18.2907 13.8395 17.9987C13.8976 17.7067 14.0408 17.4385 14.2513 17.228C14.4619 17.0175 14.7301 16.8741 15.0221 16.816C15.3141 16.758 15.6168 16.7878 15.8919 16.9017C16.167 17.0156 16.402 17.2086 16.5674 17.4561C16.7328 17.7036 16.8211 17.9947 16.8211 18.2924C16.8211 18.6916 16.6626 19.0745 16.3803 19.3568C16.098 19.6391 15.715 19.7977 15.3158 19.7977ZM15.3158 17.4902C15.1572 17.4902 15.0021 17.5373 14.8702 17.6254C14.7383 17.7136 14.6355 17.8388 14.5748 17.9854C14.5141 18.132 14.4981 18.2933 14.5291 18.4489C14.56 18.6045 14.6364 18.7474 14.7485 18.8596C14.8607 18.9718 15.0037 19.0482 15.1593 19.0791C15.3149 19.1101 15.4763 19.0942 15.6228 19.0335C15.7694 18.9728 15.8946 18.8699 15.9827 18.738C16.0709 18.6061 16.1179 18.451 16.1179 18.2924C16.1176 18.0798 16.033 17.8759 15.8827 17.7256C15.7323 17.5753 15.5284 17.4906 15.3158 17.4902Z",
            fill: "#101820"
          }
        )
      ]
    }
  );
}
IconWalletFullColor.displayName = "WalletFullColor";
class EnvironmentKeys {
}
__publicField(EnvironmentKeys, "KEY_PP_API", "PP_API");
class EnvironmentServiceMemory {
  constructor(memory = {}) {
    this.memory = memory;
  }
  get(key) {
    return Promise.resolve(get(this.memory, key));
  }
  set(key, value) {
    if (value === void 0) {
      delete this.memory[key];
    } else {
      set(this.memory, key, value);
    }
    return this.get(key);
  }
}
class EnvironmentServiceVite {
  constructor($env) {
    this.$env = $env;
  }
  get(key) {
    const $key = key.startsWith("VITE_") ? key : `VITE_${key}`;
    return Promise.resolve(this.$env[$key]);
  }
}
function createDefaultFeedbackService() {
  return new FeedbackServiceToast();
}
const FeedbackServiceContext = createContext(createDefaultFeedbackService());
const useFeedbackService = () => useContext(FeedbackServiceContext);
class HttpRequestBuilder {
  constructor() {
    __publicField(this, "$request");
    __publicField(this, "delete", this.method.bind(this, "delete", void 0));
    __publicField(this, "get", this.method.bind(this, "get", void 0));
    __publicField(this, "patch", this.method.bind(this, "patch"));
    __publicField(this, "post", this.method.bind(this, "post"));
    __publicField(this, "put", this.method.bind(this, "put"));
    this.$request = {
      method: "get",
      url: "localhost",
      headers: {}
    };
  }
  method(verb, body2) {
    this.$request.method = verb;
    this.$request.body = body2;
    if (body2 == null) {
      delete this.$request.body;
    }
    return this;
  }
  url(endpoint) {
    this.$request.url = endpoint;
    return this;
  }
  headers(headers) {
    this.$request.headers = headers;
    return this;
  }
  header(key, value) {
    return this.headers({ ...this.$request.headers, [key]: value });
  }
  auth(bearer) {
    return this.header("Authorization", `Bearer ${bearer}`);
  }
  contentType(type) {
    return this.header("Content-Type", type);
  }
  accept(type) {
    return this.header("Accept", type);
  }
  copy(other) {
    this.$request = cloneDeep(other);
    return this;
  }
  params(params) {
    this.$request.params = params;
    return this;
  }
  build() {
    return cloneDeep(this.$request);
  }
}
class HttpResponseBuilder {
  constructor() {
    __publicField(this, "$response");
    this.$response = {
      status: 200
    };
  }
  data(data) {
    this.$response.data = data;
    return this;
  }
  status(status2) {
    this.$response.status = status2;
    return this;
  }
  build() {
    return cloneDeep(this.$response);
  }
}
class HttpServiceAxios {
  constructor($axios) {
    this.$axios = $axios;
  }
  async request(request) {
    var _a, _b;
    try {
      const response = await this.$axios.request({
        url: request.url,
        method: request.method,
        headers: request.headers,
        data: request.body,
        params: request.params
      });
      return new HttpResponseBuilder().data(response.data).status(response.status).build();
    } catch (e) {
      const status2 = firstDefined(500, e.status);
      const data = e.status === 404 && ((_a = e.response) == null ? void 0 : _a.headers["content-type"]) === "text/html" ? { message: e.message } : { ...(_b = e.response) == null ? void 0 : _b.data };
      delete data.stack;
      return Promise.reject(new HttpResponseBuilder().data(data).status(status2).build());
    }
  }
}
function createDefaultHttpService() {
  return new HttpServiceAxios(axios.create());
}
class HttpServiceMemory {
  constructor() {
    __publicField(this, "$mapping", {});
  }
  static createEmptyMapping() {
    return {
      get: null,
      post: null,
      delete: null,
      put: null,
      patch: null
    };
  }
  mapping(request) {
    const endpoint = get(this.$mapping, request.url, null);
    if (endpoint == null) {
      return null;
    }
    const factory = get(endpoint, request.method, null);
    if (factory == null) {
      return null;
    }
    return factory;
  }
  set(method, endpoint, invoke) {
    this.$mapping[endpoint] = firstDefined(
      HttpServiceMemory.createEmptyMapping(),
      this.$mapping[endpoint]
    );
    this.$mapping[endpoint][method] = typeof invoke === "function" ? invoke : () => invoke;
  }
  async request(request) {
    const result = this.mapping(request);
    if (result == null) {
      const data = { message: "DNS Lookup Failed" };
      const notFound = new HttpResponseBuilder().status(404).data(data).build();
      return Promise.reject(notFound);
    }
    const errorThreshold = 400;
    const intermediate = await result(request);
    return Number(intermediate.status) < errorThreshold ? Promise.resolve(intermediate) : Promise.reject(intermediate);
  }
}
class HttpServicePartnerPortal {
  constructor($forward, $storage, $environment) {
    this.$forward = $forward;
    this.$storage = $storage;
    this.$environment = $environment;
  }
  async request(request) {
    let $request = new HttpRequestBuilder().copy(request).contentType("application/json; charset=utf-8").accept("application/json");
    const portalAccessToken = await this.$storage.get(StorageKeys.PATH_PORTAL_ACCESS_TOKEN);
    if (portalAccessToken && !request.headers.Authorization) {
      $request = $request.auth(portalAccessToken);
    }
    if (!request.url.match(/^https?:\/\//)) {
      let baseUrl = await this.$environment.get(EnvironmentKeys.KEY_PP_API);
      baseUrl = trim(trimEnd(firstDefined("", baseUrl), "/"));
      if (baseUrl) {
        const uri = trim(trimStart(request.url, "/"));
        const url = `${baseUrl}/${uri}`;
        $request = $request.url(url);
      }
    }
    return this.$forward.request($request.build());
  }
}
function createPartnerPortalHttpService(env) {
  const targets = [StorageServiceBrowser.session(), StorageServiceBrowser.local()];
  const storage = new StorageServiceComposite(targets);
  const environment = new EnvironmentServiceVite(env);
  return new HttpServicePartnerPortal(createDefaultHttpService(), storage, environment);
}
class StorageServiceMemory {
  /**
   * Initializes a new instance of this object.
   *
   * @param $memory -
   *        The block to write to.  If not set, then this will
   *        get an internal block.  You can use this to set the
   *        initial state of the memory block.
   */
  constructor($memory = {}) {
    this.$memory = $memory;
  }
  get(path, fallback) {
    const result = get(this.$memory, path, fallback);
    return Promise.resolve(result);
  }
  set(key, value) {
    if (value == null) {
      delete this.$memory[key];
    } else {
      this.$memory[key] = value;
    }
    return Promise.resolve();
  }
}
const ColorSchemas = Object.freeze([
  "dark",
  "deactivated",
  "destructive",
  "error",
  "error-light",
  "form-error",
  "form-field",
  "information",
  "information-light",
  "inherit",
  "item",
  "light",
  "monochromatic-dark",
  "monochromatic-light",
  "neutral",
  "neutral-dark",
  "neutral-light",
  "primary",
  "primary-dark",
  "success",
  "success-light",
  "transparent",
  "warning",
  "warning-light"
]);
class ColorsBuilder {
  constructor() {
    __publicField(this, "$colors");
    __publicField(this, "dark", this.add.bind(this, "dark"));
    __publicField(this, "deactivated", this.add.bind(this, "deactivated"));
    __publicField(this, "destructive", this.add.bind(this, "destructive"));
    __publicField(this, "error", this.add.bind(this, "error"));
    __publicField(this, "errorLight", this.add.bind(this, "error-light"));
    __publicField(this, "formError", this.add.bind(this, "form-error"));
    __publicField(this, "formField", this.add.bind(this, "form-field"));
    __publicField(this, "information", this.add.bind(this, "information"));
    __publicField(this, "informationLight", this.add.bind(this, "information-light"));
    __publicField(this, "inherit", this.add.bind(this, "inherit"));
    __publicField(this, "item", this.add.bind(this, "item"));
    __publicField(this, "light", this.add.bind(this, "light"));
    __publicField(this, "monochromaticDark", this.add.bind(this, "monochromatic-dark"));
    __publicField(this, "monochromaticLight", this.add.bind(this, "monochromatic-light"));
    __publicField(this, "neutral", this.add.bind(this, "neutral"));
    __publicField(this, "neutralDark", this.add.bind(this, "neutral-dark"));
    __publicField(this, "neutralDarkest", this.add.bind(this, "neutral-darkest"));
    __publicField(this, "neutralLight", this.add.bind(this, "neutral-light"));
    __publicField(this, "neutralLightest", this.add.bind(this, "neutral-lightest"));
    __publicField(this, "primary", this.add.bind(this, "primary"));
    __publicField(this, "primaryDark", this.add.bind(this, "primary-dark"));
    __publicField(this, "success", this.add.bind(this, "success"));
    __publicField(this, "successLight", this.add.bind(this, "success-light"));
    __publicField(this, "transparent", this.add.bind(this, "transparent"));
    __publicField(this, "warning", this.add.bind(this, "warning"));
    __publicField(this, "warningLight", this.add.bind(this, "warning-light"));
    this.$colors = [];
  }
  add(schema) {
    this.$colors.push(schema);
    return this;
  }
  all() {
    return this.dark().deactivated().destructive().error().errorLight().formError().formField().information().informationLight().inherit().item().light().monochromaticDark().monochromaticLight().neutral().neutralDark().neutralDarkest().neutralLight().neutralLightest().primary().primaryDark().success().successLight().transparent().warning().warningLight();
  }
  build() {
    return this.$colors.slice();
  }
}
const PaletteColors = Object.freeze([
  "blue",
  "green",
  "light-blue",
  "neutrals",
  "orange",
  "red",
  "yellow"
]);
const PaletteShades = Object.freeze([
  0,
  25,
  50,
  100,
  200,
  300,
  400,
  500,
  600,
  700,
  800
]);
class SizesBuilder {
  constructor() {
    __publicField(this, "$sizes");
    __publicField(this, "xs3", this.add.bind(this, "3xs"));
    __publicField(this, "xs2", this.add.bind(this, "2xs"));
    __publicField(this, "xs", this.add.bind(this, "xs"));
    __publicField(this, "sm", this.add.bind(this, "sm"));
    __publicField(this, "md", this.add.bind(this, "md"));
    __publicField(this, "lg", this.add.bind(this, "lg"));
    __publicField(this, "xl", this.add.bind(this, "xl"));
    __publicField(this, "xl2", this.add.bind(this, "2xl"));
    __publicField(this, "xl3", this.add.bind(this, "3xl"));
    __publicField(this, "auto", this.add.bind(this, "auto"));
    __publicField(this, "full", this.add.bind(this, "full"));
    __publicField(this, "none", this.add.bind(this, "none"));
    // Alias of none for now.
    __publicField(this, "void", this.none);
    this.$sizes = [];
  }
  add(size2) {
    this.$sizes.push(size2);
    return this;
  }
  fixed() {
    return this.xs3().xs2().xs().sm().md().lg().xl().xl2().xl3();
  }
  varied() {
    return this.auto().full();
  }
  all() {
    return this.fixed().varied().none();
  }
  build() {
    return this.$sizes.slice();
  }
}
var CharacterUniverse = /* @__PURE__ */ ((CharacterUniverse2) => {
  CharacterUniverse2["Dc"] = "dc";
  CharacterUniverse2["Marvel"] = "marvel";
  CharacterUniverse2["Pokemon"] = "pokemon";
  return CharacterUniverse2;
})(CharacterUniverse || {});
const CharacterUniverseDisplay = {
  [
    "dc"
    /* Dc */
  ]: "DC Comics",
  [
    "marvel"
    /* Marvel */
  ]: "Marvel Comics",
  [
    "pokemon"
    /* Pokemon */
  ]: "Pokémon"
};
class CharacterBuilder {
  constructor() {
    __publicField(this, "character");
    __publicField(this, "dc", this.universe.bind(
      this,
      "dc"
      /* Dc */
    ));
    __publicField(this, "marvel", this.universe.bind(
      this,
      "marvel"
      /* Marvel */
    ));
    __publicField(this, "pokemon", this.universe.bind(
      this,
      "pokemon"
      /* Pokemon */
    ));
    this.character = {
      id: "missing-no",
      name: "MissingNo",
      alias: "MissingNo",
      universe: "pokemon"
      /* Pokemon */
    };
  }
  static all() {
    return [
      new CharacterBuilder().batman().build(),
      new CharacterBuilder().superman().build(),
      new CharacterBuilder().wonderWoman().build(),
      new CharacterBuilder().flash().build(),
      new CharacterBuilder().spiderMan().build(),
      new CharacterBuilder().blackWidow().build(),
      new CharacterBuilder().captainAmerica().build(),
      new CharacterBuilder().wolverine().build()
    ];
  }
  id(id) {
    this.character.id = id;
    return this;
  }
  name(name) {
    this.character.name = name;
    return this;
  }
  description(description) {
    this.character.description = description;
    return this;
  }
  alias(alias) {
    this.character.alias = alias;
    return this;
  }
  universe(universe) {
    this.character.universe = universe;
    return this;
  }
  batman() {
    return this.dc().id("batman").name("Bruce Wayne").alias("Batman").description(
      "Batman is a superhero in American comic books published by DC Comics. The character was created by artist Bob Kane and writer Bill Finger, and debuted in the 27th issue of the comic book Detective Comics on March 30, 1939."
    );
  }
  superman() {
    return this.dc().id("superman").name("Clark Kent").alias("Superman").description(
      "Superman is a superhero who appears in American comic books published by DC Comics. The character was created by writer Jerry Siegel and artist Joe Shuster, and debuted in the comic book Action Comics #1."
    );
  }
  flash() {
    return this.dc().id("flash").name("Barry Allen").alias("The Flash");
  }
  wonderWoman() {
    return this.dc().id("wonder-woman").name("Diana Prince").alias("Wonder Woman");
  }
  spiderMan() {
    return this.marvel().id("spider-man").name("Peter Parker").alias("Spider Man");
  }
  wolverine() {
    return this.marvel().id("wolverine").name("James Logan Howlett").alias("Wolverine");
  }
  captainAmerica() {
    return this.marvel().id("captain-america").name("Steven Rogers").alias("Captain America");
  }
  blackWidow() {
    return this.marvel().id("black-widow").name("Natalia Alianovna Romanova").alias("Black Widow");
  }
  build() {
    return JSON.parse(JSON.stringify(this.character));
  }
}
const DateLocaleEnglishUnitedStates = enUS;
const DateLocaleSpanishSpain = es;
const DateLocaleUkrainian = uk;
var MonthIndex = /* @__PURE__ */ ((MonthIndex2) => {
  MonthIndex2[MonthIndex2["January"] = 0] = "January";
  MonthIndex2[MonthIndex2["February"] = 1] = "February";
  MonthIndex2[MonthIndex2["March"] = 2] = "March";
  MonthIndex2[MonthIndex2["April"] = 3] = "April";
  MonthIndex2[MonthIndex2["May"] = 4] = "May";
  MonthIndex2[MonthIndex2["June"] = 5] = "June";
  MonthIndex2[MonthIndex2["July"] = 6] = "July";
  MonthIndex2[MonthIndex2["August"] = 7] = "August";
  MonthIndex2[MonthIndex2["September"] = 8] = "September";
  MonthIndex2[MonthIndex2["October"] = 9] = "October";
  MonthIndex2[MonthIndex2["November"] = 10] = "November";
  MonthIndex2[MonthIndex2["December"] = 11] = "December";
  return MonthIndex2;
})(MonthIndex || {});
var MonthFormat = /* @__PURE__ */ ((MonthFormat2) => {
  MonthFormat2["Number"] = "M";
  MonthFormat2["Ordinal"] = "Mo";
  MonthFormat2["ZeroPadded"] = "MM";
  MonthFormat2["Short"] = "MMM";
  MonthFormat2["Full"] = "MMMM";
  MonthFormat2["Single"] = "MMMMM";
  return MonthFormat2;
})(MonthFormat || {});
function getMonthName(index, options = {}) {
  const { format: $format = "MMMM", locale } = options;
  return format(new Date(2e3, index, 1), $format, { locale });
}
function getMonthNames(options) {
  return range(0, 12).map((monthIndex) => getMonthName(monthIndex, options));
}
function tag(strings, ...expressions) {
  let [result] = strings;
  for (let i = 1, l = strings.length; i < l; i++) {
    result += expressions[i - 1];
    result += strings[i];
  }
  return result;
}
const html = tag;
const css = tag;
const js = tag;
const javascript = tag;
const md = tag;
const markdown = tag;
const ts = tag;
const typescript = tag;
const sh = tag;
const bash = tag;
const zsh = tag;
class DataSearchText {
  match(data, filter2) {
    const $filter = filter2.toUpperCase();
    return `${data}`.toUpperCase().includes($filter);
  }
}
class DataResolveMatchField {
  constructor($data, options) {
    __publicField(this, "$options");
    this.$data = $data;
    this.$options = {
      field: "id",
      delay: 0,
      ...options
    };
  }
  async resolve(ids) {
    const data = await this.$data;
    if (data instanceof Error) {
      return new Promise((_, reject) => setTimeout(() => reject(data), this.$options.delay));
    }
    const pairs = data.map((item2) => [get(item2, this.$options.field), item2]);
    const lookup = new Map(pairs);
    const values = ids.map((id) => lookup.get(id)).filter((value) => value != null).map((value) => value);
    return new Promise((resolve) => setTimeout(() => resolve(values), this.$options.delay));
  }
}
class DataResolveSelectField {
  constructor($field, options) {
    __publicField(this, "$options");
    this.$field = $field;
    this.$options = {
      delay: 0,
      ...options
    };
  }
  async resolve(data) {
    const field = await this.$field;
    const values = data.map((item2) => get(item2, field));
    return new Promise((resolve) => setTimeout(() => resolve(values), this.$options.delay));
  }
}
export {
  Alert,
  AnalyticsEventBuilder,
  AnalyticsPayloadBuilder,
  AnalyticsServiceContext,
  AnalyticsServiceGoogleTagManager,
  AnalyticsServiceInject,
  AnchorX,
  AnchorY,
  AsyncLoading,
  Backdrop,
  Balloon,
  Banner,
  BinaryComparators,
  Body,
  Box,
  Breadcrumbs,
  Bubble,
  Button,
  ButtonTextLarge,
  ButtonTextMedium,
  ButtonTextSmall,
  Caption,
  Caption1,
  Caption2,
  Card,
  CharacterBuilder,
  CharacterUniverse,
  CharacterUniverseDisplay,
  Checkbox,
  Chip,
  ChoiceAsync,
  ChoiceDropDown,
  ChoiceSelect,
  Collapsible,
  ColorSchemas,
  ColorsBuilder,
  ColumnHeader,
  ColumnLabel,
  ConfirmationModal,
  CornersBuilder,
  Countdown,
  CssPropertiesBuilder,
  DataBucket,
  DataFilterFields,
  DataMatchOptional,
  DataRequestBuilder,
  DataResolveIdentity,
  DataResolveMatchField,
  DataResolveSelectField,
  DataSearchFields,
  DataSearchText,
  DataSourceStatic,
  DataTabular,
  DateLocaleEnglishUnitedStates,
  DateLocaleSpanishSpain,
  DateLocaleUkrainian,
  Datepicker,
  DeviceValues,
  Divider,
  DonutChart,
  Dropdown,
  DropdownButton,
  DropdownWithSearch,
  DualityIndicator,
  EnvironmentKeys,
  EnvironmentServiceMemory,
  EnvironmentServiceVite,
  FeedbackBuilder,
  FeedbackContainer,
  FeedbackServiceContext,
  FeedbackServiceToast,
  FilterBinaryBuilder,
  FilterLogicBuilder,
  FullScreen,
  Grid,
  GridSpan,
  Grow,
  Hidden,
  HttpRequestBuilder,
  HttpResponseBuilder,
  HttpServiceAxios,
  HttpServiceMemory,
  HttpServicePartnerPortal,
  IconAddPerson,
  IconAdditionalActions,
  IconBulletedListFilled,
  IconCalendar,
  IconCalendarOutlined,
  IconCancelFilled,
  IconCancelOutlined,
  IconCartOutlined,
  IconCheckMark,
  IconCheckboxSelected,
  IconCheckboxUnselected,
  IconCheckmarkWithCircleOutlined,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconChevronUpDown,
  IconClock,
  IconEditFilled,
  IconEditOutlined,
  IconExclamationSignOutlined,
  IconExit,
  IconExternalLinkOutlined,
  IconFilledCircularCheckmark,
  IconFilledClock,
  IconFilledDelete,
  IconFilledExclamationSign,
  IconFilledRoundedCamera,
  IconFilledUpload,
  IconFilterFunnel,
  IconGafeIso,
  IconGafeIsoLogo,
  IconHomeOutlined,
  IconHomeRepairFullColor,
  IconInfoFilled,
  IconInfoOutlined,
  IconLeadsOutlined,
  IconNotApplicable,
  IconOutlinedCamera,
  IconPendingReview,
  IconPlus,
  IconQuestionMark,
  IconQuestionMarkOutline,
  IconRefresh,
  IconReportsOutlined,
  IconSearch,
  IconSendFilled,
  IconSendOutlined,
  IconShield,
  IconShieldNotApplicable,
  IconShingleFilled,
  IconSolarHouseFullColor,
  IconSort,
  IconSpinner,
  IconStar,
  IconUserPlus,
  IconWalletFullColor,
  IconWarning,
  IconWarningOutlined,
  IdentityBuilder,
  IdentityServiceContext,
  IdentityServiceStorage,
  Inherit,
  Label,
  Labeled,
  Legend,
  LinkButton,
  LinkButtonTextMedium,
  LinkButtonTextSmall,
  List,
  ListComponentModel,
  ListItem,
  LoadingSkeleton,
  LoadingSkeletonTheme,
  Lozenge,
  MediaSize,
  MediaType,
  MessageBox,
  MetadataBuilder,
  MetadataType,
  MobileDrawer,
  Modal,
  ModalAnimationLengthMs,
  MonthFormat,
  MonthIndex,
  NumericInput,
  OperatorBinary,
  OperatorLogic,
  PaletteColors,
  PaletteShades,
  Plane2d,
  Popover,
  Popup,
  ProgressSpinner,
  RadioButton,
  RectangleBuilder,
  Reminder,
  SectionTitle,
  SegmentedControl,
  SidebarPanel,
  SizesBuilder,
  Slider,
  SortCriterionBuilder,
  SortDirection,
  Stack,
  StorageKeys,
  StorageServiceBrowser,
  StorageServiceComposite,
  StorageServiceMemory,
  Subtitle,
  Subtitle1,
  Subtitle2,
  Subtitle3,
  Tab,
  TabLabel,
  Table,
  TableBody,
  TableCell,
  TableComponentModel,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TaskCard,
  TextInput,
  Textarea,
  Title,
  Title1,
  Title2,
  Title3,
  Title4,
  Title5,
  Title6,
  Toast,
  ToastContainer,
  Toggle,
  ToggleableCard,
  Tooltip,
  Typography,
  Wizard,
  WizardPage,
  asData,
  asError,
  bash,
  castFunction,
  colors,
  createDefaultAnalyticsService,
  createDefaultFeedbackService,
  createDefaultHttpService,
  createDefaultIdentityService,
  createError,
  createPartnerPortalHttpService,
  css,
  firstDefined,
  firstTruthy,
  getMonthName,
  getMonthNames,
  html,
  isBinaryFilter,
  isCorners,
  isCornersHorizontal,
  isCornersVertical,
  isDataErrored,
  isDataLoaded,
  isDataLoading,
  isDeviceMap,
  isLogicFilter,
  isPoint,
  isRectangle,
  javascript,
  js,
  mapToString,
  markdown,
  md,
  omitDataAttributes,
  pick,
  pickDataAttributes,
  sh,
  sleep,
  tag,
  ts,
  typescript,
  useAmbassadorState,
  useAnalyticsService,
  useAsyncState,
  useDeviceDetection,
  useDeviceValue,
  useFeedbackService,
  useIdentity,
  useIdentityService,
  useToday,
  uuid,
  zsh
};
//# sourceMappingURL=index.js.map
